<template>
  <div class="templateBigScreen1">
    <div class="largeScreenContent">
      <!--标题-->
      <div class="screenTitle">{{ pageData.baseInfo.projectName }}</div>
      <!--时间-->
      <div class="timeBoxTemplateBigScreen1">{{ nowTime }}</div>
      <!--操作-->
      <div class="operatorBox">
        <img v-show="screenFlag" alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/backIcon.png" @click="exitFullscreenClick" />
        <img v-show="!screenFlag" alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/screenIcon.png" @click="enterScreenClick" />
        <img v-show="!screenFlag" alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/editIcon.png" @click="selectSetDialog = true" />
      </div>
      <!--天气-->
      <div class="weatherBoxTemplateBigScreen1">
        <img v-show="currentWeatherObj.weather === '晴'" alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/weather1.png" style="width: 16px; height: 16px" />
        <img
          v-show="currentWeatherObj.weather === '阴' || currentWeatherObj.weather === '多云'"
          alt=""
          src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/weather2.png"
          style="width: 16px; height: 16px"
        />
        <img
          v-show="currentWeatherObj.weather && currentWeatherObj.weather.includes('雨')"
          alt=""
          src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/weather3.png"
          style="width: 16px; height: 16px"
        />
        <img
          v-show="currentWeatherObj.weather && currentWeatherObj.weather.includes('雪')"
          alt=""
          src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/weather4.png"
          style="width: 16px; height: 16px"
        />
        {{ currentWeatherObj.weather }} {{ currentWeatherObj.temperature }}℃ 湿度{{ currentWeatherObj.humidity }}% {{ currentWeatherObj.province }}省{{ currentWeatherObj.city }}
        <!--        东经 {{Number(pageData.baseInfo.longitude).toFixed(2)}}，北纬{{ Number(pageData.baseInfo.latitude).toFixed(2) }}-->
      </div>
      <!--左边数据展示-->
      <div class="leftBoxTemplateBigScreen1">
        <div class="leftItem leftItem1" v-loading="loadingBaseInfo">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/title1.png" />
            <p class="itemTitleRight">电压等级：{{ pageData.baseInfo.voltageLevel }}kV</p>
          </div>
          <div class="leftItemCont">
            <div class="leftItemContTop">
              <div class="leftItemContTopItem">
                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item1.png" />
                <p class="name">变压器数量</p>
                <p class="val">
                  {{ pageData.baseInfo.transformerNum }}
                  <span class="unit">台</span>
                </p>
              </div>
              <div class="leftItemContTopItem">
                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item2.png" />
                <p class="name">变压器容量</p>
                <p class="val">
                  {{ pageData.baseInfo.transformerCapacity }}
                  <span class="unit">KVA</span>
                </p>
              </div>
              <div class="leftItemContTopItem">
                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item3.png" />
                <div class="name">
                  <p class="name">收费方式</p>
                </div>
                <p class="val" style="font-size: 20px">
                  {{ pageData.baseInfo.chargingMethod == 1 ? "按容收费" : "按需收费" }}
                </p>
              </div>
            </div>
            <div class="leftItemContBottom">
              <div class="leftItemContBottomItem">
                <p class="val">
                  {{ pageData.baseInfo.photovoltaicCapacity }}
                  <span class="unit">KW</span>
                </p>
                <p class="name">光伏容量</p>
              </div>
              <div class="leftItemContBottomItem">
                <p class="val">
                  {{ pageData.baseInfo.energyStorageCapacity }}
                  <span class="unit">KW</span>
                </p>
                <p class="name">储能容量</p>
              </div>
              <div class="leftItemContBottomItem">
                <p class="val">{{ pageData.baseInfo.dcPile }} <span class="unit">KW</span></p>
                <p class="name">直流充电桩</p>
              </div>
              <div class="leftItemContBottomItem">
                <p class="val">{{ pageData.baseInfo.acPile }} <span class="unit">KW</span></p>
                <p class="name">交流充电桩</p>
              </div>
            </div>
          </div>
        </div>
        <div class="leftItem leftItem2" v-loading="loadingElectricAnalysis">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/title2.png" />
          </div>
          <div class="leftItemCont">
            <div class="leftItemContTop">
              <div class="leftItemContTopItem">
                <p class="name">年用电量</p>
                <p class="val">{{ pageData.electricAnalysis.yearElectric }}<span class="unit">KWH</span></p>
              </div>
              <div class="leftItemContTopItem">
                <p class="name">月用电量</p>
                <p class="val">{{ pageData.electricAnalysis.monthElectric }}<span class="unit">KWH</span></p>
              </div>
              <div class="leftItemContTopItem">
                <p class="name">日用电量</p>
                <p class="val">{{ pageData.electricAnalysis.dayElectric }}<span class="unit">KWH</span></p>
              </div>
              <div class="leftItemContTopItem">
                <p class="name">当月需量</p>
                <p class="val">{{ pageData.electricAnalysis.monthRequiredAmount }}<span class="unit">KW</span></p>
              </div>
            </div>
            <div class="echartsBox">
              <div class="leftEchartsBox">
                <div class="circleChartRef1" style="width: 195px; height: 100px"></div>
                <div class="labelBox">
                  <p>
                    <span class="name">电网月供电:</span>
                    <span class="val">
                      {{ pageData.electricAnalysis.monthElectricGrid }}KWH(
                      {{
                        pageData.electricAnalysis.monthElectricGrid + pageData.electricAnalysis.monthNewEnergyConsumption > 0
                          ? ((pageData.electricAnalysis.monthElectricGrid / (pageData.electricAnalysis.monthElectricGrid + pageData.electricAnalysis.monthNewEnergyConsumption)) * 100).toFixed(2)
                          : "0.00"
                      }}% )
                    </span>
                  </p>
                  <p>
                    <span class="name">新能源月消纳:</span>
                    <span class="val">
                      {{ pageData.electricAnalysis.monthNewEnergyConsumption }}KWH(
                      {{
                        pageData.electricAnalysis.monthElectricGrid + pageData.electricAnalysis.monthNewEnergyConsumption > 0
                          ? ((pageData.electricAnalysis.monthNewEnergyConsumption / (pageData.electricAnalysis.monthElectricGrid + pageData.electricAnalysis.monthNewEnergyConsumption)) * 100).toFixed(
                              2
                            )
                          : "0.00"
                      }}% )
                    </span>
                  </p>
                </div>
              </div>
              <div class="rightEchartsBox">
                <div class="circleChartRef2" style="width: 195px; height: 100px"></div>
                <div class="labelBox">
                  <p>
                    <span class="name">电网年供电:</span>
                    <span class="val">
                      {{ pageData.electricAnalysis.yearElectricGrid }}KWH(
                      {{
                        pageData.electricAnalysis.yearElectricGrid + pageData.electricAnalysis.yearNewEnergyConsumption > 0
                          ? ((pageData.electricAnalysis.yearElectricGrid / (pageData.electricAnalysis.yearElectricGrid + pageData.electricAnalysis.yearNewEnergyConsumption)) * 100).toFixed(2)
                          : "0.00"
                      }}% )
                    </span>
                  </p>
                  <p>
                    <span class="name">新能源年消纳:</span>
                    <span class="val">
                      {{ pageData.electricAnalysis.yearNewEnergyConsumption }}KWH(
                      {{
                        pageData.electricAnalysis.yearElectricGrid + pageData.electricAnalysis.yearNewEnergyConsumption > 0
                          ? ((pageData.electricAnalysis.yearNewEnergyConsumption / (pageData.electricAnalysis.yearElectricGrid + pageData.electricAnalysis.yearNewEnergyConsumption)) * 100).toFixed(2)
                          : "0.00"
                      }}% )
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="leftItem leftItem3" v-loading="loadingNewEnergy">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/title3.png" />
          </div>
          <div class="leftItemCont">
            <div class="leftItemContItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item5.png" />
              <div class="leftItemContItemRight">
                <div class="val">{{ pageData.newEnergy.totalNewEnergyGeneratingCapacity }}<span class="unit">KW·h</span></div>
                <div class="name">新能源发电量</div>
              </div>
            </div>
            <div class="leftItemContItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item6.png" />
              <div class="leftItemContItemRight">
                <div class="val">{{ pageData.newEnergy.newEnergyEffectiveHours }}<span class="unit">h</span></div>
                <div class="name">新能源年有效小时数</div>
              </div>
            </div>
            <div class="leftItemContItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item7.png" />
              <div class="leftItemContItemRight">
                <div class="val">{{ pageData.newEnergy.selfUseEnergy }}<span class="unit">KW·h</span></div>
                <div class="name">新能源自用电量</div>
              </div>
            </div>
            <div class="leftItemContItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item8.png" />
              <div class="leftItemContItemRight">
                <div class="val">{{ pageData.newEnergy.internetEnergy }}<span class="unit">KW·h</span></div>
                <div class="name">新能源上网电量</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--中间数据展示-->
      <div class="centerBoxTemplateBigScreen1" v-loading="loadingMiddleInfo">
        <!--中间上边数据展示-->
        <div class="centerTopBox">
          <div class="centerTopItem">
            <div class="tit">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item9.png" />
              <p class="name">累计节约电量</p>
            </div>
            <div class="valBox">
              <count-up :end-val="pageData.middleInfo.totalSavingAmount" :options="{ useGrouping: true }" :start-val="countStart1" class="val">
                <template #suffix>
                  <span style="font-size: 12px; letter-spacing: 0">kwh·h</span>
                </template>
              </count-up>
            </div>
          </div>
          <div class="centerTopItem">
            <div class="tit">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item11.png" />
              <p class="name">累计系统收益</p>
            </div>
            <div class="valBox">
              <count-up :end-val="pageData.middleInfo.totalSystemRevenue" :options="{ useGrouping: true }" :start-val="countStart2" class="val">
                <template #suffix>
                  <span style="font-size: 12px; letter-spacing: 0">元</span>
                </template>
              </count-up>
            </div>
          </div>
          <div class="centerTopItem">
            <div class="tit">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item10.png" />
              <p class="name">总用电量</p>
            </div>
            <div class="valBox">
              <count-up :end-val="pageData.middleInfo.totalElectric" :options="{ useGrouping: true }" :start-val="countStart3" class="val">
                <template #suffix>
                  <span style="font-size: 12px; letter-spacing: 0">KW·h</span>
                </template>
              </count-up>
            </div>
          </div>
        </div>
        <!--中间数据展示-->
        <div class="centerBox">
          <!--光伏数据-->
          <div class="centerBox1-1 centerBigBox">
            <div class="tit">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/icon1.png" />
              <p class="name">光伏</p>
            </div>
            <div class="centerBigBoxCont">
              <p>日发电量：{{ pageData.middleInfo.dayPhotovoltaicPowerGeneration }}kW·h</p>
              <p>日收益：{{ pageData.middleInfo.dayPhotovoltaicIncome }}元</p>
            </div>
          </div>
          <!--光伏发电功率-->
          <div class="centerBox1-2 centerSmallBox">发电功率:{{ pageData.middleInfo.photovoltaicGeneratedPower }}kW</div>
          <!--市电数据-->
          <div class="centerBox2-1 centerBigBox">
            <div class="tit">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/icon1.png" />
              <p class="name">市电</p>
            </div>
            <div style="display: flex; justify-content: space-between; align-items: center">
              <div class="centerBigBoxCont">
                <p>上网电量：{{ pageData.middleInfo.internetElectricity }}kW·h</p>
                <p>下网电量：{{ pageData.middleInfo.offInternetElectricity }}W·h</p>
              </div>
              <!--              <div style="display: flex;flex-direction: column;align-items: center">-->
              <!--                <el-progress :percentage="20" :stroke-width="8" color="#20F7C3"-->
              <!--                             type="circle"/>-->
              <!--                <p style="font-weight: 400;font-size: 14px;color: #FFFFFF;">10kV Trans</p>-->
              <!--              </div>-->
            </div>
          </div>
          <!--市电上网功率-->
          <div class="centerBox2-2 centerSmallBox">上网功率:{{ pageData.middleInfo.internetPower }}kW</div>
          <!--市电下网功率-->
          <div class="centerBox2-3 centerSmallBox">下网功率:{{ pageData.middleInfo.offInternetPower }}kW</div>
          <!--储能数据-->
          <div class="centerBox3-1 centerBigBox">
            <div class="tit">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/icon1.png" />
              <p class="name">储能</p>
            </div>
            <div class="centerBigBoxCont">
              <p>储能SOC：{{ pageData.middleInfo.soc }}%</p>
            </div>
          </div>
          <!--储能充电-->
          <div class="centerBox3-2 centerSmallBox">充电功率:{{ pageData.middleInfo.energyStorageChargingPower }}kW</div>
          <!--储能放电-->
          <div class="centerBox3-3 centerSmallBox">放电功率:{{ pageData.middleInfo.energyStorageDisChargingPower }}kW</div>
          <!--充电桩数据-->
          <div class="centerBox4-1 centerBigBox">
            <div class="tit">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/icon1.png" />
              <p class="name">充电桩</p>
            </div>
            <div class="centerBigBoxCont">
              <p>日充电量：{{ pageData.middleInfo.dayChargingCapacityOfChargingPile }}kW·h</p>
              <p>日充电收益：{{ pageData.middleInfo.dayChargingIncomeOfChargingPile }}元</p>
            </div>
          </div>
          <!--充电桩功率-->
          <div class="centerBox4-2 centerSmallBox">充电功率:{{ pageData.middleInfo.chargingPilePower }}kW</div>
          <!--负荷数据-->
          <div class="centerBox5-1 centerBigBox">
            <div class="tit">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/icon1.png" />
              <p class="name">负荷</p>
            </div>
            <div class="centerBigBoxCont">
              <p>日用电量：{{ pageData.middleInfo.dayElectric }}MW·h</p>
            </div>
          </div>
          <!--用电负荷-->
          <div class="centerBox5-2 centerSmallBox">用电负荷:{{ pageData.middleInfo.electricityLoad }}kW</div>
          <!--新能源占比-->
          <div class="centerProportionBox">
            <p class="val">
              <count-up :end-val="pageData.middleInfo.newEnergyRate || 0" :options="{ useGrouping: true }" :start-val="countStart4" class="val">
                <template #suffix>
                  <span>%</span>
                </template>
              </count-up>
            </p>
            <p class="name">新能源占比</p>
          </div>
        </div>
        <!--中间下边数据展示-->
        <div class="centerBottomBox">
          <div class="centerBottomBox1">
            <div class="centerBottomBoxItem">
              <div class="tit">
                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/icon2.png" />
                <p class="name">峰谷套利</p>
              </div>
              <div class="centerBottomBoxItemCont">
                <p>当月节约电费：{{ pageData.middleInfo.monthSavingElectricFee }}元</p>
                <p>累计节约电费：{{ pageData.middleInfo.totalSavingElectricFee }}元</p>
              </div>
            </div>
            <div class="centerBottomBoxItem">
              <div class="tit">
                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/icon2.png" />
                <p class="name">需量管理</p>
              </div>
              <div class="centerBottomBoxItemCont">
                <p>当月降低需量：{{ pageData.middleInfo.monthDownElectricDemand }}KW</p>
                <p>当月节约电费：{{ pageData.middleInfo.monthDownElectricDemandFee }}元</p>
                <p>累计节约电费：{{ pageData.middleInfo.totalSavingElectricDemandFee }}元</p>
              </div>
            </div>
            <div class="centerBottomBoxItem">
              <div class="tit">
                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/icon2.png" />
                <p class="name">新能源消纳</p>
              </div>
              <div class="centerBottomBoxItemCont">
                <p>当月消纳电费：{{ pageData.middleInfo.monthNewEnergyFee }}MW·h</p>
                <p>累计节约电费：{{ pageData.middleInfo.totalNewEnergyFee }}元</p>
              </div>
            </div>
            <div class="centerBottomBoxItem">
              <div class="tit">
                <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/icon2.png" />
                <p class="name">综合用电成本对比</p>
              </div>
              <div class="centerBottomBoxItemCont">
                <p>投入前：{{ pageData.middleInfo.beforeInvestmentCost }}元/kW·h</p>
                <p>投入后：{{ pageData.middleInfo.afterInvestmentCost }}元/kW·h</p>
              </div>
            </div>
          </div>
          <div class="centerBottomBox2">
            <div class="itemTitle">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/title7.png" />
            </div>
            <div class="centerBottomBoxCont">
              <div class="lineChartRef2"></div>
            </div>
          </div>
        </div>
      </div>
      <!--右边数据展示-->
      <div class="rightBoxTemplateBigScreen1">
        <div class="rightItem rightItem1" v-loading="loadingOperatingPowerChar">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/title4.png" />
            <p class="itemTitleRight">运行天数：{{ pageData.middleInfo.totalRunDay }}天</p>
          </div>
          <div class="rightItemCont">
            <div class="lineChartRef1 chartBox"></div>
          </div>
        </div>
        <div class="rightItem rightItem2" v-loading="loadingLast7DayFeeChar">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/title5.png" />
          </div>
          <div class="rightItemCont">
            <div class="barChartRef1 chartBox"></div>
          </div>
        </div>
        <div class="rightItem rightItem3" v-loading="loadingNewEnergySocialBenefits">
          <div class="itemTitle">
            <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/title6.png" />
          </div>
          <div class="rightItemCont">
            <div class="rightItemContItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item5.png" />
              <div class="rightItemContItemRight">
                <div class="val">
                  {{ pageData.newEnergySocialBenefits && pageData.newEnergySocialBenefits.reduceCarbonEmissions ? pageData.newEnergySocialBenefits.reduceCarbonEmissions : ""
                  }}<span class="unit">t</span>
                </div>
                <div class="name">减少碳排放</div>
              </div>
            </div>
            <div class="rightItemContItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item6.png" />
              <div class="rightItemContItemRight">
                <div class="val">
                  {{ pageData.newEnergySocialBenefits && pageData.newEnergySocialBenefits.savingStandardCoal ? pageData.newEnergySocialBenefits.savingStandardCoal : "" }}<span class="unit">t</span>
                </div>
                <div class="name">节约标准煤</div>
              </div>
            </div>
            <div class="rightItemContItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item7.png" />
              <div class="rightItemContItemRight">
                <div class="val">
                  {{ pageData.newEnergySocialBenefits && pageData.newEnergySocialBenefits.eqTreesPlanted ? pageData.newEnergySocialBenefits.eqTreesPlanted : "" }}<span class="unit">颗</span>
                </div>
                <div class="name">等效植树数</div>
              </div>
            </div>
            <div class="rightItemContItem">
              <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/item8.png" />
              <div class="rightItemContItemRight">
                <div class="val">
                  {{ pageData.newEnergySocialBenefits && pageData.newEnergySocialBenefits.eqGreenCertificate ? pageData.newEnergySocialBenefits.eqGreenCertificate : "" }}<span class="unit">张</span>
                </div>
                <div class="name">等效绿证书</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--选择配置哪个模块的弹窗-->
    <el-dialog v-model="selectSetDialog" class="selectSetDialog" title="配置" width="60%">
      <div class="listBox">
        <div class="listItem" @click="selectSetSubmit(1)">
          <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/setBgc1.png" />
        </div>
        <div class="listItem" @click="selectSetSubmit(2)">
          <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/setBgc2.png" />
        </div>
        <div class="listItem" @click="selectSetSubmit(3)">
          <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/setBgc3.png" />
        </div>
        <div class="listItem" @click="selectSetSubmit(4)">
          <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/setBgc4.png" />
        </div>
        <div class="listItem" @click="selectSetSubmit(5)">
          <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/setBgc5.png" />
        </div>
        <!--        <div class="listItem" @click="selectSetSubmit(6)">-->
        <!--          <img alt=""-->
        <!--               src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/setBgc6.png">-->
        <!--        </div>-->
        <div class="listItem" @click="selectSetSubmit(7)">
          <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/setBgc7.png" />
        </div>
        <div class="listItem" @click="selectSetSubmit(6)">
          <img alt="" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/setBgc8.png" />
        </div>
      </div>
    </el-dialog>
    <!--基本信息配置-->
    <el-dialog v-model="setDialog1" class="setDialog1" title="基本信息配置" width="50%">
      <el-form ref="roomSetFormRef" :model="basicInfoFormData" :rules="basicInfoFormRules" class="demo-ruleForm" status-icon>
        <el-form-item label="项目名称" name="name" prop="projectName">
          <el-input v-model="basicInfoFormData.projectName" placeholder="请输入项目名称" />
        </el-form-item>
        <el-form-item label="电压等级" name="voltageLevel" prop="voltageLevel">
          <el-input v-model="basicInfoFormData.voltageLevel" placeholder="请输入电压等级"></el-input>
        </el-form-item>
        <el-form-item label="变压器数量" name="transformerNum" prop="transformerNum">
          <el-input-number v-model="basicInfoFormData.transformerNum" :max="99999999" :min="0" placeholder="请输入变压器数量" />
        </el-form-item>
        <el-form-item label="变压器容量" name="transformerCapacity" prop="transformerCapacity">
          <el-input-number v-model="basicInfoFormData.transformerCapacity" :max="99999999" :min="0" placeholder="请输入变压器容量" />
        </el-form-item>
        <el-form-item label="收费方式" name="chargingMethod" prop="chargingMethod">
          <el-select v-model="basicInfoFormData.chargingMethod" placeholder="请选择收费方式">
            <el-option label="按容收费" value="1"></el-option>
            <el-option label="按需收费" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="光伏容量" name="photovoltaicCapacity" prop="photovoltaicCapacity">
          <el-input-number v-model="basicInfoFormData.photovoltaicCapacity" :max="99999999" :min="0" placeholder="请输入光伏容量" />
        </el-form-item>
        <el-form-item label="储能容量" name="energyStorageCapacity" prop="energyStorageCapacity">
          <el-input-number v-model="basicInfoFormData.energyStorageCapacity" :max="99999999" :min="0" placeholder="请输入储能容量" />
        </el-form-item>
        <el-form-item label="直流充电桩" name="dcPile" prop="dcPile">
          <el-input-number v-model="basicInfoFormData.dcPile" :max="99999999" :min="0" placeholder="请输入直流充电桩" />
        </el-form-item>
        <el-form-item label="交流充电桩" name="acPile" prop="acPile">
          <el-input-number v-model="basicInfoFormData.acPile" :max="99999999" :min="0" placeholder="请输入交流充电桩" />
        </el-form-item>
        <el-form-item label="电站地址" name="address" prop="address">
          <el-input v-model="basicInfoFormData.address" placeholder="请输入电站地址" />
        </el-form-item>
        <div style="width: 100%">
          <div style="display: flex">
            <el-form-item label="地图选点" prop="">
              <el-input id="suggestId" v-model="mapName" autocomplete="off" placeholder="请输入地址" style="width: 200px" type="text"></el-input>
            </el-form-item>
            <el-form-item label="经度" prop="longitude">
              <el-input v-model="basicInfoFormData.longitude" placeholder="请输入经度" type="number" />
            </el-form-item>
            <el-form-item label="纬度" prop="latitude">
              <el-input v-model="basicInfoFormData.latitude" placeholder="请输入纬度" type="number" />
            </el-form-item>
          </div>
          <div id="allmap" ref="allmap"></div>
        </div>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button class="resetButton" @click="setDialog1 = false">取消</el-button>
          <el-button type="primary" @click="setDialogSubmit1">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <!--用电情况分析配置-->
    <el-dialog v-model="setDialog2" class="setDialog1" title="用电情况分析配置" width="80%">
      <div class="eleContBox">
        <!--用电量配置-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>用电量</p>
              <p @click="deviceSelectClick2(0)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 0"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[0]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in eleFormData.electricity.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="eleFormData.electricity.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('electricity', index, '+')">+</p>
              <p :class="eleFormData.electricity.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('electricity', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="eleFormData.electricity.formula.substring(2*index-1,2*index)==='×'||eleFormData.electricity.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('electricity',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="eleFormData.electricity.formula.substring(2*index-1,2*index)==='÷'||eleFormData.electricity.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('electricity',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('electricity', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(1, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 1 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('electricity')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--新能源消纳配置-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>新能源消纳</p>
              <p @click="deviceSelectClick2(1)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 1"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[1]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in eleFormData.absorb.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="eleFormData.absorb.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('absorb', index, '+')">+</p>
              <p :class="eleFormData.absorb.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('absorb', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="eleFormData.absorb.formula.substring(2*index-1,2*index)==='×'||eleFormData.absorb.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('absorb',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="eleFormData.absorb.formula.substring(2*index-1,2*index)==='÷'||eleFormData.absorb.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('absorb',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('absorb', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(2, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 2 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('absorb')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--当月需量-->
        <div style="display: flex; align-items: center; margin: 20px 10px">
          <span style="margin-right: 10px">当月需量</span>
          <el-select
            ref="elSelectTable"
            v-model="eleFormData.demandQuantityJson.dictKey"
            :disabled="true"
            :popper-append-to-body="false"
            :suffix-icon="Plus"
            class="timeSelect"
            multiple
            placeholder="请选择设备指标"
            popper-class="timeSelectPopper"
            style="width: 500px"
            @click="deviceDictSelectClick(3)"
          >
            <el-option v-for="(item, index) in deviceDictList[2]" :key="index" :label="item.deviceName + '-' + item.dictName" :value="item.dictKey"></el-option>
          </el-select>
          <DeviceDictSelect v-if="deviceDictSelectIdx === 3" :deviceDictVisible="deviceDictVisible" @checkDeviceDictListFun="checkDeviceDictListFun" @deviceDictVisibleFun="deviceDictVisibleFun" />
        </div>
        <!--电网供电-->
        <div style="display: flex; align-items: center; margin: 20px 10px">
          <span style="margin-right: 10px">电网供电</span>
          <el-select
            ref="elSelectTable"
            v-model="eleFormData.powerSupplyJson.dictKey"
            :disabled="true"
            :popper-append-to-body="false"
            :suffix-icon="Plus"
            class="timeSelect"
            multiple
            placeholder="请选择设备指标"
            popper-class="timeSelectPopper"
            style="width: 500px"
            @click="deviceDictSelectClick(4)"
          >
            <el-option v-for="(item, index) in deviceDictList[3]" :key="index" :label="item.deviceName + '-' + item.dictName" :value="item.dictKey"></el-option>
          </el-select>
          <DeviceDictSelect v-if="deviceDictSelectIdx === 4" :deviceDictVisible="deviceDictVisible" @checkDeviceDictListFun="checkDeviceDictListFun" @deviceDictVisibleFun="deviceDictVisibleFun" />
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button class="resetButton" @click="setDialog2 = false">取消</el-button>
          <el-button type="primary" @click="setDialogSubmit2">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <!--新能源情况分析配置-->
    <el-dialog v-model="setDialog3" class="setDialog1" title="新能源情况分析配置" width="80%">
      <div class="eleContBox">
        <!--发电量配置-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>新能源发电量</p>
              <p @click="deviceSelectClick2(0)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 0"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[0]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in newEnergyPowerGeneration.electricity.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="newEnergyPowerGeneration.electricity.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('electricity', index, '+')">+</p>
              <p :class="newEnergyPowerGeneration.electricity.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('electricity', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="newEnergyPowerGeneration.electricity.formula.substring(2*index-1,2*index)==='×'||newEnergyPowerGeneration.electricity.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('electricity',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="newEnergyPowerGeneration.electricity.formula.substring(2*index-1,2*index)==='÷'||newEnergyPowerGeneration.electricity.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('electricity',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('electricity', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(1, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 1 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('electricity')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--自用电量配置-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>新能源自用电量</p>
              <p @click="deviceSelectClick2(1)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 1"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[1]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in newEnergyPowerGeneration.selfElectricity.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="newEnergyPowerGeneration.selfElectricity.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('selfElectricity', index, '+')">+</p>
              <p :class="newEnergyPowerGeneration.selfElectricity.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('selfElectricity', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="newEnergyPowerGeneration.selfElectricity.formula.substring(2*index-1,2*index)==='×'||newEnergyPowerGeneration.selfElectricity.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('selfElectricity',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="newEnergyPowerGeneration.selfElectricity.formula.substring(2*index-1,2*index)==='÷'||newEnergyPowerGeneration.selfElectricity.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('selfElectricity',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('selfElectricity', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(2, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 2 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('selfElectricity')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--上网电量配置-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>新能源上网电量</p>
              <p @click="deviceSelectClick2(2)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 2"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[2]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in newEnergyPowerGeneration.internetElectricity.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p
                :class="newEnergyPowerGeneration.internetElectricity.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''"
                @click="symbolClick('internetElectricity', index, '+')"
              >
                +
              </p>
              <p
                :class="newEnergyPowerGeneration.internetElectricity.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''"
                @click="symbolClick('internetElectricity', index, '-')"
              >
                -
              </p>
              <!--              <p-->
              <!--                  :class="newEnergyPowerGeneration.internetElectricity.formula.substring(2*index-1,2*index)==='×'||newEnergyPowerGeneration.internetElectricity.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('internetElectricity',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="newEnergyPowerGeneration.internetElectricity.formula.substring(2*index-1,2*index)==='÷'||newEnergyPowerGeneration.internetElectricity.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('internetElectricity',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('internetElectricity', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(3, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 3 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('internetElectricity')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button class="resetButton" @click="setDialog3 = false">取消</el-button>
          <el-button type="primary" @click="setDialogSubmit3">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <!--运行功率曲线配置-->
    <el-dialog v-model="setDialog4" class="setDialog1" title="运行功率曲线配置" width="80%">
      <div class="eleContBox">
        <!--负荷运行功率配置-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>负荷运行功率</p>
              <p @click="deviceSelectClick2(0)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 0"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[0]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in operatingPower.load.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="operatingPower.load.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('load', index, '+')">+</p>
              <p :class="operatingPower.load.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('load', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="operatingPower.load.formula.substring(2*index-1,2*index)==='×'||operatingPower.load.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('load',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="operatingPower.load.formula.substring(2*index-1,2*index)==='÷'||operatingPower.load.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('load',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('load', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(1, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 1 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('load')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--储能运行功率配置-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>储能运行功率</p>
              <p @click="deviceSelectClick2(1)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 1"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[1]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in operatingPower.energyStorage.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="operatingPower.energyStorage.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('energyStorage', index, '+')">+</p>
              <p :class="operatingPower.energyStorage.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('energyStorage', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="operatingPower.energyStorage.formula.substring(2*index-1,2*index)==='×'||operatingPower.energyStorage.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('energyStorage',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="operatingPower.energyStorage.formula.substring(2*index-1,2*index)==='÷'||operatingPower.energyStorage.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('energyStorage',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('energyStorage', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(2, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 2 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('energyStorage')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--市电运行功率配置-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>市电运行功率</p>
              <p @click="deviceSelectClick2(2)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 2"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[2]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in operatingPower.municipalElectricity.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="operatingPower.municipalElectricity.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('municipalElectricity', index, '+')">+</p>
              <p :class="operatingPower.municipalElectricity.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('municipalElectricity', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="operatingPower.municipalElectricity.formula.substring(2*index-1,2*index)==='×'||operatingPower.municipalElectricity.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('municipalElectricity',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="operatingPower.municipalElectricity.formula.substring(2*index-1,2*index)==='÷'||operatingPower.municipalElectricity.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('municipalElectricity',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('municipalElectricity', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(3, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 3 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('municipalElectricity')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--新能源运行功率配置-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>新能源运行功率</p>
              <p @click="deviceSelectClick2(3)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 3"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[3]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in operatingPower.newEnergy.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="operatingPower.newEnergy.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('newEnergy', index, '+')">+</p>
              <p :class="operatingPower.newEnergy.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('newEnergy', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="operatingPower.newEnergy.formula.substring(2*index-1,2*index)==='×'||operatingPower.newEnergy.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('newEnergy',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="operatingPower.newEnergy.formula.substring(2*index-1,2*index)==='÷'||operatingPower.newEnergy.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('newEnergy',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('newEnergy', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(4, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 4 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('newEnergy')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button class="resetButton" @click="setDialog4 = false">取消</el-button>
          <el-button type="primary" @click="setDialogSubmit4">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <!--近7日费用对比-->
    <el-dialog v-model="setDialog5" class="setDialog1" title="近7日费用对比配置" width="80%">
      <div class="eleContBox">
        <!--        <span>设备：</span>-->
        <!--        <el-select ref="elSelectTable" v-model="costFormData.equipmentIdJson" :disabled="true"-->
        <!--                   :popper-append-to-body="false" :suffix-icon="Plus" class="timeSelect"-->
        <!--                   multiple popper-class="timeSelectPopper" style="width: 500px"-->
        <!--                   @click="deviceSelectClick">-->
        <!--          <el-option v-for="(item,index) in equipmentList" :key="index"-->
        <!--                     :label="item.name"-->
        <!--                     :value="item.id"></el-option>-->
        <!--        </el-select>-->
        <!--        <DeviceCheck :checkDeviceList="equipmentList" :deviceVisible="deviceVisible" :isMultiple="true"-->
        <!--                     @checkDeviceListFun="checkDeviceListFun" @deviceVisibleFun="deviceVisibleFun"/>-->

        <!--费用对比优化前-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>费用优化前</p>
              <p @click="deviceSelectClick2(0)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 0"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[0]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in costFormData.optimizationBefore.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="costFormData.optimizationBefore.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('optimizationBefore', index, '+')">+</p>
              <p :class="costFormData.optimizationBefore.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('optimizationBefore', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="costFormData.optimizationBefore.formula.substring(2*index-1,2*index)==='×'||costFormData.optimizationBefore.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('optimizationBefore',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="costFormData.optimizationBefore.formula.substring(2*index-1,2*index)==='÷'||costFormData.optimizationBefore.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('optimizationBefore',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('optimizationBefore', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(1, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 1 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('optimizationBefore')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--费用对比优化后-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>费用优化后</p>
              <p @click="deviceSelectClick2(1)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 1"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[1]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in costFormData.optimizationAfter.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="costFormData.optimizationAfter.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('optimizationAfter', index, '+')">+</p>
              <p :class="costFormData.optimizationAfter.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('optimizationAfter', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="costFormData.optimizationAfter.formula.substring(2*index-1,2*index)==='×'||costFormData.optimizationAfter.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('optimizationAfter',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="costFormData.optimizationAfter.formula.substring(2*index-1,2*index)==='÷'||costFormData.optimizationAfter.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('optimizationAfter',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('optimizationAfter', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(2, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 2 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('optimizationAfter')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button class="resetButton" @click="setDialog5 = false">取消</el-button>
          <el-button type="primary" @click="setDialogSubmit5">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <!--中间板块配置-->
    <el-dialog v-model="setDialog6" class="setDialog1" title="中间板块配置" width="80%">
      <div class="eleContBox">
        <p class="tit">新能源占比：<span style="font-size: 12px; color: #a4a4a4">（占比为A值/B值）</span></p>
        <!--新能源占比A值配置-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>新能源占比A值</p>
              <p @click="deviceSelectClick2(0)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 0"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[0]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.newEnergyProportionA.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="centerFormData.newEnergyProportionA.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('newEnergyProportionA', index, '+')">+</p>
              <p :class="centerFormData.newEnergyProportionA.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('newEnergyProportionA', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="centerFormData.newEnergyProportionA.formula.substring(2*index-1,2*index)==='×'||centerFormData.newEnergyProportionA.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('newEnergyProportionA',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.newEnergyProportionA.formula.substring(2*index-1,2*index)==='÷'||centerFormData.newEnergyProportionA.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('newEnergyProportionA',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('newEnergyProportionA', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(1, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 1 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('newEnergyProportionA')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--新能源占比B值配置-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>新能源占比B值</p>
              <p @click="deviceSelectClick2(1)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 1"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[1]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.newEnergyProportionB.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="centerFormData.newEnergyProportionB.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('newEnergyProportionB', index, '+')">+</p>
              <p :class="centerFormData.newEnergyProportionB.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('newEnergyProportionB', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="centerFormData.newEnergyProportionB.formula.substring(2*index-1,2*index)==='×'||centerFormData.newEnergyProportionB.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('newEnergyProportionB',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.newEnergyProportionB.formula.substring(2*index-1,2*index)==='÷'||centerFormData.newEnergyProportionB.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('newEnergyProportionB',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('newEnergyProportionB', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(2, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 2 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('newEnergyProportionB')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <p class="tit">光伏：</p>
        <!--光伏发电功率-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>光伏发电功率</p>
              <p @click="deviceSelectClick2(2)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 2"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[2]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.photovoltaicPowerGenerationCapacity.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p
                :class="centerFormData.photovoltaicPowerGenerationCapacity.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''"
                @click="symbolClick('photovoltaicPowerGenerationCapacity', index, '+')"
              >
                +
              </p>
              <p
                :class="centerFormData.photovoltaicPowerGenerationCapacity.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''"
                @click="symbolClick('photovoltaicPowerGenerationCapacity', index, '-')"
              >
                -
              </p>
              <!--              <p-->
              <!--                  :class="centerFormData.photovoltaicPowerGenerationCapacity.formula.substring(2*index-1,2*index)==='×'||centerFormData.photovoltaicPowerGenerationCapacity.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('photovoltaicPowerGenerationCapacity',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.photovoltaicPowerGenerationCapacity.formula.substring(2*index-1,2*index)==='÷'||centerFormData.photovoltaicPowerGenerationCapacity.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('photovoltaicPowerGenerationCapacity',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('photovoltaicPowerGenerationCapacity', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(3, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 3 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('photovoltaicPowerGenerationCapacity')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--光伏日发电量-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>光伏发电量</p>
              <p @click="deviceSelectClick2(3)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 3"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[3]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.photovoltaicPowerGeneration.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p
                :class="centerFormData.photovoltaicPowerGeneration.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''"
                @click="symbolClick('photovoltaicPowerGeneration', index, '+')"
              >
                +
              </p>
              <p
                :class="centerFormData.photovoltaicPowerGeneration.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''"
                @click="symbolClick('photovoltaicPowerGeneration', index, '-')"
              >
                -
              </p>
              <!--              <p-->
              <!--                  :class="centerFormData.photovoltaicPowerGeneration.formula.substring(2*index-1,2*index)==='×'||centerFormData.photovoltaicPowerGeneration.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('photovoltaicPowerGeneration',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.photovoltaicPowerGeneration.formula.substring(2*index-1,2*index)==='÷'||centerFormData.photovoltaicPowerGeneration.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('photovoltaicPowerGeneration',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('photovoltaicPowerGeneration', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(4, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 4 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('photovoltaicPowerGeneration')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--光伏日收益-->
        <div v-if="false" class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>光伏日收益</p>
              <p @click="deviceSelectClick2(4)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 4"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[4]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.photovoltaicRevenue.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="centerFormData.photovoltaicRevenue.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('photovoltaicRevenue', index, '+')">+</p>
              <p :class="centerFormData.photovoltaicRevenue.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('photovoltaicRevenue', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="centerFormData.photovoltaicRevenue.formula.substring(2*index-1,2*index)==='×'||centerFormData.photovoltaicRevenue.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('photovoltaicRevenue',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.photovoltaicRevenue.formula.substring(2*index-1,2*index)==='÷'||centerFormData.photovoltaicRevenue.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('photovoltaicRevenue',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('photovoltaicRevenue', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(5, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 5 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('photovoltaicRevenue')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--光伏收益-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>光伏收益</p>
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.photovoltaicRevenue.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="centerFormData.photovoltaicRevenue.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('photovoltaicRevenue', index, '+')">+</p>
              <p :class="centerFormData.photovoltaicRevenue.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('photovoltaicRevenue', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="centerFormData.photovoltaicRevenue.formula.substring(2*index-1,2*index)==='×'||centerFormData.photovoltaicRevenue.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('photovoltaicRevenue',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.photovoltaicRevenue.formula.substring(2*index-1,2*index)==='÷'||centerFormData.photovoltaicRevenue.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('photovoltaicRevenue',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('photovoltaicRevenue', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-tree-select
                  v-model="item.deviceId"
                  :data="photovoltaicRevenueTreeData"
                  :props="{
                    label: 'name',
                    children: 'subList',
                    disabled: (data) => data.nodeType == 2,
                  }"
                  :render-after-expand="false"
                  node-key="id"
                  style="width: 160px"
                />
              </div>
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('photovoltaicRevenue')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <p class="tit">市电</p>
        <!--上网功率-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>上网功率</p>
              <p @click="deviceSelectClick2(5)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 5"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[5]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.internetPower.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="centerFormData.internetPower.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('internetPower', index, '+')">+</p>
              <p :class="centerFormData.internetPower.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('internetPower', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="centerFormData.internetPower.formula.substring(2*index-1,2*index)==='×'||centerFormData.internetPower.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('internetPower',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.internetPower.formula.substring(2*index-1,2*index)==='÷'||centerFormData.internetPower.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('internetPower',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('internetPower', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(12, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 12 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('internetPower')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--下网功率-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>下网功率</p>
              <p @click="deviceSelectClick2(6)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 6"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[6]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.downInternetPower.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="centerFormData.downInternetPower.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('downInternetPower', index, '+')">+</p>
              <p :class="centerFormData.downInternetPower.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('downInternetPower', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="centerFormData.downInternetPower.formula.substring(2*index-1,2*index)==='×'||centerFormData.downInternetPower.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('downInternetPower',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.downInternetPower.formula.substring(2*index-1,2*index)==='÷'||centerFormData.downInternetPower.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('downInternetPower',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('downInternetPower', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(13, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 13 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('downInternetPower')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--上网电量-->
        <div style="margin-top: 20px; margin-left: 20px">
          <span style="margin-right: 16px">上网电量</span>
          <el-select
            ref="elSelectTable"
            v-model="centerFormData.internetPowerConsumption.dictKey"
            :disabled="true"
            :popper-append-to-body="false"
            :suffix-icon="Plus"
            class="timeSelect"
            multiple
            placeholder="请选择设备指标"
            popper-class="timeSelectPopper"
            style="width: 500px"
            @click="deviceDictSelectClick(14)"
          >
            <el-option v-for="(item, index) in deviceDictList[13]" :key="index" :label="item.deviceName + '-' + item.dictName" :value="item.dictKey"></el-option>
          </el-select>
          <DeviceDictSelect v-if="deviceDictSelectIdx === 14" :deviceDictVisible="deviceDictVisible" @checkDeviceDictListFun="checkDeviceDictListFun" @deviceDictVisibleFun="deviceDictVisibleFun" />
        </div>
        <!--下网电量-->
        <div style="margin-top: 20px; margin-left: 20px">
          <span style="margin-right: 16px">下网电量</span>
          <el-select
            ref="elSelectTable"
            v-model="centerFormData.downInternetPowerConsumption.dictKey"
            :disabled="true"
            :popper-append-to-body="false"
            :suffix-icon="Plus"
            class="timeSelect"
            multiple
            placeholder="请选择设备指标"
            popper-class="timeSelectPopper"
            style="width: 500px"
            @click="deviceDictSelectClick(15)"
          >
            <el-option v-for="(item, index) in deviceDictList[14]" :key="index" :label="item.deviceName + '-' + item.dictName" :value="item.dictKey"></el-option>
          </el-select>
          <DeviceDictSelect v-if="deviceDictSelectIdx === 15" :deviceDictVisible="deviceDictVisible" @checkDeviceDictListFun="checkDeviceDictListFun" @deviceDictVisibleFun="deviceDictVisibleFun" />
        </div>
        <p class="tit">储能：</p>
        <!--储能充电功率-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>储能充电功率</p>
              <p @click="deviceSelectClick2(7)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 7"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[7]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.energyStorageChargingPower.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p
                :class="centerFormData.energyStorageChargingPower.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''"
                @click="symbolClick('energyStorageChargingPower', index, '+')"
              >
                +
              </p>
              <p
                :class="centerFormData.energyStorageChargingPower.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''"
                @click="symbolClick('energyStorageChargingPower', index, '-')"
              >
                -
              </p>
              <!--              <p-->
              <!--                  :class="centerFormData.energyStorageChargingPower.formula.substring(2*index-1,2*index)==='×'||centerFormData.energyStorageChargingPower.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('energyStorageChargingPower',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.energyStorageChargingPower.formula.substring(2*index-1,2*index)==='÷'||centerFormData.energyStorageChargingPower.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('energyStorageChargingPower',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('energyStorageChargingPower', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(6, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 6 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('energyStorageChargingPower')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--储能放电功率-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>储能放电功率</p>
              <p @click="deviceSelectClick2(8)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 8"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[8]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.energyStorageDischargePower.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p
                :class="centerFormData.energyStorageDischargePower.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''"
                @click="symbolClick('energyStorageDischargePower', index, '+')"
              >
                +
              </p>
              <p
                :class="centerFormData.energyStorageDischargePower.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''"
                @click="symbolClick('energyStorageDischargePower', index, '-')"
              >
                -
              </p>
              <!--              <p-->
              <!--                  :class="centerFormData.energyStorageDischargePower.formula.substring(2*index-1,2*index)==='×'||centerFormData.energyStorageDischargePower.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('energyStorageDischargePower',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.energyStorageDischargePower.formula.substring(2*index-1,2*index)==='÷'||centerFormData.energyStorageDischargePower.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('energyStorageDischargePower',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('energyStorageDischargePower', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(7, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 7 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('energyStorageDischargePower')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--储能收益-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>储能收益</p>
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.energyRevenue.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="centerFormData.energyRevenue.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('energyRevenue', index, '+')">+</p>
              <p :class="centerFormData.energyRevenue.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('energyRevenue', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="centerFormData.energyRevenue.formula.substring(2*index-1,2*index)==='×'||centerFormData.energyRevenue.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('energyRevenue',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.energyRevenue.formula.substring(2*index-1,2*index)==='÷'||centerFormData.energyRevenue.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('energyRevenue',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('energyRevenue', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-tree-select
                  v-model="item.deviceId"
                  :data="energyRevenueTreeData"
                  :props="{
                    label: 'name',
                    children: 'subList',
                    disabled: (data) => data.nodeType == 2,
                  }"
                  :render-after-expand="false"
                  node-key="id"
                  style="width: 160px"
                />
              </div>
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('energyRevenue')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--储能SOC-->
        <div style="margin-top: 20px; margin-left: 20px">
          <span style="margin-right: 16px">储能SOC</span>
          <!--          <el-select ref="elSelectTable" v-model="centerFormData.energyStorageSOC.equipmentIdJson" :disabled="true"-->
          <!--                     :popper-append-to-body="false" :suffix-icon="Plus" class="timeSelect"-->
          <!--                     multiple popper-class="timeSelectPopper" style="width: 500px"-->
          <!--                     @click="deviceSelectClick">-->
          <!--            <el-option v-for="(item,index) in equipmentList" :key="index"-->
          <!--                       :label="item.name"-->
          <!--                       :value="item.id"></el-option>-->
          <!--          </el-select>-->
          <!--          <DeviceCheck :checkDeviceList="equipmentList" :deviceVisible="deviceVisible" :isMultiple="true"-->
          <!--                       @checkDeviceListFun="checkDeviceListFun" @deviceVisibleFun="deviceVisibleFun"/>-->
          <el-select
            ref="elSelectTable"
            v-model="centerFormData.energyStorageSOC.dictKey"
            :disabled="true"
            :popper-append-to-body="false"
            :suffix-icon="Plus"
            class="timeSelect"
            multiple
            placeholder="请选择设备指标"
            popper-class="timeSelectPopper"
            style="width: 500px"
            @click="deviceDictSelectClick(17)"
          >
            <el-option v-for="(item, index) in deviceDictList[16]" :key="index" :label="item.deviceName + '-' + item.dictName" :value="item.dictKey"></el-option>
          </el-select>
          <DeviceDictSelect v-if="deviceDictSelectIdx === 17" :deviceDictVisible="deviceDictVisible" @checkDeviceDictListFun="checkDeviceDictListFun" @deviceDictVisibleFun="deviceDictVisibleFun" />
        </div>
        <p class="tit">充电桩：</p>
        <!--充电桩功率-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>充电桩功率</p>
              <p @click="deviceSelectClick2(9)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 9"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[9]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.chargingPilePower.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="centerFormData.chargingPilePower.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('chargingPilePower', index, '+')">+</p>
              <p :class="centerFormData.chargingPilePower.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('chargingPilePower', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="centerFormData.chargingPilePower.formula.substring(2*index-1,2*index)==='×'||centerFormData.chargingPilePower.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('chargingPilePower',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.chargingPilePower.formula.substring(2*index-1,2*index)==='÷'||centerFormData.chargingPilePower.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('chargingPilePower',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('chargingPilePower', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(8, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 8 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('chargingPilePower')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--充电桩日充电量-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>充电桩日充电量</p>
              <p @click="deviceSelectClick2(10)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 10"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[10]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.chargingPileChargingCapacity.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p
                :class="centerFormData.chargingPileChargingCapacity.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''"
                @click="symbolClick('chargingPileChargingCapacity', index, '+')"
              >
                +
              </p>
              <p
                :class="centerFormData.chargingPileChargingCapacity.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''"
                @click="symbolClick('chargingPileChargingCapacity', index, '-')"
              >
                -
              </p>
              <!--              <p-->
              <!--                  :class="centerFormData.chargingPileChargingCapacity.formula.substring(2*index-1,2*index)==='×'||centerFormData.chargingPileChargingCapacity.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('chargingPileChargingCapacity',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.chargingPileChargingCapacity.formula.substring(2*index-1,2*index)==='÷'||centerFormData.chargingPileChargingCapacity.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('chargingPileChargingCapacity',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('chargingPileChargingCapacity', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(9, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 9 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('chargingPileChargingCapacity')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <p class="tit">负荷</p>
        <!--用电负荷-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>用电负荷</p>
              <p @click="deviceSelectClick2(11)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 11"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[11]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.electricityLoad.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="centerFormData.electricityLoad.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('electricityLoad', index, '+')">+</p>
              <p :class="centerFormData.electricityLoad.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('electricityLoad', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="centerFormData.electricityLoad.formula.substring(2*index-1,2*index)==='×'||centerFormData.electricityLoad.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('electricityLoad',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.electricityLoad.formula.substring(2*index-1,2*index)==='÷'||centerFormData.electricityLoad.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('electricityLoad',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('electricityLoad', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(16, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 16 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('electricityLoad')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>用电负荷</p>
              <p @click="deviceSelectClick2(11)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 11"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[11]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.electricityLoad.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="centerFormData.electricityLoad.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('electricityLoad', index, '+')">+</p>
              <p :class="centerFormData.electricityLoad.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('electricityLoad', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="centerFormData.electricityLoad.formula.substring(2*index-1,2*index)==='×'||centerFormData.electricityLoad.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('electricityLoad',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.electricityLoad.formula.substring(2*index-1,2*index)==='÷'||centerFormData.electricityLoad.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('electricityLoad',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('electricityLoad', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(16, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 16 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('electricityLoad')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <p class="tit">需量：<span style="font-size: 12px; color: #a4a4a4">（占比为A值-B值）</span></p>
        <!--当月降低需量值A-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>当月降低需量A值</p>
              <p @click="deviceSelectClick2(12)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 12"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[12]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.demandQuantityA.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="centerFormData.demandQuantityA.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('demandQuantityA', index, '+')">+</p>
              <p :class="centerFormData.demandQuantityA.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('demandQuantityA', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="centerFormData.demandQuantityA.formula.substring(2*index-1,2*index)==='×'||centerFormData.demandQuantityA.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('demandQuantityA',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.demandQuantityA.formula.substring(2*index-1,2*index)==='÷'||centerFormData.demandQuantityA.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('demandQuantityA',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('demandQuantityA', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(10, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 10 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('demandQuantityA')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--当月降低需量值B-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>当月降低需量B值</p>
              <p @click="deviceSelectClick2(13)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 13"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[13]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in centerFormData.demandQuantityB.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="centerFormData.demandQuantityB.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('demandQuantityB', index, '+')">+</p>
              <p :class="centerFormData.demandQuantityB.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('demandQuantityB', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="centerFormData.demandQuantityB.formula.substring(2*index-1,2*index)==='×'||centerFormData.demandQuantityB.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('demandQuantityB',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="centerFormData.demandQuantityB.formula.substring(2*index-1,2*index)==='÷'||centerFormData.demandQuantityB.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('demandQuantityB',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('demandQuantityB', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(11, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 11 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('demandQuantityB')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--单价-->
        <div style="margin-top: 20px; margin-left: 20px; display: flex; align-items: center">
          <span style="margin-right: 16px">单价</span>
          <el-input v-model="centerFormData.price" placeholder="请输入单价" style="width: 200px"></el-input>
        </div>
        <p class="tit">综合用电成本：</p>
        <!--综合用电成本-->
        <div style="margin-top: 20px; margin-left: 20px; display: flex; align-items: center">
          <span style="margin-right: 16px">投入前</span>
          <el-input v-model="centerFormData.beforeInvestmentCost" placeholder="请输入" style="width: 200px"></el-input>
          <span style="margin: 0 16px 0 32px">投入后</span>
          <el-input v-model="centerFormData.afterInvestmentCost" placeholder="请输入" style="width: 200px"></el-input>
        </div>
        <p class="tit">运行时间：</p>
        <!--运行时间-->
        <div style="margin-top: 20px; margin-left: 20px; display: flex; align-items: center">
          <span style="margin-right: 16px">运行时间</span>
          <el-date-picker v-model="centerFormData.startRunTime" placeholder="请选择时间" style="width: 200px" type="date" value-format="YYYY-MM-DD" />
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button class="resetButton" @click="setDialog6 = false">取消</el-button>
          <el-button type="primary" @click="setDialogSubmit6">确定</el-button>
        </span>
      </template>
    </el-dialog>
    <!--电力需求曲线配置-->
    <el-dialog v-model="setDialog7" class="setDialog1" title="电力需求曲线配置" width="80%">
      <div class="eleContBox">
        <!--电力需求优化前曲线配置-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>电力需求优化前</p>
              <p @click="deviceSelectClick2(0)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 0"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[0]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in electricityDemand.optimizationBefore.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="electricityDemand.optimizationBefore.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('optimizationBefore', index, '+')">+</p>
              <p :class="electricityDemand.optimizationBefore.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('optimizationBefore', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="electricityDemand.optimizationBefore.formula.substring(2*index-1,2*index)==='×'||electricityDemand.optimizationBefore.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('optimizationBefore',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="electricityDemand.optimizationBefore.formula.substring(2*index-1,2*index)==='÷'||electricityDemand.optimizationBefore.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('optimizationBefore',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('optimizationBefore', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(1, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 1 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('optimizationBefore')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
        <!--电力需求优化后曲线配置-->
        <div class="contentItem">
          <div class="liItemBox">
            <div class="bgc">
              <p>电力需求优化后</p>
              <p @click="deviceSelectClick2(1)">批量选择设备</p>
              <DeviceDictCheck
                v-if="deviceSelectIdx2 === 1"
                :checkDeviceList="equipmentList2"
                :deviceVisible="deviceVisible2"
                :isMultiple="true"
                @checkDeviceListFun="checkDeviceListFun2"
                @deviceVisibleFun="deviceVisibleFun2"
              />
              <el-checkbox v-model="isSynchronization[1]" label="同步指标" size="small" />
            </div>
            <p style="margin-left: 30px">=</p>
          </div>
          <div v-for="(item, index) in electricityDemand.optimizationAfter.items" :key="index" class="contItemBox">
            <div v-if="index !== 0" class="symbol">
              <p :class="electricityDemand.optimizationAfter.formula.substring(2 * index - 1, 2 * index) === '+' ? 'activeSymbol' : ''" @click="symbolClick('optimizationAfter', index, '+')">+</p>
              <p :class="electricityDemand.optimizationAfter.formula.substring(2 * index - 1, 2 * index) === '-' ? 'activeSymbol' : ''" @click="symbolClick('optimizationAfter', index, '-')">-</p>
              <!--              <p-->
              <!--                  :class="electricityDemand.optimizationAfter.formula.substring(2*index-1,2*index)==='×'||electricityDemand.optimizationAfter.formula.substring(2*index-1,2*index)==='*'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('optimizationAfter',index,'*')">×</p>-->
              <!--              <p-->
              <!--                  :class="electricityDemand.optimizationAfter.formula.substring(2*index-1,2*index)==='÷'||electricityDemand.optimizationAfter.formula.substring(2*index-1,2*index)==='/'?'activeSymbol':''"-->
              <!--                  @click="symbolClick('optimizationAfter',index,'/')">÷</p>-->
            </div>
            <div class="contItem">
              <el-icon class="delIcon" @click="delControl('optimizationAfter', index)">
                <CircleClose />
              </el-icon>
              <div class="contBox">
                <el-input v-model="item.dictName" readonly style="margin-top: 20px; cursor: pointer" @click="deviceDictSelectClick(2, index)"></el-input>
                <div class="center">
                  <span v-if="item.deviceName">{{ item.deviceName }}</span>
                </div>
                <span class="unit">{{ item.unit }}</span>
              </div>
              <DeviceDictSelect
                v-if="deviceDictSelectIdx === 2 && deviceDictSelectIdx2 === index"
                :deviceDictVisible="deviceDictVisible"
                @checkDeviceDictListFun="checkDeviceDictListFun"
                @deviceDictVisibleFun="deviceDictVisibleFun"
              />
            </div>
          </div>
          <div>
            <el-icon class="addIcon" @click="addControl('optimizationAfter')">
              <CirclePlus />
            </el-icon>
          </div>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button class="resetButton" @click="setDialog7 = false">取消</el-button>
          <el-button type="primary" @click="setDialogSubmit7">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';
import { defineProps, h, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import moment from "moment";
import CountUp from "vue-countup-v3";
import * as echarts from "echarts";
import "echarts-gl";
import { ElMessage, ElMessageBox } from "element-plus";
import { CircleClose, CirclePlus, Plus } from "@element-plus/icons-vue";
import DeviceDictSelect from "./component/deviceDictSelect";
import DeviceDictCheck from "./component/deviceDictCheck";
import letterList from "@/assets/js/letterList";
import { getGeneralWeatherApi, getKanbanDataApi, getKanbanDataDetailApi, saveKanbanDataApi, getKanbanDataApiV2 } from "@/api/modules/project";
import { getStationTreeApi } from "@/api/modules/powerStation";
import qs from "qs";
import cityCode from "@/assets/js/citycode.json";
import WebSocketService from "./component/websocketService";
import { ws } from "@/api"; // 确保路径正确
const props = defineProps(["screenFlag", "projectModuleId", "showFlag", "custerObj", "templateId"]);
moment.locale("zh-cn");

let isSynchronization = ref([true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true]);

// 多个设备的单个指标加减选择
// 参数操作------------------------------------
// 符号点击
const symbolClick = function (index, index_child, e) {
  if (setDialog2.value) {
    // 判断如果是用电情况分析
    let str = eleFormData.value[index].formula;
    eleFormData.value[index].formula = str.substr(0, 2 * index_child - 1) + e + str.substr(2 * index_child);
  } else if (setDialog3.value) {
    // 判断如果是用电情况分析
    let str = newEnergyPowerGeneration.value[index].formula;
    newEnergyPowerGeneration.value[index].formula = str.substr(0, 2 * index_child - 1) + e + str.substr(2 * index_child);
  } else if (setDialog4.value) {
    // 判断如果是用电情况分析
    let str = operatingPower.value[index].formula;
    operatingPower.value[index].formula = str.substr(0, 2 * index_child - 1) + e + str.substr(2 * index_child);
  } else if (setDialog5.value) {
    // 判断如果是用电情况分析
    let str = costFormData.value[index].formula;
    costFormData.value[index].formula = str.substr(0, 2 * index_child - 1) + e + str.substr(2 * index_child);
  } else if (setDialog6.value) {
    // 判断如果是用电情况分析
    let str = centerFormData.value[index].formula;
    centerFormData.value[index].formula = str.substr(0, 2 * index_child - 1) + e + str.substr(2 * index_child);
  } else if (setDialog7.value) {
    // 判断如果是用电情况分析
    let str = electricityDemand.value[index].formula;
    electricityDemand.value[index].formula = str.substr(0, 2 * index_child - 1) + e + str.substr(2 * index_child);
  }
};
// 添加参数值
const addControl = function (type) {
  if (setDialog2.value) {
    // 判断如果是用电情况分析
    if (type === "electricity") {
      if (eleFormData.value.electricity.items.length === 0) {
        eleFormData.value.electricity.formula = "A";
      } else {
        eleFormData.value.electricity.formula = eleFormData.value.electricity.formula.concat("+D");
      }
      eleFormData.value.electricity.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "absorb") {
      if (eleFormData.value.absorb.items.length === 0) {
        eleFormData.value.absorb.formula = "A";
      } else {
        eleFormData.value.absorb.formula = eleFormData.value.absorb.formula.concat("+D");
      }
      eleFormData.value.absorb.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    }
  } else if (setDialog3.value) {
    // 判断如果是新能源情况分析
    if (type === "electricity") {
      if (newEnergyPowerGeneration.value.electricity.items.length === 0) {
        newEnergyPowerGeneration.value.electricity.formula = "A";
      } else {
        newEnergyPowerGeneration.value.electricity.formula = newEnergyPowerGeneration.value.electricity.formula.concat("+D");
      }
      newEnergyPowerGeneration.value.electricity.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "selfElectricity") {
      if (newEnergyPowerGeneration.value.selfElectricity.items.length === 0) {
        newEnergyPowerGeneration.value.selfElectricity.formula = "A";
      } else {
        newEnergyPowerGeneration.value.selfElectricity.formula = newEnergyPowerGeneration.value.selfElectricity.formula.concat("+D");
      }
      newEnergyPowerGeneration.value.selfElectricity.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "internetElectricity") {
      if (newEnergyPowerGeneration.value.internetElectricity.items.length === 0) {
        newEnergyPowerGeneration.value.internetElectricity.formula = "A";
      } else {
        newEnergyPowerGeneration.value.internetElectricity.formula = newEnergyPowerGeneration.value.internetElectricity.formula.concat("+D");
      }
      newEnergyPowerGeneration.value.internetElectricity.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    }
  } else if (setDialog4.value) {
    // 判断如果是运行功率曲线
    if (type === "load") {
      if (operatingPower.value.load.items.length === 0) {
        operatingPower.value.load.formula = "A";
      } else {
        operatingPower.value.load.formula = operatingPower.value.load.formula.concat("+D");
      }
      operatingPower.value.load.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "energyStorage") {
      if (operatingPower.value.energyStorage.items.length === 0) {
        operatingPower.value.energyStorage.formula = "A";
      } else {
        operatingPower.value.energyStorage.formula = operatingPower.value.energyStorage.formula.concat("+D");
      }
      operatingPower.value.energyStorage.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "municipalElectricity") {
      if (operatingPower.value.municipalElectricity.items.length === 0) {
        operatingPower.value.municipalElectricity.formula = "A";
      } else {
        operatingPower.value.municipalElectricity.formula = operatingPower.value.municipalElectricity.formula.concat("+D");
      }
      operatingPower.value.municipalElectricity.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "newEnergy") {
      if (operatingPower.value.newEnergy.items.length === 0) {
        operatingPower.value.newEnergy.formula = "A";
      } else {
        operatingPower.value.newEnergy.formula = operatingPower.value.newEnergy.formula.concat("+D");
      }
      operatingPower.value.newEnergy.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    }
  } else if (setDialog5.value) {
    // 判断如果是运行功率曲线
    if (type === "optimizationBefore") {
      if (costFormData.value.optimizationBefore.items.length === 0) {
        costFormData.value.optimizationBefore.formula = "A";
      } else {
        costFormData.value.optimizationBefore.formula = costFormData.value.optimizationBefore.formula.concat("+D");
      }
      costFormData.value.optimizationBefore.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "optimizationAfter") {
      if (costFormData.value.optimizationAfter.items.length === 0) {
        costFormData.value.optimizationAfter.formula = "A";
      } else {
        costFormData.value.optimizationAfter.formula = costFormData.value.optimizationAfter.formula.concat("+D");
      }
      costFormData.value.optimizationAfter.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    }
  } else if (setDialog6.value) {
    // 判断如果是新能源情况分析
    if (type === "newEnergyProportionA") {
      if (centerFormData.value.newEnergyProportionA.items.length === 0) {
        centerFormData.value.newEnergyProportionA.formula = "A";
      } else {
        centerFormData.value.newEnergyProportionA.formula = centerFormData.value.newEnergyProportionA.formula.concat("+D");
      }
      centerFormData.value.newEnergyProportionA.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "newEnergyProportionB") {
      if (centerFormData.value.newEnergyProportionB.items.length === 0) {
        centerFormData.value.newEnergyProportionB.formula = "A";
      } else {
        centerFormData.value.newEnergyProportionB.formula = centerFormData.value.newEnergyProportionB.formula.concat("+D");
      }
      centerFormData.value.newEnergyProportionB.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "photovoltaicPowerGenerationCapacity") {
      if (centerFormData.value.photovoltaicPowerGenerationCapacity.items.length === 0) {
        centerFormData.value.photovoltaicPowerGenerationCapacity.formula = "A";
      } else {
        centerFormData.value.photovoltaicPowerGenerationCapacity.formula = centerFormData.value.photovoltaicPowerGenerationCapacity.formula.concat("+D");
      }
      centerFormData.value.photovoltaicPowerGenerationCapacity.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "photovoltaicPowerGeneration") {
      if (centerFormData.value.photovoltaicPowerGeneration.items.length === 0) {
        centerFormData.value.photovoltaicPowerGeneration.formula = "A";
      } else {
        centerFormData.value.photovoltaicPowerGeneration.formula = centerFormData.value.photovoltaicPowerGeneration.formula.concat("+D");
      }
      centerFormData.value.photovoltaicPowerGeneration.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "photovoltaicRevenue") {
      if (centerFormData.value.photovoltaicRevenue.items.length === 0) {
        centerFormData.value.photovoltaicRevenue.formula = "A";
      } else {
        centerFormData.value.photovoltaicRevenue.formula = centerFormData.value.photovoltaicRevenue.formula.concat("+D");
      }
      centerFormData.value.photovoltaicRevenue.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "energyStorageChargingPower") {
      if (centerFormData.value.energyStorageChargingPower.items.length === 0) {
        centerFormData.value.energyStorageChargingPower.formula = "A";
      } else {
        centerFormData.value.energyStorageChargingPower.formula = centerFormData.value.energyStorageChargingPower.formula.concat("+D");
      }
      centerFormData.value.energyStorageChargingPower.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "energyStorageDischargePower") {
      if (centerFormData.value.energyStorageDischargePower.items.length === 0) {
        centerFormData.value.energyStorageDischargePower.formula = "A";
      } else {
        centerFormData.value.energyStorageDischargePower.formula = centerFormData.value.energyStorageDischargePower.formula.concat("+D");
      }
      centerFormData.value.energyStorageDischargePower.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "energyRevenue") {
      if (centerFormData.value.energyRevenue.items.length === 0) {
        centerFormData.value.energyRevenue.formula = "A";
      } else {
        centerFormData.value.energyRevenue.formula = centerFormData.value.energyRevenue.formula.concat("+D");
      }
      centerFormData.value.energyRevenue.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "chargingPilePower") {
      if (centerFormData.value.chargingPilePower.items.length === 0) {
        centerFormData.value.chargingPilePower.formula = "A";
      } else {
        centerFormData.value.chargingPilePower.formula = centerFormData.value.chargingPilePower.formula.concat("+D");
      }
      centerFormData.value.chargingPilePower.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "chargingPileChargingCapacity") {
      if (centerFormData.value.chargingPileChargingCapacity.items.length === 0) {
        centerFormData.value.chargingPileChargingCapacity.formula = "A";
      } else {
        centerFormData.value.chargingPileChargingCapacity.formula = centerFormData.value.chargingPileChargingCapacity.formula.concat("+D");
      }
      centerFormData.value.chargingPileChargingCapacity.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "demandQuantityA") {
      if (centerFormData.value.demandQuantityA.items.length === 0) {
        centerFormData.value.demandQuantityA.formula = "A";
      } else {
        centerFormData.value.demandQuantityA.formula = centerFormData.value.demandQuantityA.formula.concat("+D");
      }
      centerFormData.value.demandQuantityA.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "demandQuantityB") {
      if (centerFormData.value.demandQuantityB.items.length === 0) {
        centerFormData.value.demandQuantityB.formula = "A";
      } else {
        centerFormData.value.demandQuantityB.formula = centerFormData.value.demandQuantityB.formula.concat("+D");
      }
      centerFormData.value.demandQuantityB.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "internetPower") {
      if (centerFormData.value.internetPower.items.length === 0) {
        centerFormData.value.internetPower.formula = "A";
      } else {
        centerFormData.value.internetPower.formula = centerFormData.value.internetPower.formula.concat("+D");
      }
      centerFormData.value.internetPower.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "downInternetPower") {
      if (centerFormData.value.downInternetPower.items.length === 0) {
        centerFormData.value.downInternetPower.formula = "A";
      } else {
        centerFormData.value.downInternetPower.formula = centerFormData.value.downInternetPower.formula.concat("+D");
      }
      centerFormData.value.downInternetPower.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "electricityLoad") {
      if (centerFormData.value.electricityLoad.items.length === 0) {
        centerFormData.value.electricityLoad.formula = "A";
      } else {
        centerFormData.value.electricityLoad.formula = centerFormData.value.electricityLoad.formula.concat("+D");
      }
      centerFormData.value.electricityLoad.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    }
  } else if (setDialog7.value) {
    // 判断如果是新能源情况分析
    if (type === "optimizationBefore") {
      if (electricityDemand.value.optimizationBefore.items.length === 0) {
        electricityDemand.value.optimizationBefore.formula = "A";
      } else {
        electricityDemand.value.optimizationBefore.formula = electricityDemand.value.optimizationBefore.formula.concat("+D");
      }
      electricityDemand.value.optimizationBefore.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    } else if (type === "optimizationAfter") {
      if (electricityDemand.value.optimizationAfter.items.length === 0) {
        electricityDemand.value.optimizationAfter.formula = "A";
      } else {
        electricityDemand.value.optimizationAfter.formula = electricityDemand.value.optimizationAfter.formula.concat("+D");
      }
      electricityDemand.value.optimizationAfter.items.push({
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      });
    }
  }
};
// 删除参数值
const delControl = function (type, index_child) {
  if (setDialog2.value) {
    // 判断如果是用电情况分析
    ElMessageBox.confirm("", "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      title: "删除参数",
      message: h("p", null, [
        h(
          "img",
          {
            src: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png",
            style: "width:20px;height:20px;transform: translateY(4px);margin-right:8px;",
          },
          ""
        ),
        h("span", { style: "color:#595959;" }, "请确认是否要删除此参数，删除后数据不可恢复"),
      ]),
    })
      .then(() => {
        if (type === "electricity") {
          let str = eleFormData.value.electricity.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          eleFormData.value.electricity.formula = strA.concat(strB);
          eleFormData.value.electricity.items.splice(index_child, 1);
        } else if (type === "absorb") {
          let str = eleFormData.value.absorb.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          eleFormData.value.absorb.formula = strA.concat(strB);
          eleFormData.value.absorb.items.splice(index_child, 1);
        }

        ElMessage({
          type: "success",
          message: "删除成功",
        });
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消删除",
        });
      });
  } else if (setDialog3.value) {
    // 判断如果是用电情况分析
    ElMessageBox.confirm("", "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      title: "删除参数",
      message: h("p", null, [
        h(
          "img",
          {
            src: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png",
            style: "width:20px;height:20px;transform: translateY(4px);margin-right:8px;",
          },
          ""
        ),
        h("span", { style: "color:#595959;" }, "请确认是否要删除此参数，删除后数据不可恢复"),
      ]),
    })
      .then(() => {
        if (type === "electricity") {
          let str = newEnergyPowerGeneration.value.electricity.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          newEnergyPowerGeneration.value.electricity.formula = strA.concat(strB);
          newEnergyPowerGeneration.value.electricity.items.splice(index_child, 1);
        } else if (type === "selfElectricity") {
          let str = newEnergyPowerGeneration.value.selfElectricity.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          newEnergyPowerGeneration.value.selfElectricity.formula = strA.concat(strB);
          newEnergyPowerGeneration.value.selfElectricity.items.splice(index_child, 1);
        } else if (type === "internetElectricity") {
          let str = newEnergyPowerGeneration.value.internetElectricity.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          newEnergyPowerGeneration.value.internetElectricity.formula = strA.concat(strB);
          newEnergyPowerGeneration.value.internetElectricity.items.splice(index_child, 1);
        }

        ElMessage({
          type: "success",
          message: "删除成功",
        });
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消删除",
        });
      });
  } else if (setDialog4.value) {
    // 判断如果是用电情况分析
    ElMessageBox.confirm("", "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      title: "删除参数",
      message: h("p", null, [
        h(
          "img",
          {
            src: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png",
            style: "width:20px;height:20px;transform: translateY(4px);margin-right:8px;",
          },
          ""
        ),
        h("span", { style: "color:#595959;" }, "请确认是否要删除此参数，删除后数据不可恢复"),
      ]),
    })
      .then(() => {
        if (type === "load") {
          let str = operatingPower.value.load.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          operatingPower.value.load.formula = strA.concat(strB);
          operatingPower.value.load.items.splice(index_child, 1);
        } else if (type === "energyStorage") {
          let str = operatingPower.value.energyStorage.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          operatingPower.value.energyStorage.formula = strA.concat(strB);
          operatingPower.value.energyStorage.items.splice(index_child, 1);
        } else if (type === "municipalElectricity") {
          let str = operatingPower.value.municipalElectricity.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          operatingPower.value.municipalElectricity.formula = strA.concat(strB);
          operatingPower.value.municipalElectricity.items.splice(index_child, 1);
        } else if (type === "newEnergy") {
          let str = operatingPower.value.newEnergy.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          operatingPower.value.newEnergy.formula = strA.concat(strB);
          operatingPower.value.newEnergy.items.splice(index_child, 1);
        }

        ElMessage({
          type: "success",
          message: "删除成功",
        });
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消删除",
        });
      });
  } else if (setDialog5.value) {
    // 判断如果是用电情况分析
    ElMessageBox.confirm("", "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      title: "删除参数",
      message: h("p", null, [
        h(
          "img",
          {
            src: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png",
            style: "width:20px;height:20px;transform: translateY(4px);margin-right:8px;",
          },
          ""
        ),
        h("span", { style: "color:#595959;" }, "请确认是否要删除此参数，删除后数据不可恢复"),
      ]),
    })
      .then(() => {
        if (type === "optimizationBefore") {
          let str = costFormData.value.optimizationBefore.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          costFormData.value.optimizationBefore.formula = strA.concat(strB);
          costFormData.value.optimizationBefore.items.splice(index_child, 1);
        } else if (type === "optimizationAfter") {
          let str = costFormData.value.optimizationAfter.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          costFormData.value.optimizationAfter.formula = strA.concat(strB);
          costFormData.value.optimizationAfter.items.splice(index_child, 1);
        }

        ElMessage({
          type: "success",
          message: "删除成功",
        });
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消删除",
        });
      });
  } else if (setDialog6.value) {
    // 判断如果是用电情况分析
    ElMessageBox.confirm("", "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      title: "删除参数",
      message: h("p", null, [
        h(
          "img",
          {
            src: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png",
            style: "width:20px;height:20px;transform: translateY(4px);margin-right:8px;",
          },
          ""
        ),
        h("span", { style: "color:#595959;" }, "请确认是否要删除此参数，删除后数据不可恢复"),
      ]),
    })
      .then(() => {
        if (type === "newEnergyProportionA") {
          let str = centerFormData.value.newEnergyProportionA.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.newEnergyProportionA.formula = strA.concat(strB);
          centerFormData.value.newEnergyProportionA.items.splice(index_child, 1);
        } else if (type === "newEnergyProportionB") {
          let str = centerFormData.value.newEnergyProportionB.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.newEnergyProportionB.formula = strA.concat(strB);
          centerFormData.value.newEnergyProportionB.items.splice(index_child, 1);
        } else if (type === "photovoltaicPowerGenerationCapacity") {
          let str = centerFormData.value.photovoltaicPowerGenerationCapacity.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.photovoltaicPowerGenerationCapacity.formula = strA.concat(strB);
          centerFormData.value.photovoltaicPowerGenerationCapacity.items.splice(index_child, 1);
        } else if (type === "photovoltaicPowerGeneration") {
          let str = centerFormData.value.photovoltaicPowerGeneration.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.photovoltaicPowerGeneration.formula = strA.concat(strB);
          centerFormData.value.photovoltaicPowerGeneration.items.splice(index_child, 1);
        } else if (type === "photovoltaicRevenue") {
          let str = centerFormData.value.photovoltaicRevenue.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.photovoltaicRevenue.formula = strA.concat(strB);
          centerFormData.value.photovoltaicRevenue.items.splice(index_child, 1);
        } else if (type === "energyStorageChargingPower") {
          let str = centerFormData.value.energyStorageChargingPower.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.energyStorageChargingPower.formula = strA.concat(strB);
          centerFormData.value.energyStorageChargingPower.items.splice(index_child, 1);
        } else if (type === "energyStorageDischargePower") {
          let str = centerFormData.value.energyStorageDischargePower.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.energyStorageDischargePower.formula = strA.concat(strB);
          centerFormData.value.energyStorageDischargePower.items.splice(index_child, 1);
        } else if (type === "energyRevenue") {
          let str = centerFormData.value.energyRevenue.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.energyRevenue.formula = strA.concat(strB);
          centerFormData.value.energyRevenue.items.splice(index_child, 1);
        } else if (type === "chargingPilePower") {
          let str = centerFormData.value.chargingPilePower.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.chargingPilePower.formula = strA.concat(strB);
          centerFormData.value.chargingPilePower.items.splice(index_child, 1);
        } else if (type === "chargingPileChargingCapacity") {
          let str = centerFormData.value.chargingPileChargingCapacity.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.chargingPileChargingCapacity.formula = strA.concat(strB);
          centerFormData.value.chargingPileChargingCapacity.items.splice(index_child, 1);
        } else if (type === "demandQuantityA") {
          let str = centerFormData.value.demandQuantityA.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.demandQuantityA.formula = strA.concat(strB);
          centerFormData.value.demandQuantityA.items.splice(index_child, 1);
        } else if (type === "demandQuantityB") {
          let str = centerFormData.value.demandQuantityB.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.demandQuantityB.formula = strA.concat(strB);
          centerFormData.value.demandQuantityB.items.splice(index_child, 1);
        } else if (type === "internetPower") {
          let str = centerFormData.value.internetPower.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.internetPower.formula = strA.concat(strB);
          centerFormData.value.internetPower.items.splice(index_child, 1);
        } else if (type === "downInternetPower") {
          let str = centerFormData.value.downInternetPower.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.downInternetPower.formula = strA.concat(strB);
          centerFormData.value.downInternetPower.items.splice(index_child, 1);
        } else if (type === "electricityLoad") {
          let str = centerFormData.value.electricityLoad.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          centerFormData.value.electricityLoad.formula = strA.concat(strB);
          centerFormData.value.electricityLoad.items.splice(index_child, 1);
        }
        ElMessage({
          type: "success",
          message: "删除成功",
        });
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消删除",
        });
      });
  } else if (setDialog7.value) {
    // 判断如果是用电情况分析
    ElMessageBox.confirm("", "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      title: "删除参数",
      message: h("p", null, [
        h(
          "img",
          {
            src: "https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png",
            style: "width:20px;height:20px;transform: translateY(4px);margin-right:8px;",
          },
          ""
        ),
        h("span", { style: "color:#595959;" }, "请确认是否要删除此参数，删除后数据不可恢复"),
      ]),
    })
      .then(() => {
        if (type === "optimizationBefore") {
          let str = electricityDemand.value.optimizationBefore.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          electricityDemand.value.optimizationBefore.formula = strA.concat(strB);
          electricityDemand.value.optimizationBefore.items.splice(index_child, 1);
        } else if (type === "optimizationAfter") {
          let str = electricityDemand.value.optimizationAfter.formula;
          let strA;
          let strB;
          if (index_child !== 0) {
            strA = str.slice(0, 2 * index_child - 1);
            strB = str.slice(2 * index_child + 1, str.length);
          } else {
            strA = "";
            strB = str.slice(2, str.length);
          }
          electricityDemand.value.optimizationAfter.formula = strA.concat(strB);
          electricityDemand.value.optimizationAfter.items.splice(index_child, 1);
        }

        ElMessage({
          type: "success",
          message: "删除成功",
        });
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消删除",
        });
      });
  }
};

// 地图配置**************************************************************************
let map = ref();
let mapName = ref();
const mapAllFun = function (lng, lat) {
  map.value = new BMap.Map("allmap"); // 创建Map实例
  map.value.clearOverlays(); // 清除地图上所有覆盖物
  var point = new BMap.Point(lng, lat); // 创建点坐标，汉得公司的经纬度坐标
  map.value.centerAndZoom(point, 15); //初始化地图,设置中心点坐标，
  map.value.addOverlay(new BMap.Marker(point)); //添加标注
  map.value.enableScrollWheelZoom();
  var ac = new BMap.Autocomplete({
    //建立一个自动完成的对象
    input: "suggestId",
    location: map.value,
  });
  /*if(this.editId) {
    ac.setInputValue('杭州') //自动匹配后给input默认值赋值
  }*/
  var myValue;
  ac.addEventListener("onconfirm", function (e) {
    //鼠标点击下拉列表后的事件
    var _value = e.item.value;
    myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
    mapName.value = myValue;
    setPlace();
  });

  function setPlace() {
    map.value.clearOverlays(); //清除地图上所有覆盖物
    function myFun() {
      //console.log(local.getResults().getPoi(0).point)
      basicInfoFormData.value.longitude = local.getResults().getPoi(0).point.lng;
      basicInfoFormData.value.latitude = local.getResults().getPoi(0).point.lat;
      var userlocation = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
      map.value.centerAndZoom(userlocation, 15);
      map.value.addOverlay(new BMap.Marker(userlocation)); //添加标注
    }

    var local = new BMap.LocalSearch(map.value, {
      //智能搜索
      onSearchComplete: myFun,
    });
    local.search(myValue);
  }

  //地图的点击
  map.value.addEventListener("click", function (e) {
    basicInfoFormData.value.longitude = e.point.lng;
    basicInfoFormData.value.latitude = e.point.lat;
    map.value.clearOverlays();
    var userlocation = e.point; //获取第一个智能搜索的结果
    map.value.centerAndZoom(userlocation, 15);
    map.value.addOverlay(new BMap.Marker(userlocation)); //添加标注
  });
};

// 选择配置哪个模块**************************************************************************
let selectSetDialog = ref(false);
const selectSetSubmit = function (idx) {
  if (idx) {
    // selectSetDialog.value = false
    if (idx === 1) {
      setDialogClick1();
    } else if (idx === 2) {
      setDialogClick2();
    } else if (idx === 3) {
      setDialogClick3();
    } else if (idx === 4) {
      setDialogClick4();
    } else if (idx === 5) {
      setDialogClick5();
    } else if (idx === 6) {
      setDialogClick6();
    } else if (idx === 7) {
      setDialogClick7();
    }
  } else {
    ElMessage({
      type: "info",
      message: "请选择配置的模块！",
    });
  }
};

// 实时时间**************************************************************************
let nowTime = ref();
const timer = setInterval(() => {
  nowTime.value = moment().format("YYYY-MM-DD") + "  " + moment().format("dddd") + "  " + moment().format("HH:mm:ss");
}, 1000);

// 项目基本信息**************************************************************************
let setDialog1 = ref(false);
let basicInfoFormData = ref({
  projectName: "",
  voltageLevel: "",
  transformerNum: "",
  transformerCapacity: "",
  chargingMethod: "",
  photovoltaicCapacity: "",
  energyStorageCapacity: "",
  dcPile: "",
  acPile: "",
  address: "",
  longitude: 0,
  latitude: 0,
  blockId: 1,
});
let basicInfoFormRules = ref({
  //配电室表单规则
  projectName: [
    {
      required: true,
      message: "请输入项目名称",
      trigger: "blur",
    },
  ],
  voltageLevel: [
    {
      required: true,
      message: "请输入电压等级",
      trigger: "blur",
    },
  ],
  transformerNum: [
    {
      required: true,
      message: "请输入变压器数量",
      trigger: "blur",
    },
  ],
  transformerCapacity: [
    {
      required: true,
      message: "请输入变压器容量",
      trigger: "blur",
    },
  ],
  chargingMethod: [
    {
      required: true,
      message: "请选择收费方式",
      trigger: "blur",
    },
  ],
  photovoltaicCapacity: [
    {
      required: true,
      message: "请输入光伏容量",
      trigger: "blur",
    },
  ],
  energyStorageCapacity: [
    {
      required: true,
      message: "请输入储能容量",
      trigger: "blur",
    },
  ],
  dcPile: [
    {
      required: true,
      message: "请输入直流充电桩",
      trigger: "blur",
    },
  ],
  acPile: [
    {
      required: true,
      message: "请输入交流充电桩",
      trigger: "blur",
    },
  ],
  longitude: [
    {
      required: true,
      message: "请输入经度",
      trigger: "blur",
    },
  ],
  latitude: [
    {
      required: true,
      message: "请输入纬度",
      trigger: "blur",
    },
  ],
});
const setDialogClick1 = function () {
  nextTick(() => {
    setTimeout(() => {
      mapAllFun(120.21551, 30.253082);
    }, 50);
  });
  getKanbanDataDetailApi({
    moduleId: props.projectModuleId,
    templateId: props.templateId,
    blockId: 1,
  })
    .then((res) => {
      if (res.data.code == 200) {
        setDialog1.value = true;
        basicInfoFormData.value = res.data.data.baseInfo;
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
const setDialogSubmit1 = function () {
  saveKanbanDataApi({
    baseInfo: { ...basicInfoFormData.value, blockId: 1 },
    moduleId: Number(props.projectModuleId),
    templateId: props.templateId,
  })
    .then((res) => {
      if (res.data.code == 200) {
        setDialog1.value = false;
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

// 用电情况分析**************************************************************************
// 3d饼图的实现
const getPie3D = (pieData, internalDiameterRatio) => {
  //internalDiameterRatio:透明的空心占比
  let series = [];
  let sumValue = 0;
  let startValue = 0;
  let endValue = 0;
  let k = 1;
  pieData.sort((a, b) => {
    return b.value - a.value;
  });
  // 为每一个饼图数据，生成一个 series-surface 配置
  for (let i = 0; i < pieData.length; i++) {
    sumValue += pieData[i].value;
    let seriesItem = {
      name: typeof pieData[i].name === "undefined" ? `series${i}` : pieData[i].name,
      type: "surface",
      parametric: true,
      wireframe: {
        show: false,
      },
      pieData: pieData[i],
      pieStatus: {
        selected: false,
        hovered: false,
        k: k,
      },
      radius: "50%",
      center: ["10%", "10%"],
    };

    if (typeof pieData[i].itemStyle != "undefined") {
      let itemStyle = {};
      typeof pieData[i].itemStyle.color != "undefined" ? (itemStyle.color = pieData[i].itemStyle.color) : null;
      typeof pieData[i].itemStyle.opacity != "undefined" ? (itemStyle.opacity = pieData[i].itemStyle.opacity) : null;
      seriesItem.itemStyle = itemStyle;
    }
    series.push(seriesItem);
  }

  // 使用上一次遍历时，计算出的数据和 sumValue，调用 getParametricEquation 函数，
  // 向每个 series-surface 传入不同的参数方程 series-surface.parametricEquation，也就是实现每一个扇形。
  for (let i = 0; i < series.length; i++) {
    endValue = startValue + series[i].pieData.value;
    series[i].pieData.startRatio = startValue / sumValue;
    series[i].pieData.endRatio = endValue / sumValue;
    series[i].parametricEquation = getParametricEquation(series[i].pieData.startRatio, series[i].pieData.endRatio, false, false, k, series[i].pieData.value);
    startValue = endValue;
  }
  let boxHeight = getHeight3D(series, 26); //通过传参设定3d饼/环的高度，26代表26px
  // 准备待返回的配置项，把准备好的 legendData、series 传入。
  let option = {
    backgroundColor: "transparent",
    labelLine: {
      show: true,
      lineStyle: {
        color: "#404772",
      },
    },
    label: {
      show: true,
      position: "outside",
      rich: {
        b: {
          fontSize: 24,
          lineHeight: 30,
          fontWeight: "bold",
          color: "#fff",
        },
        c: {
          fontSize: 18,
          color: "#fff",
        },
      },
      formatter: "{b|{b}}\n{c|{c}%}",
    },
    tooltip: {
      // backgroundColor: '#053A8D',
      formatter: (params) => {
        if (params.seriesName !== "mouseoutSeries" && params.seriesName !== "pie2d") {
          let bfb = ((option.series[params.seriesIndex].pieData.endRatio - option.series[params.seriesIndex].pieData.startRatio) * 100).toFixed(2);
          return `${params.seriesName}<br/>` + `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color};"></span>` + `${bfb}%`;
        }
      },
    },
    xAxis3D: {
      min: -1,
      max: 1,
    },
    yAxis3D: {
      min: -1,
      max: 1,
    },
    zAxis3D: {
      min: -1,
      max: 1,
    },
    grid3D: {
      show: false,
      boxHeight: boxHeight, //圆环的高度
      left: 0,
      top: 0, //3d饼图的位置
      viewControl: {
        //3d效果可以放大、旋转等，请自己去查看官方配置
        alpha: 30, //角度
        distance: 250, //调整视角到主体的距离，类似调整zoom
        rotateSensitivity: 0, //设置为0无法旋转
        zoomSensitivity: 0, //设置为0无法缩放
        panSensitivity: 0, //设置为0无法平移
        autoRotate: false, //自动旋转
      },
    },
    series: series,
  };
  return option;
};
//获取3d丙图的最高扇区的高度
const getHeight3D = (series, height) => {
  series.sort((a, b) => {
    return b.pieData.value - a.pieData.value;
  });
  return (height * 25) / series[0].pieData.value;
};
// 生成扇形的曲面参数方程，用于 series-surface.parametricEquation
const getParametricEquation = (startRatio, endRatio, isSelected, isHovered, k, h) => {
  // 计算
  let midRatio = (startRatio + endRatio) / 2;
  let startRadian = startRatio * Math.PI * 2;
  let endRadian = endRatio * Math.PI * 2;
  let midRadian = midRatio * Math.PI * 2;
  // 如果只有一个扇形，则不实现选中效果。
  if (startRatio === 0 && endRatio === 1) {
    isSelected = true;
  }
  // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
  k = typeof k !== "undefined" ? k : 1 / 3;
  // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
  let offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
  let offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;
  // 计算高亮效果的放大比例（未高亮，则比例为 1）
  let hoverRate = isHovered ? 1.05 : 1;
  // 返回曲面参数方程
  return {
    u: {
      min: -Math.PI,
      max: Math.PI * 3,
      step: Math.PI / 32,
    },
    v: {
      min: 0,
      max: Math.PI * 2,
      step: Math.PI / 20,
    },
    x: function (u, v) {
      if (u < startRadian) {
        return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      if (u > endRadian) {
        return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
    },
    y: function (u, v) {
      if (u < startRadian) {
        return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      if (u > endRadian) {
        return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
      }
      return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
    },
    z: function (u, v) {
      if (u < -Math.PI * 0.5) {
        return Math.sin(u);
      }
      if (u > Math.PI * 2.5) {
        return Math.sin(u) * h * 0.1;
      }
      return Math.sin(v) > 0 ? 1 * h * 0.1 : -1;
    },
  };
};
// 月供电图表
const circleChartLoad1 = function () {
  var data = [
    {
      name: "电网月供电",
      value: pageData.value.electricAnalysis.monthElectricGrid,
      itemStyle: { color: "#67EEC0" },
      startRatio: 0,
      endRatio: 0.7,
    },
    {
      name: "新能源月消纳",
      value: pageData.value.electricAnalysis.monthNewEnergyConsumption,
      itemStyle: { color: "#029EF4" },
      startRatio: 0.7,
      endRatio: 1,
    },
  ];
  var chartDom = document.querySelector(".circleChartRef1");

  var myChart = echarts.init(chartDom);
  let option = getPie3D(data, 0.8);
  console.log("option", option);
  // myChart.clear()
  option && myChart.setOption(option);
  myChart.resize({
    animation: {
      duration: 2800,
      easing: "cubicInOut",
      // delay: 500,
    },
  });
  window.onresize = () => {
    myChart.resize();
  };
};
// 年供电图表
const circleChartLoad2 = function () {
  var data = [
    {
      name: "电网年供电",
      value: pageData.value.electricAnalysis.yearElectricGrid,
      itemStyle: { color: "#67EEC0" },
      startRatio: 0,
      endRatio: 0.7,
    },
    {
      name: "新能源年消纳",
      value: pageData.value.electricAnalysis.yearNewEnergyConsumption,
      itemStyle: { color: "#029EF4" },
      startRatio: 0.7,
      endRatio: 1,
    },
  ];
  var chartDom = document.querySelector(".circleChartRef2");
  var myChart = echarts.init(chartDom);
  let option = getPie3D(data, 0.8);
  myChart.clear();
  option && myChart.setOption(option);
  myChart.resize({
    animation: {
      duration: 2800,
      easing: "cubicInOut",
      // delay: 500,
    },
  });
  window.onresize = () => {
    myChart.resize();
  };
};

// 配置逻辑-------------------------------------
let setDialog2 = ref(false);
let eleFormData = ref({
  electricity: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  },
  absorb: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  },
  demandQuantityJson: {
    dictKey: "",
    deviceIdStr: "",
  },
  powerSupplyJson: {
    dictKey: "",
    deviceIdStr: "",
  },
  blockId: 2,
});
const setDialogClick2 = function () {
  getKanbanDataDetailApi({
    moduleId: props.projectModuleId,
    templateId: props.templateId,
    blockId: 2,
  })
    .then((res) => {
      if (res.data.code == 200) {
        setDialog2.value = true;
        let data = JSON.parse(JSON.stringify(res.data.data.electricAnalysis.detail));
        if (data.length === 0 || !data[0].detailId) {
          eleFormData.value.absorb.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          eleFormData.value.electricity.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
        } else {
          eleFormData.value.electricity = data.filter((item) => item.detailId == 17)[0];
          eleFormData.value.absorb = data.filter((item) => item.detailId == 20)[0];
          if (!eleFormData.value.electricity.items) {
            eleFormData.value.electricity.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!eleFormData.value.absorb.items) {
            eleFormData.value.absorb.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }

          // 下拉框数据
          deviceDictList.value[2] = [
            {
              dictKey: data.filter((item) => item.detailId == 4)[0].items[0].dictKey,
              dictName: data.filter((item) => item.detailId == 4)[0].items[0].dictName,
              deviceIdStr: data.filter((item) => item.detailId == 4)[0].items[0].deviceIdStr,
              deviceName: data.filter((item) => item.detailId == 4)[0].items[0].deviceName,
            },
          ];
          deviceDictList.value[3] = [
            {
              dictKey: data.filter((item) => item.detailId == 18)[0].items[0].dictKey,
              dictName: data.filter((item) => item.detailId == 18)[0].items[0].dictName,
              deviceIdStr: data.filter((item) => item.detailId == 18)[0].items[0].deviceIdStr,
              deviceName: data.filter((item) => item.detailId == 18)[0].items[0].deviceName,
            },
          ];
          setTimeout(() => {
            // 下拉框绑定数据
            eleFormData.value.demandQuantityJson = {
              dictKey: [data.filter((item) => item.detailId == 4)[0].items[0].dictKey],
              dictName: data.filter((item) => item.detailId == 4)[0].items[0].dictName,
              deviceIdStr: data.filter((item) => item.detailId == 4)[0].items[0].deviceIdStr,
              deviceName: data.filter((item) => item.detailId == 4)[0].items[0].deviceName,
            };
            eleFormData.value.powerSupplyJson = {
              dictKey: [data.filter((item) => item.detailId == 18)[0].items[0].dictKey],
              dictName: data.filter((item) => item.detailId == 18)[0].items[0].dictName,
              deviceIdStr: data.filter((item) => item.detailId == 18)[0].items[0].deviceIdStr,
              deviceName: data.filter((item) => item.detailId == 18)[0].items[0].deviceName,
            };
            console.log("setDialogClick2 data", data);

            console.log("setDialogClick2 demandQuantityJson", eleFormData.value.demandQuantityJson);
            console.log("setDialogClick2 powerSupplyJson", eleFormData.value.powerSupplyJson);
          }, 500);
        }
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
// 配置提交
const setDialogSubmit2 = function () {
  let data = JSON.parse(JSON.stringify(eleFormData.value));

  // 处理符号和字母
  for (let i = 0; i < data.electricity.items.length; i++) {
    data.electricity.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.electricity.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.electricity.formula = data.electricity.formula.substr(0, i) + letterList()[i / 2].name + data.electricity.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.absorb.items.length; i++) {
    data.absorb.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.absorb.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.absorb.formula = data.absorb.formula.substr(0, i) + letterList()[i / 2].name + data.absorb.formula.substr(i + 1);
    }
  }
  // 改成接口需要的格式
  let json = {
    electricAnalysis: {
      blockId: 2,
      detail: [
        {
          detailId: 4,
          formula: "A",
          title: "需量",
          items: [
            {
              dictKey: data.demandQuantityJson.dictKey[0],
              dictName: data.demandQuantityJson.dictName,
              deviceIdStr: data.demandQuantityJson.deviceIdStr,
              deviceName: data.demandQuantityJson.deviceName,
              name: "A",
            },
          ],
        },
        {
          detailId: 18,
          formula: "A",
          title: "电网供电",
          items: [
            {
              dictKey: data.powerSupplyJson.dictKey[0],
              dictName: data.powerSupplyJson.dictName,
              deviceIdStr: data.powerSupplyJson.deviceIdStr,
              deviceName: data.powerSupplyJson.deviceName,
              name: "A",
            },
          ],
        },
        data.electricity,
        data.absorb,
      ],
    },
    moduleId: Number(props.projectModuleId),
    templateId: props.templateId,
  };
  saveKanbanDataApi(json)
    .then((res) => {
      if (res.data.code == 200) {
        setDialog2.value = false;
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

// 新能源情况分析**************************************************************************
// 配置逻辑-------------------------------------
let setDialog3 = ref(false);
let newEnergyPowerGeneration = ref({
  electricity: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  },
  selfElectricity: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  },
  internetElectricity: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  },
});
const setDialogClick3 = function () {
  getKanbanDataDetailApi({
    moduleId: props.projectModuleId,
    templateId: props.templateId,
    blockId: 3,
  })
    .then((res) => {
      if (res.data.code == 200) {
        setDialog3.value = true;
        let data = JSON.parse(JSON.stringify(res.data.data.newEnergy.detail));
        if (data.length === 0 || !data[0].detailId) {
          newEnergyPowerGeneration.value.electricity.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          newEnergyPowerGeneration.value.selfElectricity.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          newEnergyPowerGeneration.value.internetElectricity.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
        } else {
          newEnergyPowerGeneration.value.electricity = data.filter((item) => item.detailId == 25)[0];
          newEnergyPowerGeneration.value.selfElectricity = data.filter((item) => item.detailId == 26)[0];
          newEnergyPowerGeneration.value.internetElectricity = data.filter((item) => item.detailId == 27)[0];
          if (!newEnergyPowerGeneration.value.electricity.items) {
            newEnergyPowerGeneration.value.electricity.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!newEnergyPowerGeneration.value.selfElectricity.items) {
            newEnergyPowerGeneration.value.selfElectricity.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!newEnergyPowerGeneration.value.internetElectricity.items) {
            newEnergyPowerGeneration.value.internetElectricity.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
        }
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
// 配置提交
const setDialogSubmit3 = function () {
  let data = JSON.parse(JSON.stringify(newEnergyPowerGeneration.value));
  // 处理符号和字母
  for (let i = 0; i < data.electricity.items.length; i++) {
    data.electricity.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.electricity.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.electricity.formula = data.electricity.formula.substr(0, i) + letterList()[i / 2].name + data.electricity.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.selfElectricity.items.length; i++) {
    data.selfElectricity.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.selfElectricity.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.selfElectricity.formula = data.selfElectricity.formula.substr(0, i) + letterList()[i / 2].name + data.selfElectricity.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.internetElectricity.items.length; i++) {
    data.internetElectricity.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.internetElectricity.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.internetElectricity.formula = data.internetElectricity.formula.substr(0, i) + letterList()[i / 2].name + data.internetElectricity.formula.substr(i + 1);
    }
  }
  let json = {
    newEnergy: {
      blockId: 3,
      detail: [data.electricity, data.selfElectricity, data.internetElectricity],
    },
    moduleId: Number(props.projectModuleId),
    templateId: props.templateId,
  };
  saveKanbanDataApi(json)
    .then((res) => {
      if (res.data.code == 200) {
        setDialog3.value = false;
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

// 运行功率曲线**************************************************************************
// 功率曲线图表
const lineChartLoad1 = function () {
  var chartDom = document.querySelector(".lineChartRef1");
  var myChart = echarts.init(chartDom);
  let option = {
    title: {
      text: "kW",
      left: 16,
      top: 4,
      textStyle: {
        fontSize: 10,
        fontWeight: 300,
      },
    },
    legend: {
      show: true,
      icon: "rect",
      right: 10,
      itemWidth: 10,
      itemHeight: 10,
      // textStyle: {
      //   color: '#048CB5'
      // }
    },
    grid: {
      left: 50,
      top: 40,
      bottom: 40,
      right: 30,
    },
    tooltip: {
      trigger: "axis", // axis   item   none三个值
      show: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      axisLabel: {
        textStyle: {
          fontWeight: 400,
          color: "#405873",
        },
      },
      data: pageData.value.operatingPowerChar.xAxis,
    },
    yAxis: {
      type: "value",
      // min: 120000,
      // min: Number(Math.min.apply(null, data.value.powerList)) - Number(Math.min.apply(null, data.value.powerList)) % 10000,
      splitLine: {
        show: true,
        lineStyle: {
          color: ["rgba(62, 122, 248, 0.12)"],
        },
      },
      axisLabel: {
        textStyle: {
          color: "#405873",
        },
      },
    },
    color: ["#00F6FF", "#0A7DFA", "#F48700", "#0BD543"],
    series: [
      {
        name: "负荷",
        type: "line",
        smooth: true,
        symbolSize: 0,
        data:
          pageData.value.operatingPowerChar.series && pageData.value.operatingPowerChar.series.filter((item) => item.name === "负荷运行功率").length > 0
            ? pageData.value.operatingPowerChar.series.filter((item) => item.name === "负荷运行功率")[0].data
            : [],
        lineStyle: {
          width: 1,
        },
      },
      {
        name: "储能",
        type: "line",
        smooth: true,
        symbolSize: 0,
        data:
          pageData.value.operatingPowerChar.series && pageData.value.operatingPowerChar.series.filter((item) => item.name === "储能运行功率").length > 0
            ? pageData.value.operatingPowerChar.series.filter((item) => item.name === "储能运行功率")[0].data
            : [],
        lineStyle: {
          width: 1,
        },
      },
      {
        name: "市电",
        type: "line",
        smooth: true,
        symbolSize: 0,
        data:
          pageData.value.operatingPowerChar.series && pageData.value.operatingPowerChar.series.filter((item) => item.name === "市电运行功率").length > 0
            ? pageData.value.operatingPowerChar.series.filter((item) => item.name === "市电运行功率")[0].data
            : [],
        lineStyle: {
          width: 1,
        },
      },
      {
        name: "新能源",
        type: "line",
        smooth: true,
        symbolSize: 0,
        data:
          pageData.value.operatingPowerChar.series && pageData.value.operatingPowerChar.series.filter((item) => item.name === "新能源运行功率").length > 0
            ? pageData.value.operatingPowerChar.series.filter((item) => item.name === "新能源运行功率")[0].data
            : [],
        lineStyle: {
          width: 1,
        },
      },
    ],
  };
  myChart.clear();
  option && myChart.setOption(option);
  myChart.resize({
    animation: {
      duration: 2800,
      easing: "cubicInOut",
      // delay: 500,
    },
  });
  window.onresize = () => {
    myChart.resize();
  };
};

// 配置逻辑-------------------------------------
let setDialog4 = ref(false);
let operatingPower = ref({
  load: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  },
  energyStorage: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  },
  municipalElectricity: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  },
  newEnergy: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  },
});
const setDialogClick4 = function () {
  getKanbanDataDetailApi({
    moduleId: props.projectModuleId,
    templateId: props.templateId,
    blockId: 4,
  })
    .then((res) => {
      if (res.data.code == 200) {
        setDialog4.value = true;
        let data = JSON.parse(JSON.stringify(res.data.data.operatingPowerChar.detail));
        if (data.length === 0 || !data[0].detailId) {
          operatingPower.value.load.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          operatingPower.value.energyStorage.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          operatingPower.value.municipalElectricity.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          operatingPower.value.newEnergy.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
        } else {
          operatingPower.value.load = data.filter((item) => item.detailId == 29)[0];
          operatingPower.value.energyStorage = data.filter((item) => item.detailId == 30)[0];
          operatingPower.value.municipalElectricity = data.filter((item) => item.detailId == 31)[0];
          operatingPower.value.newEnergy = data.filter((item) => item.detailId == 32)[0];
          if (!operatingPower.value.load.items) {
            operatingPower.value.load.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!operatingPower.value.energyStorage.items) {
            operatingPower.value.energyStorage.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!operatingPower.value.municipalElectricity.items) {
            operatingPower.value.municipalElectricity.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!operatingPower.value.newEnergy.items) {
            operatingPower.value.newEnergy.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
        }
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
// 配置提交
const setDialogSubmit4 = function () {
  let data = JSON.parse(JSON.stringify(operatingPower.value));
  // 处理符号和字母
  for (let i = 0; i < data.load.items.length; i++) {
    data.load.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.load.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.load.formula = data.load.formula.substr(0, i) + letterList()[i / 2].name + data.load.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.energyStorage.items.length; i++) {
    data.energyStorage.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.energyStorage.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.energyStorage.formula = data.energyStorage.formula.substr(0, i) + letterList()[i / 2].name + data.energyStorage.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.municipalElectricity.items.length; i++) {
    data.municipalElectricity.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.municipalElectricity.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.municipalElectricity.formula = data.municipalElectricity.formula.substr(0, i) + letterList()[i / 2].name + data.municipalElectricity.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.newEnergy.items.length; i++) {
    data.newEnergy.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.newEnergy.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.newEnergy.formula = data.newEnergy.formula.substr(0, i) + letterList()[i / 2].name + data.newEnergy.formula.substr(i + 1);
    }
  }

  let json = {
    operatingPowerChar: {
      blockId: 4,
      detail: [data.load, data.energyStorage, data.municipalElectricity, data.newEnergy],
    },
    moduleId: Number(props.projectModuleId),
    templateId: props.templateId,
  };
  saveKanbanDataApi(json)
    .then((res) => {
      if (res.data.code == 200) {
        setDialog4.value = false;
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

// 近7日费用对比**************************************************************************
// 费用对比图表
const barChartLoad1 = function () {
  var chartDom = document.querySelector(".barChartRef1");
  var myChart = echarts.init(chartDom);
  let option = {
    title: {
      text: "元",
      left: 16,
      top: 4,
      textStyle: {
        fontSize: 10,
        fontWeight: 300,
      },
    },
    legend: {
      show: true,
      icon: "rect",
      right: 10,
      itemWidth: 10,
      itemHeight: 10,
    },
    grid: {
      left: 50,
      top: 40,
      bottom: 40,
      right: 30,
    },
    tooltip: {
      trigger: "axis", // axis   item   none三个值
      show: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: true,
      axisLabel: {
        textStyle: {
          fontWeight: 400,
          color: "#405873",
        },
      },
      data: pageData.value.last7DayFeeChar.xAxis,
    },
    yAxis: {
      type: "value",
      // min: 120000,
      // min: Number(Math.min.apply(null, data.value.powerList)) - Number(Math.min.apply(null, data.value.powerList)) % 10000,
      splitLine: {
        show: true,
        lineStyle: {
          color: ["rgba(62, 122, 248, 0.12)"],
        },
      },
      axisLabel: {
        textStyle: {
          color: "#405873",
        },
      },
    },
    series: [
      {
        name: "优化前",
        type: "bar",
        data:
          pageData.value.last7DayFeeChar.series && pageData.value.last7DayFeeChar.series.filter((item) => item.name === "费用优化前").length > 0
            ? pageData.value.last7DayFeeChar.series.filter((item) => item.name === "费用优化前")[0].data
            : [],
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(255, 165, 0, 1)",
          },
          {
            offset: 1,
            color: "rgba(255, 165, 0, 0)",
          },
        ]),
      },
      {
        name: "优化后",
        type: "bar",
        data:
          pageData.value.last7DayFeeChar.series && pageData.value.last7DayFeeChar.series.filter((item) => item.name === "费用优化后").length > 0
            ? pageData.value.last7DayFeeChar.series.filter((item) => item.name === "费用优化后")[0].data
            : [],
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(0, 251, 255, 1)",
          },
          {
            offset: 1,
            color: "rgba(0, 251, 255, 0)",
          },
        ]),
      },
    ],
  };
  myChart.clear();
  option && myChart.setOption(option);
  myChart.resize({
    animation: {
      duration: 2800,
      easing: "cubicInOut",
      // delay: 500,
    },
  });
  window.onresize = () => {
    myChart.resize();
  };
};

// 配置逻辑
// 配置逻辑-------------------------------------
let setDialog5 = ref(false);
let costFormData = ref({
  equipmentIdJson: [],
  optimizationBefore: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  },
  optimizationAfter: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  },
});
const setDialogClick5 = function () {
  getKanbanDataDetailApi({
    moduleId: props.projectModuleId,
    templateId: props.templateId,
    blockId: 5,
  })
    .then((res) => {
      if (res.data.code == 200) {
        setDialog5.value = true;
        let data = JSON.parse(JSON.stringify(res.data.data.last7DayFeeChar.detail));
        if (data.length === 0 || !data[0].detailId) {
          costFormData.value.optimizationBefore.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          costFormData.value.optimizationAfter.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
        } else {
          costFormData.value.optimizationBefore = data.filter((item) => item.detailId == 33)[0];
          costFormData.value.optimizationAfter = data.filter((item) => item.detailId == 34)[0];
          if (!costFormData.value.optimizationBefore.items) {
            costFormData.value.optimizationBefore.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!costFormData.value.optimizationAfter.items) {
            costFormData.value.optimizationAfter.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
        }
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
// 配置提交
const setDialogSubmit5 = function () {
  let data = JSON.parse(JSON.stringify(costFormData.value));
  // 处理符号和字母
  for (let i = 0; i < data.optimizationBefore.items.length; i++) {
    data.optimizationBefore.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.optimizationBefore.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.optimizationBefore.formula = data.optimizationBefore.formula.substr(0, i) + letterList()[i / 2].name + data.optimizationBefore.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.optimizationAfter.items.length; i++) {
    data.optimizationAfter.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.optimizationAfter.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.optimizationAfter.formula = data.optimizationAfter.formula.substr(0, i) + letterList()[i / 2].name + data.optimizationAfter.formula.substr(i + 1);
    }
  }

  let json = {
    operatingPowerChar: {
      blockId: 5,
      detail: [data.optimizationBefore, data.optimizationAfter],
    },
    moduleId: Number(props.projectModuleId),
    templateId: props.templateId,
  };
  saveKanbanDataApi(json)
    .then((res) => {
      if (res.data.code == 200) {
        setDialog5.value = false;
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
// 新能源社会效益**************************************************************************

// 中上部分累计数据**************************************************************************
let countStart1 = ref(0);
let countStart2 = ref(0);
let countStart3 = ref(0);
let countStart4 = ref(0);

// 中间板块数据**************************************************************************
// 中间板块配置------------------------------
let setDialog6 = ref(false);
let centerFormData = ref({
  newEnergyProportionA: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //新能源占比值A
  newEnergyProportionB: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //新能源占比值B
  photovoltaicPowerGenerationCapacity: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //光伏发电功率
  photovoltaicPowerGeneration: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //光伏日发电量
  photovoltaicRevenue: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //光伏日收益
  internetPower: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //上网功率
  downInternetPower: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //下网功率
  internetPowerConsumption: {
    dictKey: "",
    equipmentId: "",
  }, //上网电量
  downInternetPowerConsumption: {
    dictKey: "",
    equipmentId: "",
  }, //下网电量
  energyStorageChargingPower: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //储能充电功率
  energyStorageDischargePower: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //储能放电功率
  energyRevenue: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //储能收益
  energyStorageSOC: {
    dictKey: "",
    equipmentId: "",
  }, //储能SOC
  chargingPilePower: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //充电桩功率
  chargingPileChargingCapacity: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //充电桩日充电量
  demandQuantityA: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //当月降低需量值A
  demandQuantityB: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //当月降低需量值B
  price: "", //单价
  beforeInvestmentCost: "", //用电成本投入前
  afterInvestmentCost: "", //用电成本投入后
  startRunTime: "", //运行时间
  electricityLoad: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  }, //用电负荷
});
const setDialogClick6 = function () {
  setDialog6.value = true;
  getKanbanDataDetailApi({
    moduleId: props.projectModuleId,
    templateId: props.templateId,
    blockId: 7,
  })
    .then((res) => {
      if (res.data.code == 200) {
        let data = JSON.parse(JSON.stringify(res.data.data.middleInfo.detail));
        if (data.length === 0 || !data[0].detailId) {
          centerFormData.value.newEnergyProportionA.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          centerFormData.value.newEnergyProportionB.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          centerFormData.value.photovoltaicPowerGenerationCapacity.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          centerFormData.value.photovoltaicPowerGeneration.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          centerFormData.value.internetPower.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          centerFormData.value.downInternetPower.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          centerFormData.value.energyStorageChargingPower.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          centerFormData.value.energyStorageDischargePower.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          centerFormData.value.chargingPilePower.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          centerFormData.value.chargingPileChargingCapacity.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          centerFormData.value.electricityLoad.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          centerFormData.value.demandQuantityA.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          centerFormData.value.demandQuantityB.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
        } else {
          centerFormData.value.beforeInvestmentCost = res.data.data.middleInfo.beforeInvestmentCost;
          centerFormData.value.afterInvestmentCost = res.data.data.middleInfo.afterInvestmentCost;
          centerFormData.value.price = res.data.data.middleInfo.price;
          centerFormData.value.startRunTime = res.data.data.middleInfo.startRunTime;
          // 新能源占比
          centerFormData.value.newEnergyProportionA = data.filter((item) => item.detailId == 37)[0];
          centerFormData.value.newEnergyProportionB = data.filter((item) => item.detailId == 38)[0];
          // 光伏
          centerFormData.value.photovoltaicPowerGenerationCapacity = data.filter((item) => item.detailId == 39)[0];
          centerFormData.value.photovoltaicPowerGeneration = data.filter((item) => item.detailId == 40)[0];
          centerFormData.value.photovoltaicRevenue = data.filter((item) => item.detailId == 41)[0];
          if (centerFormData.value.photovoltaicRevenue.items && centerFormData.value.photovoltaicRevenue.items.length > 0) {
            for (let i = 0; i < centerFormData.value.photovoltaicRevenue.items.length; i++) {
              centerFormData.value.photovoltaicRevenue.items[i].deviceId = String(centerFormData.value.photovoltaicRevenue.items[i].deviceId);
            }
          } else {
            centerFormData.value.photovoltaicRevenue.items = [
              {
                deviceId: null,
              },
            ];
          }

          // 市电---上下网功率
          centerFormData.value.internetPower = data.filter((item) => item.detailId == 44)[0];
          centerFormData.value.downInternetPower = data.filter((item) => item.detailId == 45)[0];
          // 市电---上下网电量
          if (data.filter((item) => item.detailId == 46)[0] && data.filter((item) => item.detailId == 46)[0].items) {
            // 市电---上下网电量---下拉框绑定数据
            centerFormData.value.internetPowerConsumption = {
              dictKey: [data.filter((item) => item.detailId == 46)[0].items[0].dictKey],
              dictName: data.filter((item) => item.detailId == 46)[0].items[0].dictName,
              deviceIdStr: data.filter((item) => item.detailId == 46)[0].items[0].deviceIdStr,
              deviceName: data.filter((item) => item.detailId == 46)[0].items[0].deviceName,
            };
            // 市电---上下网电量---下拉框数据
            deviceDictList.value[13] = [
              {
                dictKey: data.filter((item) => item.detailId == 46)[0].items[0].dictKey,
                dictName: data.filter((item) => item.detailId == 46)[0].items[0].dictName,
                deviceIdStr: data.filter((item) => item.detailId == 46)[0].items[0].deviceIdStr,
                deviceName: data.filter((item) => item.detailId == 46)[0].items[0].deviceName,
              },
            ];
          }
          if (data.filter((item) => item.detailId == 47)[0] && data.filter((item) => item.detailId == 47)[0].items) {
            // 市电---上下网电量---下拉框绑定数据
            centerFormData.value.downInternetPowerConsumption = {
              dictKey: [data.filter((item) => item.detailId == 47)[0].items[0].dictKey],
              dictName: data.filter((item) => item.detailId == 47)[0].items[0].dictName,
              deviceIdStr: data.filter((item) => item.detailId == 47)[0].items[0].deviceIdStr,
              deviceName: data.filter((item) => item.detailId == 47)[0].items[0].deviceName,
            };
            // 市电---上下网电量---下拉框数据
            deviceDictList.value[14] = [
              {
                dictKey: data.filter((item) => item.detailId == 47)[0].items[0].dictKey,
                dictName: data.filter((item) => item.detailId == 47)[0].items[0].dictName,
                deviceIdStr: data.filter((item) => item.detailId == 47)[0].items[0].deviceIdStr,
                deviceName: data.filter((item) => item.detailId == 47)[0].items[0].deviceName,
              },
            ];
          }
          // 储能---充放电功率
          centerFormData.value.energyStorageChargingPower = data.filter((item) => item.detailId == 48)[0];
          centerFormData.value.energyStorageDischargePower = data.filter((item) => item.detailId == 49)[0];
          centerFormData.value.energyRevenue = data.filter((item) => item.detailId == 74)[0];
          if (centerFormData.value.energyRevenue.items && centerFormData.value.energyRevenue.items.length > 0) {
            for (let i = 0; i < centerFormData.value.energyRevenue.items.length; i++) {
              centerFormData.value.energyRevenue.items[i].deviceId = String(centerFormData.value.energyRevenue.items[i].deviceId);
            }
          } else {
            centerFormData.value.energyRevenue.items = [
              {
                deviceId: null,
              },
            ];
          }
          // 储能---SOC
          if (data.filter((item) => item.detailId == 50)[0] && data.filter((item) => item.detailId == 50)[0].items) {
            // 储能---SOC---下拉框绑定数据
            centerFormData.value.energyStorageSOC = {
              dictKey: [data.filter((item) => item.detailId == 50)[0].items[0].dictKey],
              dictName: data.filter((item) => item.detailId == 50)[0].items[0].dictName,
              deviceIdStr: data.filter((item) => item.detailId == 50)[0].items[0].deviceIdStr,
              deviceName: data.filter((item) => item.detailId == 50)[0].items[0].deviceName,
            };
            //储能---SOC---下拉框数据
            deviceDictList.value[16] = [
              {
                dictKey: data.filter((item) => item.detailId == 50)[0].items[0].dictKey,
                dictName: data.filter((item) => item.detailId == 50)[0].items[0].dictName,
                deviceIdStr: data.filter((item) => item.detailId == 50)[0].items[0].deviceIdStr,
                deviceName: data.filter((item) => item.detailId == 50)[0].items[0].deviceName,
              },
            ];
          }
          // 充电桩---功率和日充电量
          centerFormData.value.chargingPilePower = data.filter((item) => item.detailId == 51)[0];
          centerFormData.value.chargingPileChargingCapacity = data.filter((item) => item.detailId == 52)[0];
          // 用电负荷
          centerFormData.value.electricityLoad = data.filter((item) => item.detailId == 54)[0];
          // 需量---需量AB值
          centerFormData.value.demandQuantityA = data.filter((item) => item.detailId == 55)[0];
          centerFormData.value.demandQuantityB = data.filter((item) => item.detailId == 56)[0];

          if (!centerFormData.value.newEnergyProportionA.items) {
            centerFormData.value.newEnergyProportionA.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.newEnergyProportionB.items) {
            centerFormData.value.newEnergyProportionB.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.photovoltaicPowerGenerationCapacity.items) {
            centerFormData.value.photovoltaicPowerGenerationCapacity.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.photovoltaicPowerGeneration.items) {
            centerFormData.value.photovoltaicPowerGeneration.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.photovoltaicRevenue.items) {
            centerFormData.value.photovoltaicRevenue.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.internetPower.items) {
            centerFormData.value.internetPower.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.downInternetPower.items) {
            centerFormData.value.downInternetPower.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.internetPowerConsumption.items) {
            centerFormData.value.internetPowerConsumption.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.downInternetPowerConsumption.items) {
            centerFormData.value.downInternetPowerConsumption.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.energyStorageChargingPower.items) {
            centerFormData.value.energyStorageChargingPower.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.energyStorageDischargePower.items) {
            centerFormData.value.energyStorageDischargePower.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.energyRevenue.items) {
            centerFormData.value.energyRevenue.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.energyStorageSOC.items) {
            centerFormData.value.energyStorageSOC.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.chargingPilePower.items) {
            centerFormData.value.chargingPilePower.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.chargingPileChargingCapacity.items) {
            centerFormData.value.chargingPileChargingCapacity.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.electricityLoad.items) {
            centerFormData.value.electricityLoad.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.demandQuantityA.items) {
            centerFormData.value.demandQuantityA.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!centerFormData.value.demandQuantityB.items) {
            centerFormData.value.demandQuantityB.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
        }
        setDialog6.value = true;
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
// 配置提交
const setDialogSubmit6 = function () {
  let data = JSON.parse(JSON.stringify(centerFormData.value));
  // 处理符号和字母--------------------
  // 新能源占比
  for (let i = 0; i < data.newEnergyProportionA.items.length; i++) {
    data.newEnergyProportionA.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.newEnergyProportionA.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.newEnergyProportionA.formula = data.newEnergyProportionA.formula.substr(0, i) + letterList()[i / 2].name + data.newEnergyProportionA.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.newEnergyProportionB.items.length; i++) {
    data.newEnergyProportionB.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.newEnergyProportionB.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.newEnergyProportionB.formula = data.newEnergyProportionB.formula.substr(0, i) + letterList()[i / 2].name + data.newEnergyProportionB.formula.substr(i + 1);
    }
  }
  // 光伏
  for (let i = 0; i < data.photovoltaicPowerGenerationCapacity.items.length; i++) {
    data.photovoltaicPowerGenerationCapacity.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.photovoltaicPowerGenerationCapacity.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.photovoltaicPowerGenerationCapacity.formula =
        data.photovoltaicPowerGenerationCapacity.formula.substr(0, i) + letterList()[i / 2].name + data.photovoltaicPowerGenerationCapacity.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.photovoltaicPowerGeneration.items.length; i++) {
    data.photovoltaicPowerGeneration.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.photovoltaicPowerGeneration.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.photovoltaicPowerGeneration.formula = data.photovoltaicPowerGeneration.formula.substr(0, i) + letterList()[i / 2].name + data.photovoltaicPowerGeneration.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.photovoltaicRevenue.items.length; i++) {
    data.photovoltaicRevenue.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.photovoltaicRevenue.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.photovoltaicRevenue.formula = data.photovoltaicRevenue.formula.substr(0, i) + letterList()[i / 2].name + data.photovoltaicRevenue.formula.substr(i + 1);
    }
  }
  // 市电
  for (let i = 0; i < data.internetPower.items.length; i++) {
    data.internetPower.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.internetPower.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.internetPower.formula = data.internetPower.formula.substr(0, i) + letterList()[i / 2].name + data.internetPower.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.downInternetPower.items.length; i++) {
    data.downInternetPower.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.downInternetPower.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.downInternetPower.formula = data.downInternetPower.formula.substr(0, i) + letterList()[i / 2].name + data.downInternetPower.formula.substr(i + 1);
    }
  }
  // 储能
  for (let i = 0; i < data.energyStorageChargingPower.items.length; i++) {
    data.energyStorageChargingPower.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.energyStorageChargingPower.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.energyStorageChargingPower.formula = data.energyStorageChargingPower.formula.substr(0, i) + letterList()[i / 2].name + data.energyStorageChargingPower.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.energyStorageDischargePower.items.length; i++) {
    data.energyStorageDischargePower.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.energyStorageDischargePower.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.energyStorageDischargePower.formula = data.energyStorageDischargePower.formula.substr(0, i) + letterList()[i / 2].name + data.energyStorageDischargePower.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.energyRevenue.items.length; i++) {
    data.energyRevenue.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.energyRevenue.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.energyRevenue.formula = data.energyRevenue.formula.substr(0, i) + letterList()[i / 2].name + data.energyRevenue.formula.substr(i + 1);
    }
  }
  // 充电桩
  for (let i = 0; i < data.chargingPilePower.items.length; i++) {
    data.chargingPilePower.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.chargingPilePower.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.chargingPilePower.formula = data.chargingPilePower.formula.substr(0, i) + letterList()[i / 2].name + data.chargingPilePower.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.chargingPileChargingCapacity.items.length; i++) {
    data.chargingPileChargingCapacity.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.chargingPileChargingCapacity.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.chargingPileChargingCapacity.formula = data.chargingPileChargingCapacity.formula.substr(0, i) + letterList()[i / 2].name + data.chargingPileChargingCapacity.formula.substr(i + 1);
    }
  }
  // 用电负荷
  for (let i = 0; i < data.electricityLoad.items.length; i++) {
    data.electricityLoad.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.electricityLoad.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.electricityLoad.formula = data.electricityLoad.formula.substr(0, i) + letterList()[i / 2].name + data.electricityLoad.formula.substr(i + 1);
    }
  }
  // 需量
  for (let i = 0; i < data.demandQuantityA.items.length; i++) {
    data.demandQuantityA.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.demandQuantityA.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.demandQuantityA.formula = data.demandQuantityA.formula.substr(0, i) + letterList()[i / 2].name + data.demandQuantityA.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.demandQuantityB.items.length; i++) {
    data.demandQuantityB.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.demandQuantityB.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.demandQuantityB.formula = data.demandQuantityB.formula.substr(0, i) + letterList()[i / 2].name + data.demandQuantityB.formula.substr(i + 1);
    }
  }

  let json = {
    middleInfo: {
      blockId: 7,
      detail: [
        data.newEnergyProportionA,
        data.newEnergyProportionB,
        data.photovoltaicPowerGenerationCapacity,
        data.photovoltaicPowerGeneration,
        data.photovoltaicRevenue,
        data.internetPower,
        data.downInternetPower,
        data.energyStorageChargingPower,
        data.energyStorageDischargePower,
        data.energyRevenue,
        data.chargingPilePower,
        data.chargingPileChargingCapacity,
        data.electricityLoad,
        data.demandQuantityA,
        data.demandQuantityB,
        {
          detailId: 46,
          formula: "A",
          title: "上网电量",
          items: [
            {
              dictKey: data.internetPowerConsumption.dictKey[0],
              dictName: data.internetPowerConsumption.dictName,
              deviceIdStr: data.internetPowerConsumption.deviceIdStr,
              deviceName: data.internetPowerConsumption.deviceName,
              name: "A",
            },
          ],
        },
        {
          detailId: 47,
          formula: "A",
          title: "下网电量",
          items: [
            {
              dictKey: data.downInternetPowerConsumption.dictKey[0],
              dictName: data.downInternetPowerConsumption.dictName,
              deviceIdStr: data.downInternetPowerConsumption.deviceIdStr,
              deviceName: data.downInternetPowerConsumption.deviceName,
              name: "A",
            },
          ],
        },
        {
          detailId: 50,
          formula: "A",
          title: "储能SOC",
          items: [
            {
              dictKey: data.energyStorageSOC.dictKey[0],
              dictName: data.energyStorageSOC.dictName,
              deviceId: data.energyStorageSOC.deviceId,
              deviceIdStr: data.energyStorageSOC.deviceIdStr,
              deviceName: data.energyStorageSOC.deviceName,
              name: "A",
            },
          ],
        },
      ],
      price: data.price,
      startRunTime: data.startRunTime,
      beforeInvestmentCost: data.beforeInvestmentCost,
      afterInvestmentCost: data.afterInvestmentCost,
    },
    moduleId: Number(props.projectModuleId),
    templateId: props.templateId,
  };
  saveKanbanDataApi(json)
    .then((res) => {
      if (res.data.code == 200) {
        setDialog6.value = false;
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

// 中下部分电力需求曲线**************************************************************************
// 电力需求曲线图表
const lineChartLoad2 = function () {
  var chartDom = document.querySelector(".lineChartRef2");
  var myChart = echarts.init(chartDom);
  let option = {
    title: {
      text: "kW",
      left: 16,
      top: 4,
      textStyle: {
        fontSize: 10,
        fontWeight: 300,
      },
    },
    legend: {
      show: true,
      icon: "rect",
      right: 10,
      itemWidth: 10,
      itemHeight: 10,
      // textStyle: {
      //   color: '#048CB5'
      // }
    },
    grid: {
      left: 50,
      top: 40,
      bottom: 40,
      right: 30,
    },
    tooltip: {
      trigger: "axis", // axis   item   none三个值
      show: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      axisLabel: {
        textStyle: {
          fontWeight: 400,
          color: "#405873",
        },
      },
      data: pageData.value.powerDemandChar.xAxis,
    },
    yAxis: {
      type: "value",
      // min: 120000,
      // min: Number(Math.min.apply(null, data.value.powerList)) - Number(Math.min.apply(null, data.value.powerList)) % 10000,
      splitLine: {
        show: true,
        lineStyle: {
          color: ["rgba(62, 122, 248, 0.12)"],
        },
      },
      axisLabel: {
        textStyle: {
          color: "#405873",
        },
      },
    },
    color: ["#F48700", "#00D8F4"],
    series: [
      {
        name: "优化前",
        type: "line",
        smooth: true,
        symbolSize: 0,
        data:
          pageData.value.powerDemandChar.series && pageData.value.powerDemandChar.series.filter((item) => item.name === "电力需求优化前").length > 0
            ? pageData.value.powerDemandChar.series.filter((item) => item.name === "电力需求优化前")[0].data
            : [],
        lineStyle: {
          width: 1,
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgba(244, 135, 0, 0.40)",
            },
            {
              offset: 1,
              color: "rgba(244, 135, 0, 0)",
            },
          ]),
        },
      },
      {
        name: "优化后",
        type: "line",
        smooth: true,
        symbolSize: 0,
        data:
          pageData.value.powerDemandChar.series && pageData.value.powerDemandChar.series.filter((item) => item.name === "电力需求优化后").length > 0
            ? pageData.value.powerDemandChar.series.filter((item) => item.name === "电力需求优化后")[0].data
            : [],
        lineStyle: {
          width: 1,
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgba(0, 216, 244, 0.60)",
            },
            {
              offset: 1,
              color: "rgba(0, 216, 244, 0.20)",
            },
          ]),
        },
      },
    ],
  };
  myChart.clear();
  option && myChart.setOption(option);
  myChart.resize({
    animation: {
      duration: 2800,
      easing: "cubicInOut",
      // delay: 500,
    },
  });
  window.onresize = () => {
    myChart.resize();
  };
};

// 配置逻辑-------------------------------------
let setDialog7 = ref(false);
let electricityDemand = ref({
  optimizationBefore: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  },
  optimizationAfter: {
    formula: "A",
    name: "",
    valueType: [],
    items: [
      {
        val: "",
        type: "1",
        unit: "",
        dictKey: "",
        dictName: "",
        name: "A",
        deviceIdStr: "",
        deviceName: "",
      },
    ],
  },
});
const setDialogClick7 = function () {
  getKanbanDataDetailApi({
    moduleId: props.projectModuleId,
    templateId: props.templateId,
    blockId: 6,
  })
    .then((res) => {
      if (res.data.code == 200) {
        setDialog7.value = true;
        let data = JSON.parse(JSON.stringify(res.data.data.powerDemandChar.detail));
        if (data.length === 0 || !data[0].detailId) {
          electricityDemand.value.optimizationBefore.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
          electricityDemand.value.optimizationAfter.items = [
            {
              val: "",
              type: "1",
              unit: "",
              dictKey: "",
              dictName: "",
              name: "A",
              deviceIdStr: "",
              deviceName: "",
            },
          ];
        } else {
          electricityDemand.value.optimizationBefore = data.filter((item) => item.detailId == 35)[0];
          electricityDemand.value.optimizationAfter = data.filter((item) => item.detailId == 36)[0];
          if (!electricityDemand.value.optimizationBefore.items) {
            electricityDemand.value.optimizationBefore.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
          if (!electricityDemand.value.optimizationAfter.items) {
            electricityDemand.value.optimizationAfter.items = [
              {
                val: "",
                type: "1",
                unit: "",
                dictKey: "",
                dictName: "",
                name: "A",
                deviceIdStr: "",
                deviceName: "",
              },
            ];
          }
        }
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
// 配置提交
const setDialogSubmit7 = function () {
  let data = JSON.parse(JSON.stringify(electricityDemand.value));
  // 处理符号和字母
  for (let i = 0; i < data.optimizationBefore.items.length; i++) {
    data.optimizationBefore.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.optimizationBefore.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.optimizationBefore.formula = data.optimizationBefore.formula.substr(0, i) + letterList()[i / 2].name + data.optimizationBefore.formula.substr(i + 1);
    }
  }
  for (let i = 0; i < data.optimizationAfter.items.length; i++) {
    data.optimizationAfter.items[i].name = letterList()[i].name;
  }
  for (let i = 0; i < data.optimizationAfter.formula.length; i++) {
    if (i % 2 == 0 && i !== 0) {
      data.optimizationAfter.formula = data.optimizationAfter.formula.substr(0, i) + letterList()[i / 2].name + data.optimizationAfter.formula.substr(i + 1);
    }
  }

  let json = {
    powerDemandChar: {
      blockId: 6,
      detail: [data.optimizationBefore, data.optimizationAfter],
    },
    moduleId: Number(props.projectModuleId),
    templateId: props.templateId,
  };
  saveKanbanDataApi(json)
    .then((res) => {
      if (res.data.code == 200) {
        setDialog7.value = false;
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

// 设备指标处理***************************************************************************
// 设备-------------------------------------------
let deviceVisible = ref(false); //选择设备的组件弹窗
let equipmentList = ref([]); //选择设备的设备列表
// 点击选择设备
const deviceSelectClick = function () {
  deviceVisible.value = true;
  equipmentList.value = [];
};
const selectDeviceFun = function () {
  deviceVisible.value = true;
};
const deviceVisibleFun = function (data) {
  deviceVisible.value = data;
};
const checkDeviceListFun = function (data) {
  equipmentList.value = data;
};
// 监听设备列表
watch(
  () => equipmentList.value,
  (newVal) => {
    if (setDialog5.value) {
      costFormData.value.equipmentIdJson = [];
      for (let i = 0; i < newVal.length; i++) {
        costFormData.value.equipmentIdJson.push(newVal[i].id);
      }
    } else if (setDialog6.value) {
      centerFormData.value.energyStorageSOC.equipmentIdJson = [];
      for (let i = 0; i < newVal.length; i++) {
        centerFormData.value.energyStorageSOC.equipmentIdJson.push(newVal[i].id);
      }
    }
  },
  { deep: true }
);

// 指标-------------------------------------------
let dictVisible = ref(false); //选择设备的组件弹窗
let dictList = ref([[], [], [], [], [], [], [], [], []]); //选择设备的设备列表
let dictSelectIdx = ref();
// 点击选择设备
const dictSelectClick = function (idx) {
  dictVisible.value = true;
  dictSelectIdx.value = idx;
};
const selectDictFun = function () {
  dictVisible.value = true;
};
const dictVisibleFun = function (data) {
  dictVisible.value = data;
};
const checkDictListFun = function (data) {
  dictList.value[dictSelectIdx.value - 1] = data;
};
watch(
  () => dictList.value,
  (newVal) => {
    if (setDialog2.value) {
      if (dictSelectIdx.value === 1) {
        deviceSetFormData.value.dictJson = [];
        deviceSetFormData.value.dictIdJson = [];
        for (let i = 0; i < newVal[0].length; i++) {
          deviceSetFormData.value.dictJson.push({
            value: newVal[0][i].id,
            key: newVal[0][i].name,
          });
          deviceSetFormData.value.dictIdJson.push(newVal[0][i].id);
        }
      }
    }
  },
  { deep: true }
);

// 设备指标-------------------------------------------
let deviceDictVisible = ref(false); //选择设备的组件弹窗
let deviceDictList = ref([[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]); //选择设备的设备列表
let deviceDictSelectIdx = ref();
let deviceDictSelectIdx2 = ref();
// 点击选择设备
const deviceDictSelectClick = function (idx, idx2) {
  deviceDictVisible.value = true;
  deviceDictSelectIdx.value = idx;
  deviceDictSelectIdx2.value = idx2;
};
const selectDeviceDictFun = function () {
  deviceDictVisible.value = true;
};
const deviceDictVisibleFun = function (data) {
  deviceDictVisible.value = data;
};
const checkDeviceDictListFun = function (data) {
  if (deviceDictSelectIdx2.value !== undefined) {
    deviceDictList.value[deviceDictSelectIdx.value - 1][deviceDictSelectIdx2.value] = JSON.parse(JSON.stringify(data))[0];
  } else {
    deviceDictList.value[deviceDictSelectIdx.value - 1] = JSON.parse(JSON.stringify(data));
  }
};
watch(
  () => deviceDictList.value,
  (newVal) => {
    if (setDialog2.value) {
      if (deviceDictSelectIdx.value === 1) {
        eleFormData.value.electricity.items[deviceDictSelectIdx2.value].dictKey = newVal[0][deviceDictSelectIdx2.value].dictKey;
        eleFormData.value.electricity.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[0][deviceDictSelectIdx2.value].deviceId;
        eleFormData.value.electricity.items[deviceDictSelectIdx2.value].dictName = newVal[0][deviceDictSelectIdx2.value].dictName;
        eleFormData.value.electricity.items[deviceDictSelectIdx2.value].deviceName = newVal[0][deviceDictSelectIdx2.value].deviceName;
        eleFormData.value.electricity.items[deviceDictSelectIdx2.value].unit = newVal[0][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[0]) {
          for (let i = 0; i < eleFormData.value.electricity.items.length; i++) {
            eleFormData.value.electricity.items[i].dictKey = newVal[0][deviceDictSelectIdx2.value].dictKey;
            eleFormData.value.electricity.items[i].dictName = newVal[0][deviceDictSelectIdx2.value].dictName;
            eleFormData.value.electricity.items[i].unit = newVal[0][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 2) {
        eleFormData.value.absorb.items[deviceDictSelectIdx2.value].dictKey = newVal[1][deviceDictSelectIdx2.value].dictKey;
        eleFormData.value.absorb.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[1][deviceDictSelectIdx2.value].deviceId;
        eleFormData.value.absorb.items[deviceDictSelectIdx2.value].dictName = newVal[1][deviceDictSelectIdx2.value].dictName;
        eleFormData.value.absorb.items[deviceDictSelectIdx2.value].deviceName = newVal[1][deviceDictSelectIdx2.value].deviceName;
        eleFormData.value.absorb.items[deviceDictSelectIdx2.value].unit = newVal[1][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[1]) {
          for (let i = 0; i < eleFormData.value.absorb.items.length; i++) {
            eleFormData.value.absorb.items[i].dictKey = newVal[1][deviceDictSelectIdx2.value].dictKey;
            eleFormData.value.absorb.items[i].dictName = newVal[1][deviceDictSelectIdx2.value].dictName;
            eleFormData.value.absorb.items[i].unit = newVal[1][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 3) {
        // eleFormData.value.demandQuantityJson.dictKey = []
        // for (let i = 0; i < newVal[2].length; i++) {
        //   eleFormData.value.demandQuantityJson.dictKey.push(newVal[2][i].dictKey)
        //   eleFormData.value.demandQuantityJson.equipmentId = newVal[2][i].deviceId
        // }
        eleFormData.value.demandQuantityJson.dictKey = [newVal[2][0].dictKey];
        eleFormData.value.demandQuantityJson.deviceIdStr = newVal[2][0].deviceId;
        eleFormData.value.demandQuantityJson.dictName = newVal[2][0].dictName;
        eleFormData.value.demandQuantityJson.deviceName = newVal[2][0].deviceName;
        eleFormData.value.demandQuantityJson.unit = newVal[2][0].unit;
        console.log("deviceDictList watch demandQuantityJson", newVal);
      } else if (deviceDictSelectIdx.value === 4) {
        // eleFormData.value.powerSupplyJson.dictKey = []
        // for (let i = 0; i < newVal[3].length; i++) {
        //   eleFormData.value.powerSupplyJson.dictKey.push(newVal[3][i].dictKey)
        //   eleFormData.value.powerSupplyJson.equipmentId = newVal[3][i].deviceId
        // }
        eleFormData.value.powerSupplyJson.dictKey = [newVal[3][0].dictKey];
        eleFormData.value.powerSupplyJson.deviceIdStr = newVal[3][0].deviceId;
        eleFormData.value.powerSupplyJson.dictName = newVal[3][0].dictName;
        eleFormData.value.powerSupplyJson.deviceName = newVal[3][0].deviceName;
        eleFormData.value.powerSupplyJson.unit = newVal[3][0].unit;
        console.log("deviceDictList watch powerSupplyJson", newVal);
      }
    } else if (setDialog3.value) {
      if (deviceDictSelectIdx.value === 1) {
        newEnergyPowerGeneration.value.electricity.items[deviceDictSelectIdx2.value].dictKey = newVal[0][deviceDictSelectIdx2.value].dictKey;
        newEnergyPowerGeneration.value.electricity.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[0][deviceDictSelectIdx2.value].deviceId;
        newEnergyPowerGeneration.value.electricity.items[deviceDictSelectIdx2.value].dictName = newVal[0][deviceDictSelectIdx2.value].dictName;
        newEnergyPowerGeneration.value.electricity.items[deviceDictSelectIdx2.value].deviceName = newVal[0][deviceDictSelectIdx2.value].deviceName;
        newEnergyPowerGeneration.value.electricity.items[deviceDictSelectIdx2.value].unit = newVal[0][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[0]) {
          for (let i = 0; i < newEnergyPowerGeneration.value.electricity.items.length; i++) {
            newEnergyPowerGeneration.value.electricity.items[i].dictKey = newVal[0][deviceDictSelectIdx2.value].dictKey;
            newEnergyPowerGeneration.value.electricity.items[i].dictName = newVal[0][deviceDictSelectIdx2.value].dictName;
            newEnergyPowerGeneration.value.electricity.items[i].unit = newVal[0][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 2) {
        newEnergyPowerGeneration.value.selfElectricity.items[deviceDictSelectIdx2.value].dictKey = newVal[1][deviceDictSelectIdx2.value].dictKey;
        newEnergyPowerGeneration.value.selfElectricity.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[1][deviceDictSelectIdx2.value].deviceId;
        newEnergyPowerGeneration.value.selfElectricity.items[deviceDictSelectIdx2.value].dictName = newVal[1][deviceDictSelectIdx2.value].dictName;
        newEnergyPowerGeneration.value.selfElectricity.items[deviceDictSelectIdx2.value].deviceName = newVal[1][deviceDictSelectIdx2.value].deviceName;
        newEnergyPowerGeneration.value.selfElectricity.items[deviceDictSelectIdx2.value].unit = newVal[1][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[1]) {
          for (let i = 0; i < newEnergyPowerGeneration.value.selfElectricity.items.length; i++) {
            newEnergyPowerGeneration.value.selfElectricity.items[i].dictKey = newVal[1][deviceDictSelectIdx2.value].dictKey;
            newEnergyPowerGeneration.value.selfElectricity.items[i].dictName = newVal[1][deviceDictSelectIdx2.value].dictName;
            newEnergyPowerGeneration.value.selfElectricity.items[i].unit = newVal[1][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 3) {
        newEnergyPowerGeneration.value.internetElectricity.items[deviceDictSelectIdx2.value].dictKey = newVal[2][deviceDictSelectIdx2.value].dictKey;
        newEnergyPowerGeneration.value.internetElectricity.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[2][deviceDictSelectIdx2.value].deviceId;
        newEnergyPowerGeneration.value.internetElectricity.items[deviceDictSelectIdx2.value].dictName = newVal[2][deviceDictSelectIdx2.value].dictName;
        newEnergyPowerGeneration.value.internetElectricity.items[deviceDictSelectIdx2.value].deviceName = newVal[2][deviceDictSelectIdx2.value].deviceName;
        newEnergyPowerGeneration.value.internetElectricity.items[deviceDictSelectIdx2.value].unit = newVal[2][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[3]) {
          for (let i = 0; i < newEnergyPowerGeneration.value.internetElectricity.items.length; i++) {
            newEnergyPowerGeneration.value.internetElectricity.items[i].dictKey = newVal[2][deviceDictSelectIdx2.value].dictKey;
            newEnergyPowerGeneration.value.internetElectricity.items[i].dictName = newVal[2][deviceDictSelectIdx2.value].dictName;
            newEnergyPowerGeneration.value.internetElectricity.items[i].unit = newVal[2][deviceDictSelectIdx2.value].unit;
          }
        }
      }
    } else if (setDialog4.value) {
      if (deviceDictSelectIdx.value === 1) {
        operatingPower.value.load.items[deviceDictSelectIdx2.value].dictKey = newVal[0][deviceDictSelectIdx2.value].dictKey;
        operatingPower.value.load.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[0][deviceDictSelectIdx2.value].deviceId;
        operatingPower.value.load.items[deviceDictSelectIdx2.value].dictName = newVal[0][deviceDictSelectIdx2.value].dictName;
        operatingPower.value.load.items[deviceDictSelectIdx2.value].deviceName = newVal[0][deviceDictSelectIdx2.value].deviceName;
        operatingPower.value.load.items[deviceDictSelectIdx2.value].unit = newVal[0][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[0]) {
          for (let i = 0; i < operatingPower.value.load.items.length; i++) {
            operatingPower.value.load.items[i].dictKey = newVal[0][deviceDictSelectIdx2.value].dictKey;
            operatingPower.value.load.items[i].dictName = newVal[0][deviceDictSelectIdx2.value].dictName;
            operatingPower.value.load.items[i].unit = newVal[0][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 2) {
        operatingPower.value.energyStorage.items[deviceDictSelectIdx2.value].dictKey = newVal[1][deviceDictSelectIdx2.value].dictKey;
        operatingPower.value.energyStorage.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[1][deviceDictSelectIdx2.value].deviceId;
        operatingPower.value.energyStorage.items[deviceDictSelectIdx2.value].dictName = newVal[1][deviceDictSelectIdx2.value].dictName;
        operatingPower.value.energyStorage.items[deviceDictSelectIdx2.value].deviceName = newVal[1][deviceDictSelectIdx2.value].deviceName;
        operatingPower.value.energyStorage.items[deviceDictSelectIdx2.value].unit = newVal[1][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[1]) {
          for (let i = 0; i < operatingPower.value.energyStorage.items.length; i++) {
            operatingPower.value.energyStorage.items[i].dictKey = newVal[1][deviceDictSelectIdx2.value].dictKey;
            operatingPower.value.energyStorage.items[i].dictName = newVal[1][deviceDictSelectIdx2.value].dictName;
            operatingPower.value.energyStorage.items[i].unit = newVal[1][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 3) {
        operatingPower.value.municipalElectricity.items[deviceDictSelectIdx2.value].dictKey = newVal[2][deviceDictSelectIdx2.value].dictKey;
        operatingPower.value.municipalElectricity.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[2][deviceDictSelectIdx2.value].deviceId;
        operatingPower.value.municipalElectricity.items[deviceDictSelectIdx2.value].dictName = newVal[2][deviceDictSelectIdx2.value].dictName;
        operatingPower.value.municipalElectricity.items[deviceDictSelectIdx2.value].deviceName = newVal[2][deviceDictSelectIdx2.value].deviceName;
        operatingPower.value.municipalElectricity.items[deviceDictSelectIdx2.value].unit = newVal[2][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[2]) {
          for (let i = 0; i < operatingPower.value.municipalElectricity.items.length; i++) {
            operatingPower.value.municipalElectricity.items[i].dictKey = newVal[2][deviceDictSelectIdx2.value].dictKey;
            operatingPower.value.municipalElectricity.items[i].dictName = newVal[2][deviceDictSelectIdx2.value].dictName;
            operatingPower.value.municipalElectricity.items[i].unit = newVal[2][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 4) {
        operatingPower.value.newEnergy.items[deviceDictSelectIdx2.value].dictKey = newVal[3][deviceDictSelectIdx2.value].dictKey;
        operatingPower.value.newEnergy.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[3][deviceDictSelectIdx2.value].deviceId;
        operatingPower.value.newEnergy.items[deviceDictSelectIdx2.value].dictName = newVal[3][deviceDictSelectIdx2.value].dictName;
        operatingPower.value.newEnergy.items[deviceDictSelectIdx2.value].deviceName = newVal[3][deviceDictSelectIdx2.value].deviceName;
        operatingPower.value.newEnergy.items[deviceDictSelectIdx2.value].unit = newVal[3][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[3]) {
          for (let i = 0; i < operatingPower.value.newEnergy.items.length; i++) {
            operatingPower.value.newEnergy.items[i].dictKey = newVal[3][deviceDictSelectIdx2.value].dictKey;
            operatingPower.value.newEnergy.items[i].dictName = newVal[3][deviceDictSelectIdx2.value].dictName;
            operatingPower.value.newEnergy.items[i].unit = newVal[3][deviceDictSelectIdx2.value].unit;
          }
        }
      }
    } else if (setDialog5.value) {
      if (deviceDictSelectIdx.value === 1) {
        costFormData.value.optimizationBefore.items[deviceDictSelectIdx2.value].dictKey = newVal[0][deviceDictSelectIdx2.value].dictKey;
        costFormData.value.optimizationBefore.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[0][deviceDictSelectIdx2.value].deviceId;
        costFormData.value.optimizationBefore.items[deviceDictSelectIdx2.value].dictName = newVal[0][deviceDictSelectIdx2.value].dictName;
        costFormData.value.optimizationBefore.items[deviceDictSelectIdx2.value].deviceName = newVal[0][deviceDictSelectIdx2.value].deviceName;
        costFormData.value.optimizationBefore.items[deviceDictSelectIdx2.value].unit = newVal[0][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[0]) {
          for (let i = 0; i < costFormData.value.optimizationBefore.items.length; i++) {
            costFormData.value.optimizationBefore.items[i].dictKey = newVal[0][deviceDictSelectIdx2.value].dictKey;
            costFormData.value.optimizationBefore.items[i].dictName = newVal[0][deviceDictSelectIdx2.value].dictName;
            costFormData.value.optimizationBefore.items[i].unit = newVal[0][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 2) {
        costFormData.value.optimizationAfter.items[deviceDictSelectIdx2.value].dictKey = newVal[1][deviceDictSelectIdx2.value].dictKey;
        costFormData.value.optimizationAfter.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[1][deviceDictSelectIdx2.value].deviceId;
        costFormData.value.optimizationAfter.items[deviceDictSelectIdx2.value].dictName = newVal[1][deviceDictSelectIdx2.value].dictName;
        costFormData.value.optimizationAfter.items[deviceDictSelectIdx2.value].deviceName = newVal[1][deviceDictSelectIdx2.value].deviceName;
        costFormData.value.optimizationAfter.items[deviceDictSelectIdx2.value].unit = newVal[1][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[1]) {
          for (let i = 0; i < costFormData.value.optimizationAfter.items.length; i++) {
            costFormData.value.optimizationAfter.items[i].dictKey = newVal[1][deviceDictSelectIdx2.value].dictKey;
            costFormData.value.optimizationAfter.items[i].dictName = newVal[1][deviceDictSelectIdx2.value].dictName;
            costFormData.value.optimizationAfter.items[i].unit = newVal[1][deviceDictSelectIdx2.value].unit;
          }
        }
      }
    } else if (setDialog6.value) {
      if (deviceDictSelectIdx.value === 1) {
        centerFormData.value.newEnergyProportionA.items[deviceDictSelectIdx2.value].dictKey = newVal[0][deviceDictSelectIdx2.value].dictKey;
        centerFormData.value.newEnergyProportionA.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[0][deviceDictSelectIdx2.value].deviceId;
        centerFormData.value.newEnergyProportionA.items[deviceDictSelectIdx2.value].dictName = newVal[0][deviceDictSelectIdx2.value].dictName;
        centerFormData.value.newEnergyProportionA.items[deviceDictSelectIdx2.value].deviceName = newVal[0][deviceDictSelectIdx2.value].deviceName;
        centerFormData.value.newEnergyProportionA.items[deviceDictSelectIdx2.value].unit = newVal[0][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[0]) {
          for (let i = 0; i < centerFormData.value.newEnergyProportionA.items.length; i++) {
            centerFormData.value.newEnergyProportionA.items[i].dictKey = newVal[0][deviceDictSelectIdx2.value].dictKey;
            centerFormData.value.newEnergyProportionA.items[i].dictName = newVal[0][deviceDictSelectIdx2.value].dictName;
            centerFormData.value.newEnergyProportionA.items[i].unit = newVal[0][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 2) {
        centerFormData.value.newEnergyProportionB.items[deviceDictSelectIdx2.value].dictKey = newVal[1][deviceDictSelectIdx2.value].dictKey;
        centerFormData.value.newEnergyProportionB.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[1][deviceDictSelectIdx2.value].deviceId;
        centerFormData.value.newEnergyProportionB.items[deviceDictSelectIdx2.value].dictName = newVal[1][deviceDictSelectIdx2.value].dictName;
        centerFormData.value.newEnergyProportionB.items[deviceDictSelectIdx2.value].deviceName = newVal[1][deviceDictSelectIdx2.value].deviceName;
        centerFormData.value.newEnergyProportionB.items[deviceDictSelectIdx2.value].unit = newVal[1][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[1]) {
          for (let i = 0; i < centerFormData.value.newEnergyProportionB.items.length; i++) {
            centerFormData.value.newEnergyProportionB.items[i].dictKey = newVal[1][deviceDictSelectIdx2.value].dictKey;
            centerFormData.value.newEnergyProportionB.items[i].dictName = newVal[1][deviceDictSelectIdx2.value].dictName;
            centerFormData.value.newEnergyProportionB.items[i].unit = newVal[1][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 3) {
        centerFormData.value.photovoltaicPowerGenerationCapacity.items[deviceDictSelectIdx2.value].dictKey = newVal[2][deviceDictSelectIdx2.value].dictKey;
        centerFormData.value.photovoltaicPowerGenerationCapacity.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[2][deviceDictSelectIdx2.value].deviceId;
        centerFormData.value.photovoltaicPowerGenerationCapacity.items[deviceDictSelectIdx2.value].dictName = newVal[2][deviceDictSelectIdx2.value].dictName;
        centerFormData.value.photovoltaicPowerGenerationCapacity.items[deviceDictSelectIdx2.value].deviceName = newVal[2][deviceDictSelectIdx2.value].deviceName;
        centerFormData.value.photovoltaicPowerGenerationCapacity.items[deviceDictSelectIdx2.value].unit = newVal[2][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[2]) {
          for (let i = 0; i < centerFormData.value.photovoltaicPowerGenerationCapacity.items.length; i++) {
            centerFormData.value.photovoltaicPowerGenerationCapacity.items[i].dictKey = newVal[2][deviceDictSelectIdx2.value].dictKey;
            centerFormData.value.photovoltaicPowerGenerationCapacity.items[i].dictName = newVal[2][deviceDictSelectIdx2.value].dictName;
            centerFormData.value.photovoltaicPowerGenerationCapacity.items[i].unit = newVal[2][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 4) {
        centerFormData.value.photovoltaicPowerGeneration.items[deviceDictSelectIdx2.value].dictKey = newVal[3][deviceDictSelectIdx2.value].dictKey;
        centerFormData.value.photovoltaicPowerGeneration.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[3][deviceDictSelectIdx2.value].deviceId;
        centerFormData.value.photovoltaicPowerGeneration.items[deviceDictSelectIdx2.value].dictName = newVal[3][deviceDictSelectIdx2.value].dictName;
        centerFormData.value.photovoltaicPowerGeneration.items[deviceDictSelectIdx2.value].deviceName = newVal[3][deviceDictSelectIdx2.value].deviceName;
        centerFormData.value.photovoltaicPowerGeneration.items[deviceDictSelectIdx2.value].unit = newVal[3][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[3]) {
          for (let i = 0; i < centerFormData.value.photovoltaicPowerGeneration.items.length; i++) {
            centerFormData.value.photovoltaicPowerGeneration.items[i].dictKey = newVal[3][deviceDictSelectIdx2.value].dictKey;
            centerFormData.value.photovoltaicPowerGeneration.items[i].dictName = newVal[3][deviceDictSelectIdx2.value].dictName;
            centerFormData.value.photovoltaicPowerGeneration.items[i].unit = newVal[3][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 5) {
        centerFormData.value.photovoltaicRevenue.items[deviceDictSelectIdx2.value].dictKey = newVal[4][deviceDictSelectIdx2.value].dictKey;
        centerFormData.value.photovoltaicRevenue.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[4][deviceDictSelectIdx2.value].deviceId;
        centerFormData.value.photovoltaicRevenue.items[deviceDictSelectIdx2.value].dictName = newVal[4][deviceDictSelectIdx2.value].dictName;
        centerFormData.value.photovoltaicRevenue.items[deviceDictSelectIdx2.value].deviceName = newVal[4][deviceDictSelectIdx2.value].deviceName;
        centerFormData.value.photovoltaicRevenue.items[deviceDictSelectIdx2.value].unit = newVal[4][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[4]) {
          for (let i = 0; i < centerFormData.value.photovoltaicRevenue.items.length; i++) {
            centerFormData.value.photovoltaicRevenue.items[i].dictKey = newVal[4][deviceDictSelectIdx2.value].dictKey;
            centerFormData.value.photovoltaicRevenue.items[i].dictName = newVal[4][deviceDictSelectIdx2.value].dictName;
            centerFormData.value.photovoltaicRevenue.items[i].unit = newVal[4][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 6) {
        centerFormData.value.energyStorageChargingPower.items[deviceDictSelectIdx2.value].dictKey = newVal[5][deviceDictSelectIdx2.value].dictKey;
        centerFormData.value.energyStorageChargingPower.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[5][deviceDictSelectIdx2.value].deviceId;
        centerFormData.value.energyStorageChargingPower.items[deviceDictSelectIdx2.value].dictName = newVal[5][deviceDictSelectIdx2.value].dictName;
        centerFormData.value.energyStorageChargingPower.items[deviceDictSelectIdx2.value].deviceName = newVal[5][deviceDictSelectIdx2.value].deviceName;
        centerFormData.value.energyStorageChargingPower.items[deviceDictSelectIdx2.value].unit = newVal[5][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[5]) {
          for (let i = 0; i < centerFormData.value.energyStorageChargingPower.items.length; i++) {
            centerFormData.value.energyStorageChargingPower.items[i].dictKey = newVal[5][deviceDictSelectIdx2.value].dictKey;
            centerFormData.value.energyStorageChargingPower.items[i].dictName = newVal[5][deviceDictSelectIdx2.value].dictName;
            centerFormData.value.energyStorageChargingPower.items[i].unit = newVal[5][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 7) {
        centerFormData.value.energyStorageDischargePower.items[deviceDictSelectIdx2.value].dictKey = newVal[6][deviceDictSelectIdx2.value].dictKey;
        centerFormData.value.energyStorageDischargePower.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[6][deviceDictSelectIdx2.value].deviceId;
        centerFormData.value.energyStorageDischargePower.items[deviceDictSelectIdx2.value].dictName = newVal[6][deviceDictSelectIdx2.value].dictName;
        centerFormData.value.energyStorageDischargePower.items[deviceDictSelectIdx2.value].deviceName = newVal[6][deviceDictSelectIdx2.value].deviceName;
        centerFormData.value.energyStorageDischargePower.items[deviceDictSelectIdx2.value].unit = newVal[6][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[6]) {
          for (let i = 0; i < centerFormData.value.energyStorageDischargePower.items.length; i++) {
            centerFormData.value.energyStorageDischargePower.items[i].dictKey = newVal[6][deviceDictSelectIdx2.value].dictKey;
            centerFormData.value.energyStorageDischargePower.items[i].dictName = newVal[6][deviceDictSelectIdx2.value].dictName;
            centerFormData.value.energyStorageDischargePower.items[i].unit = newVal[6][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 8) {
        centerFormData.value.chargingPilePower.items[deviceDictSelectIdx2.value].dictKey = newVal[7][deviceDictSelectIdx2.value].dictKey;
        centerFormData.value.chargingPilePower.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[7][deviceDictSelectIdx2.value].deviceId;
        centerFormData.value.chargingPilePower.items[deviceDictSelectIdx2.value].dictName = newVal[7][deviceDictSelectIdx2.value].dictName;
        centerFormData.value.chargingPilePower.items[deviceDictSelectIdx2.value].deviceName = newVal[7][deviceDictSelectIdx2.value].deviceName;
        centerFormData.value.chargingPilePower.items[deviceDictSelectIdx2.value].unit = newVal[7][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[7]) {
          for (let i = 0; i < centerFormData.value.chargingPilePower.items.length; i++) {
            centerFormData.value.chargingPilePower.items[i].dictKey = newVal[7][deviceDictSelectIdx2.value].dictKey;
            centerFormData.value.chargingPilePower.items[i].dictName = newVal[7][deviceDictSelectIdx2.value].dictName;
            centerFormData.value.chargingPilePower.items[i].unit = newVal[7][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 9) {
        centerFormData.value.chargingPileChargingCapacity.items[deviceDictSelectIdx2.value].dictKey = newVal[8][deviceDictSelectIdx2.value].dictKey;
        centerFormData.value.chargingPileChargingCapacity.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[8][deviceDictSelectIdx2.value].deviceId;
        centerFormData.value.chargingPileChargingCapacity.items[deviceDictSelectIdx2.value].dictName = newVal[8][deviceDictSelectIdx2.value].dictName;
        centerFormData.value.chargingPileChargingCapacity.items[deviceDictSelectIdx2.value].deviceName = newVal[8][deviceDictSelectIdx2.value].deviceName;
        centerFormData.value.chargingPileChargingCapacity.items[deviceDictSelectIdx2.value].unit = newVal[8][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[8]) {
          for (let i = 0; i < centerFormData.value.chargingPileChargingCapacity.items.length; i++) {
            centerFormData.value.chargingPileChargingCapacity.items[i].dictKey = newVal[8][deviceDictSelectIdx2.value].dictKey;
            centerFormData.value.chargingPileChargingCapacity.items[i].dictName = newVal[8][deviceDictSelectIdx2.value].dictName;
            centerFormData.value.chargingPileChargingCapacity.items[i].unit = newVal[8][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 10) {
        centerFormData.value.demandQuantityA.items[deviceDictSelectIdx2.value].dictKey = newVal[9][deviceDictSelectIdx2.value].dictKey;
        centerFormData.value.demandQuantityA.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[9][deviceDictSelectIdx2.value].deviceId;
        centerFormData.value.demandQuantityA.items[deviceDictSelectIdx2.value].dictName = newVal[9][deviceDictSelectIdx2.value].dictName;
        centerFormData.value.demandQuantityA.items[deviceDictSelectIdx2.value].deviceName = newVal[9][deviceDictSelectIdx2.value].deviceName;
        centerFormData.value.demandQuantityA.items[deviceDictSelectIdx2.value].unit = newVal[9][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[9]) {
          for (let i = 0; i < centerFormData.value.demandQuantityA.items.length; i++) {
            centerFormData.value.demandQuantityA.items[i].dictKey = newVal[9][deviceDictSelectIdx2.value].dictKey;
            centerFormData.value.demandQuantityA.items[i].dictName = newVal[9][deviceDictSelectIdx2.value].dictName;
            centerFormData.value.demandQuantityA.items[i].unit = newVal[9][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 11) {
        centerFormData.value.demandQuantityB.items[deviceDictSelectIdx2.value].dictKey = newVal[10][deviceDictSelectIdx2.value].dictKey;
        centerFormData.value.demandQuantityB.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[10][deviceDictSelectIdx2.value].deviceId;
        centerFormData.value.demandQuantityB.items[deviceDictSelectIdx2.value].dictName = newVal[10][deviceDictSelectIdx2.value].dictName;
        centerFormData.value.demandQuantityB.items[deviceDictSelectIdx2.value].deviceName = newVal[10][deviceDictSelectIdx2.value].deviceName;
        centerFormData.value.demandQuantityB.items[deviceDictSelectIdx2.value].unit = newVal[10][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[10]) {
          for (let i = 0; i < centerFormData.value.demandQuantityB.items.length; i++) {
            centerFormData.value.demandQuantityB.items[i].dictKey = newVal[10][deviceDictSelectIdx2.value].dictKey;
            centerFormData.value.demandQuantityB.items[i].dictName = newVal[10][deviceDictSelectIdx2.value].dictName;
            centerFormData.value.demandQuantityB.items[i].unit = newVal[10][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 12) {
        centerFormData.value.internetPower.items[deviceDictSelectIdx2.value].dictKey = newVal[11][deviceDictSelectIdx2.value].dictKey;
        centerFormData.value.internetPower.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[11][deviceDictSelectIdx2.value].deviceId;
        centerFormData.value.internetPower.items[deviceDictSelectIdx2.value].dictName = newVal[11][deviceDictSelectIdx2.value].dictName;
        centerFormData.value.internetPower.items[deviceDictSelectIdx2.value].deviceName = newVal[11][deviceDictSelectIdx2.value].deviceName;
        centerFormData.value.internetPower.items[deviceDictSelectIdx2.value].unit = newVal[11][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[11]) {
          for (let i = 0; i < centerFormData.value.internetPower.items.length; i++) {
            centerFormData.value.internetPower.items[i].dictKey = newVal[11][deviceDictSelectIdx2.value].dictKey;
            centerFormData.value.internetPower.items[i].dictName = newVal[11][deviceDictSelectIdx2.value].dictName;
            centerFormData.value.internetPower.items[i].unit = newVal[11][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 13) {
        centerFormData.value.downInternetPower.items[deviceDictSelectIdx2.value].dictKey = newVal[12][deviceDictSelectIdx2.value].dictKey;
        centerFormData.value.downInternetPower.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[12][deviceDictSelectIdx2.value].deviceId;
        centerFormData.value.downInternetPower.items[deviceDictSelectIdx2.value].dictName = newVal[12][deviceDictSelectIdx2.value].dictName;
        centerFormData.value.downInternetPower.items[deviceDictSelectIdx2.value].deviceName = newVal[12][deviceDictSelectIdx2.value].deviceName;
        centerFormData.value.downInternetPower.items[deviceDictSelectIdx2.value].unit = newVal[12][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[12]) {
          for (let i = 0; i < centerFormData.value.downInternetPower.items.length; i++) {
            centerFormData.value.downInternetPower.items[i].dictKey = newVal[12][deviceDictSelectIdx2.value].dictKey;
            centerFormData.value.downInternetPower.items[i].dictName = newVal[12][deviceDictSelectIdx2.value].dictName;
            centerFormData.value.downInternetPower.items[i].unit = newVal[12][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 14) {
        // centerFormData.value.internetPowerConsumption.dictKey = []
        // for (let i = 0; i < newVal[13].length; i++) {
        //   centerFormData.value.internetPowerConsumption.dictKey.push(newVal[13][i].dictKey)
        //   centerFormData.value.internetPowerConsumption.equipmentId = newVal[13][i].deviceId
        // }
        centerFormData.value.internetPowerConsumption.dictKey = [newVal[13][0].dictKey];
        centerFormData.value.internetPowerConsumption.deviceIdStr = newVal[13][0].deviceId;
        centerFormData.value.internetPowerConsumption.dictName = newVal[13][0].dictName;
        centerFormData.value.internetPowerConsumption.deviceName = newVal[13][0].deviceName;
        centerFormData.value.internetPowerConsumption.unit = newVal[13][0].unit;
      } else if (deviceDictSelectIdx.value === 15) {
        // centerFormData.value.downInternetPowerConsumption.dictKey = []
        // for (let i = 0; i < newVal[14].length; i++) {
        //   centerFormData.value.downInternetPowerConsumption.dictKey.push(newVal[14][i].dictKey)
        //   centerFormData.value.downInternetPowerConsumption.equipmentId = newVal[14][i].deviceId
        // }
        centerFormData.value.downInternetPowerConsumption.dictKey = [newVal[14][0].dictKey];
        centerFormData.value.downInternetPowerConsumption.deviceIdStr = newVal[14][0].deviceId;
        centerFormData.value.downInternetPowerConsumption.dictName = newVal[14][0].dictName;
        centerFormData.value.downInternetPowerConsumption.deviceName = newVal[14][0].deviceName;
        centerFormData.value.downInternetPowerConsumption.unit = newVal[14][0].unit;
      } else if (deviceDictSelectIdx.value === 16) {
        centerFormData.value.electricityLoad.items[deviceDictSelectIdx2.value].dictKey = newVal[15][deviceDictSelectIdx2.value].dictKey;
        centerFormData.value.electricityLoad.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[15][deviceDictSelectIdx2.value].deviceId;
        centerFormData.value.electricityLoad.items[deviceDictSelectIdx2.value].dictName = newVal[15][deviceDictSelectIdx2.value].dictName;
        centerFormData.value.electricityLoad.items[deviceDictSelectIdx2.value].deviceName = newVal[15][deviceDictSelectIdx2.value].deviceName;
        centerFormData.value.electricityLoad.items[deviceDictSelectIdx2.value].unit = newVal[15][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[13]) {
          for (let i = 0; i < centerFormData.value.electricityLoad.items.length; i++) {
            centerFormData.value.electricityLoad.items[i].dictKey = newVal[15][deviceDictSelectIdx2.value].dictKey;
            centerFormData.value.electricityLoad.items[i].dictName = newVal[15][deviceDictSelectIdx2.value].dictName;
            centerFormData.value.electricityLoad.items[i].unit = newVal[15][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 17) {
        // centerFormData.value.energyStorageSOC.dictKey = []
        // for (let i = 0; i < newVal[16].length; i++) {
        //   centerFormData.value.energyStorageSOC.dictKey.push(newVal[16][i].dictKey)
        //   centerFormData.value.energyStorageSOC.equipmentId = newVal[16][i].deviceId
        // }
        centerFormData.value.energyStorageSOC.dictKey = [newVal[16][0].dictKey];
        centerFormData.value.energyStorageSOC.deviceIdStr = newVal[16][0].deviceId;
        centerFormData.value.energyStorageSOC.dictName = newVal[16][0].dictName;
        centerFormData.value.energyStorageSOC.deviceName = newVal[16][0].deviceName;
        centerFormData.value.energyStorageSOC.unit = newVal[16][0].unit;
      }
    } else if (setDialog7.value) {
      if (deviceDictSelectIdx.value === 1) {
        electricityDemand.value.optimizationBefore.items[deviceDictSelectIdx2.value].dictKey = newVal[0][deviceDictSelectIdx2.value].dictKey;
        electricityDemand.value.optimizationBefore.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[0][deviceDictSelectIdx2.value].deviceId;
        electricityDemand.value.optimizationBefore.items[deviceDictSelectIdx2.value].dictName = newVal[0][deviceDictSelectIdx2.value].dictName;
        electricityDemand.value.optimizationBefore.items[deviceDictSelectIdx2.value].deviceName = newVal[0][deviceDictSelectIdx2.value].deviceName;
        electricityDemand.value.optimizationBefore.items[deviceDictSelectIdx2.value].unit = newVal[0][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[0]) {
          for (let i = 0; i < electricityDemand.value.optimizationBefore.items.length; i++) {
            electricityDemand.value.optimizationBefore.items[i].dictKey = newVal[0][deviceDictSelectIdx2.value].dictKey;
            electricityDemand.value.optimizationBefore.items[i].dictName = newVal[0][deviceDictSelectIdx2.value].dictName;
            electricityDemand.value.optimizationBefore.items[i].unit = newVal[0][deviceDictSelectIdx2.value].unit;
          }
        }
      } else if (deviceDictSelectIdx.value === 2) {
        electricityDemand.value.optimizationAfter.items[deviceDictSelectIdx2.value].dictKey = newVal[1][deviceDictSelectIdx2.value].dictKey;
        electricityDemand.value.optimizationAfter.items[deviceDictSelectIdx2.value].deviceIdStr = newVal[1][deviceDictSelectIdx2.value].deviceId;
        electricityDemand.value.optimizationAfter.items[deviceDictSelectIdx2.value].dictName = newVal[1][deviceDictSelectIdx2.value].dictName;
        electricityDemand.value.optimizationAfter.items[deviceDictSelectIdx2.value].deviceName = newVal[1][deviceDictSelectIdx2.value].deviceName;
        electricityDemand.value.optimizationAfter.items[deviceDictSelectIdx2.value].unit = newVal[1][deviceDictSelectIdx2.value].unit;
        if (isSynchronization.value[1]) {
          for (let i = 0; i < electricityDemand.value.optimizationAfter.items.length; i++) {
            electricityDemand.value.optimizationAfter.items[i].dictKey = newVal[1][deviceDictSelectIdx2.value].dictKey;
            electricityDemand.value.optimizationAfter.items[i].dictName = newVal[1][deviceDictSelectIdx2.value].dictName;
            electricityDemand.value.optimizationAfter.items[i].unit = newVal[1][deviceDictSelectIdx2.value].unit;
          }
        }
      }
    }
  },
  { deep: true, immediate: true }
);

// 多设备单指标-------------------------------------------
let deviceVisible2 = ref(false); //选择设备的组件弹窗
let equipmentList2 = ref([]); //选择设备的设备列表
let deviceSelectIdx2 = ref();
// 点击选择设备
const deviceSelectClick2 = function (idx) {
  deviceVisible2.value = true;
  deviceSelectIdx2.value = idx;
  equipmentList2.value = [];
};
const selectDeviceFun2 = function () {
  deviceVisible2.value = true;
};
const deviceVisibleFun2 = function (data) {
  deviceVisible2.value = data;
};
const checkDeviceListFun2 = function (data) {
  equipmentList2.value = data;
};
// 监听设备列表
watch(
  () => equipmentList2.value,
  (newVal) => {
    if (setDialog2.value) {
      if (deviceSelectIdx2.value === 0) {
        eleFormData.value.electricity.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            eleFormData.value.electricity.formula = "A";
          } else {
            eleFormData.value.electricity.formula = eleFormData.value.electricity.formula.concat("+D");
          }
          eleFormData.value.electricity.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 1) {
        eleFormData.value.absorb.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            eleFormData.value.absorb.formula = "A";
          } else {
            eleFormData.value.absorb.formula = eleFormData.value.absorb.formula.concat("+D");
          }
          eleFormData.value.absorb.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      }
    } else if (setDialog3.value) {
      if (deviceSelectIdx2.value === 0) {
        newEnergyPowerGeneration.value.electricity.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            newEnergyPowerGeneration.value.electricity.formula = "A";
          } else {
            newEnergyPowerGeneration.value.electricity.formula = newEnergyPowerGeneration.value.electricity.formula.concat("+D");
          }
          newEnergyPowerGeneration.value.electricity.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 1) {
        newEnergyPowerGeneration.value.selfElectricity.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            newEnergyPowerGeneration.value.selfElectricity.formula = "A";
          } else {
            newEnergyPowerGeneration.value.selfElectricity.formula = newEnergyPowerGeneration.value.selfElectricity.formula.concat("+D");
          }
          newEnergyPowerGeneration.value.selfElectricity.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 2) {
        newEnergyPowerGeneration.value.internetElectricity.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            newEnergyPowerGeneration.value.internetElectricity.formula = "A";
          } else {
            newEnergyPowerGeneration.value.internetElectricity.formula = newEnergyPowerGeneration.value.internetElectricity.formula.concat("+D");
          }
          newEnergyPowerGeneration.value.internetElectricity.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      }
    } else if (setDialog4.value) {
      if (deviceSelectIdx2.value === 0) {
        operatingPower.value.load.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            operatingPower.value.load.formula = "A";
          } else {
            operatingPower.value.load.formula = operatingPower.value.load.formula.concat("+D");
          }
          operatingPower.value.load.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 1) {
        operatingPower.value.energyStorage.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            operatingPower.value.energyStorage.formula = "A";
          } else {
            operatingPower.value.energyStorage.formula = operatingPower.value.energyStorage.formula.concat("+D");
          }
          operatingPower.value.energyStorage.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 2) {
        operatingPower.value.municipalElectricity.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            operatingPower.value.municipalElectricity.formula = "A";
          } else {
            operatingPower.value.municipalElectricity.formula = operatingPower.value.municipalElectricity.formula.concat("+D");
          }
          operatingPower.value.municipalElectricity.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 3) {
        operatingPower.value.newEnergy.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            operatingPower.value.newEnergy.formula = "A";
          } else {
            operatingPower.value.newEnergy.formula = operatingPower.value.newEnergy.formula.concat("+D");
          }
          operatingPower.value.newEnergy.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      }
    } else if (setDialog5.value) {
      if (deviceSelectIdx2.value === 0) {
        costFormData.value.optimizationBefore.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            costFormData.value.optimizationBefore.formula = "A";
          } else {
            costFormData.value.optimizationBefore.formula = costFormData.value.optimizationBefore.formula.concat("+D");
          }
          costFormData.value.optimizationBefore.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 1) {
        costFormData.value.optimizationAfter.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            costFormData.value.optimizationAfter.formula = "A";
          } else {
            costFormData.value.optimizationAfter.formula = costFormData.value.optimizationAfter.formula.concat("+D");
          }
          costFormData.value.optimizationAfter.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      }
    } else if (setDialog6.value) {
      if (deviceSelectIdx2.value === 0) {
        centerFormData.value.newEnergyProportionA.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            centerFormData.value.newEnergyProportionA.formula = "A";
          } else {
            centerFormData.value.newEnergyProportionA.formula = centerFormData.value.newEnergyProportionA.formula.concat("+D");
          }
          centerFormData.value.newEnergyProportionA.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 1) {
        centerFormData.value.newEnergyProportionB.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            centerFormData.value.newEnergyProportionB.formula = "A";
          } else {
            centerFormData.value.newEnergyProportionB.formula = centerFormData.value.newEnergyProportionB.formula.concat("+D");
          }
          centerFormData.value.newEnergyProportionB.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 2) {
        centerFormData.value.photovoltaicPowerGenerationCapacity.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            centerFormData.value.photovoltaicPowerGenerationCapacity.formula = "A";
          } else {
            centerFormData.value.photovoltaicPowerGenerationCapacity.formula = centerFormData.value.photovoltaicPowerGenerationCapacity.formula.concat("+D");
          }
          centerFormData.value.photovoltaicPowerGenerationCapacity.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 3) {
        centerFormData.value.photovoltaicPowerGeneration.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            centerFormData.value.photovoltaicPowerGeneration.formula = "A";
          } else {
            centerFormData.value.photovoltaicPowerGeneration.formula = centerFormData.value.photovoltaicPowerGeneration.formula.concat("+D");
          }
          centerFormData.value.photovoltaicPowerGeneration.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 4) {
        centerFormData.value.photovoltaicRevenue.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            centerFormData.value.photovoltaicRevenue.formula = "A";
          } else {
            centerFormData.value.photovoltaicRevenue.formula = centerFormData.value.photovoltaicRevenue.formula.concat("+D");
          }
          centerFormData.value.photovoltaicRevenue.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 5) {
        // internetPower
        // downInternetPower
        // energyStorageChargingPower
        // energyStorageDischargePower
        // chargingPilePower
        // chargingPileChargingCapacity
        // demandQuantityA
        // demandQuantityB

        centerFormData.value.internetPower.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            centerFormData.value.internetPower.formula = "A";
          } else {
            centerFormData.value.internetPower.formula = centerFormData.value.internetPower.formula.concat("+D");
          }
          centerFormData.value.internetPower.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 6) {
        centerFormData.value.downInternetPower.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            centerFormData.value.downInternetPower.formula = "A";
          } else {
            centerFormData.value.downInternetPower.formula = centerFormData.value.downInternetPower.formula.concat("+D");
          }
          centerFormData.value.downInternetPower.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 7) {
        centerFormData.value.energyStorageChargingPower.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            centerFormData.value.energyStorageChargingPower.formula = "A";
          } else {
            centerFormData.value.energyStorageChargingPower.formula = centerFormData.value.energyStorageChargingPower.formula.concat("+D");
          }
          centerFormData.value.energyStorageChargingPower.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 8) {
        centerFormData.value.energyStorageDischargePower.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            centerFormData.value.energyStorageDischargePower.formula = "A";
          } else {
            centerFormData.value.energyStorageDischargePower.formula = centerFormData.value.energyStorageDischargePower.formula.concat("+D");
          }
          centerFormData.value.energyStorageDischargePower.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 9) {
        centerFormData.value.chargingPilePower.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            centerFormData.value.chargingPilePower.formula = "A";
          } else {
            centerFormData.value.chargingPilePower.formula = centerFormData.value.chargingPilePower.formula.concat("+D");
          }
          centerFormData.value.chargingPilePower.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 10) {
        centerFormData.value.chargingPileChargingCapacity.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            centerFormData.value.chargingPileChargingCapacity.formula = "A";
          } else {
            centerFormData.value.chargingPileChargingCapacity.formula = centerFormData.value.chargingPileChargingCapacity.formula.concat("+D");
          }
          centerFormData.value.chargingPileChargingCapacity.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 11) {
        centerFormData.value.electricityLoad.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            centerFormData.value.electricityLoad.formula = "A";
          } else {
            centerFormData.value.electricityLoad.formula = centerFormData.value.electricityLoad.formula.concat("+D");
          }
          centerFormData.value.electricityLoad.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 12) {
        centerFormData.value.demandQuantityA.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            centerFormData.value.demandQuantityA.formula = "A";
          } else {
            centerFormData.value.demandQuantityA.formula = centerFormData.value.demandQuantityA.formula.concat("+D");
          }
          centerFormData.value.demandQuantityA.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 13) {
        centerFormData.value.demandQuantityB.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            centerFormData.value.demandQuantityB.formula = "A";
          } else {
            centerFormData.value.demandQuantityB.formula = centerFormData.value.demandQuantityB.formula.concat("+D");
          }
          centerFormData.value.demandQuantityB.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      }
    } else if (setDialog7.value) {
      if (deviceSelectIdx2.value === 0) {
        electricityDemand.value.optimizationBefore.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            electricityDemand.value.optimizationBefore.formula = "A";
          } else {
            electricityDemand.value.optimizationBefore.formula = electricityDemand.value.optimizationBefore.formula.concat("+D");
          }
          electricityDemand.value.optimizationBefore.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      } else if (deviceSelectIdx2.value === 1) {
        electricityDemand.value.optimizationAfter.items = [];
        for (let i = 0; i < newVal.length; i++) {
          if (i === 0) {
            electricityDemand.value.optimizationAfter.formula = "A";
          } else {
            electricityDemand.value.optimizationAfter.formula = electricityDemand.value.optimizationAfter.formula.concat("+D");
          }
          electricityDemand.value.optimizationAfter.items.push({
            val: "",
            type: "1",
            unit: newVal[i].unit,
            dictKey: newVal[i].dictKey,
            dictName: newVal[i].dictName,
            name: "A",
            deviceIdStr: newVal[i].id,
            deviceName: newVal[i].name,
          });
        }
      }
    }
  },
  { deep: true }
);

// 获取电站数据***************************************************************************
// 获取电站树形数据
let photovoltaicRevenueTreeData = ref([]);
let energyRevenueTreeData = ref([]);
const getPhotovoltaicRevenueTreeDataFun = function () {
  // 光伏电站
  getStationTreeApi(qs.stringify({ type: 1 }))
    .then((res) => {
      if (res.data.code === 0) {
        photovoltaicRevenueTreeData.value = [];
        photovoltaicRevenueTreeData.value.push(res.data.result);
      } else {
        ElMessage({
          message: res.data.msg,
          type: "error",
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
  // 储能电站
  getStationTreeApi(qs.stringify({ type: 2 }))
    .then((res) => {
      if (res.data.code === 0) {
        energyRevenueTreeData.value = [];
        energyRevenueTreeData.value.push(res.data.result);
      } else {
        ElMessage({
          message: res.data.msg,
          type: "error",
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

// 大屏管理***************************************************************************
let screenFlag = ref(false);
// 点击进入全屏
const enterScreenClick = function () {
  // 获取layout的dom元素
  const parentNode = document.querySelector(".templateBigScreen1"); // 获取需要全屏的元素;
  // 进入全屏
  if (parentNode.requestFullscreen) {
    parentNode.requestFullscreen();
  } else if (parentNode.webkitRequestFullScreen) {
    parentNode.webkitRequestFullScreen();
  } else if (parentNode.mozRequestFullScreen) {
    parentNode.mozRequestFullScreen();
  } else if (parentNode.msRequestFullscreen) {
    // IE11
    parentNode.msRequestFullscreen();
  }
  screenFlag.value = true;
  nextTick(() => {
    // chartLoad()
    setTimeout(() => {
      resizeFun();
    }, 100);
  });
};
// 退出全屏
const exitFullscreenClick = () => {
  const parentNode = document.querySelector(".templateBigScreen1"); // 获取需要全屏的元素;
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
  screenFlag.value = false;
  nextTick(() => {
    // chartLoad()
    setTimeout(() => {
      resizeFun();
    }, 100);
  });
};
watch(
  () => props.screenFlag,
  (newVal) => {
    if (newVal) {
      nextTick(() => {
        enterScreenClick();
      });
    }
  },
  { immediate: true, deep: true }
);

// 页面自适应***************************************************************************
const resizeFun = function () {
  nextTick(() => {
    let ele = document.querySelector(".templateBigScreen1");
    let scaleX = ele.clientWidth / 1920;
    let scaleY = ele.clientHeight / 1080;
    document.querySelector(".templateBigScreen1 .largeScreenContent").style.transform = `scale(${scaleX},${scaleY})`;
  });
};

// 获取页面数据***************************************************************************
let pageData = ref({
  baseInfo: {},
  electricAnalysis: {},
  last7DayFeeChar: {},
  middleInfo: {},
  newEnergy: {},
  newEnergySocialBenefits: {},
  operatingPowerChar: {},
  powerDemandChar: {},
});
// 新增每个模块的 loading 状态
const loadingBaseInfo = ref(false);
const loadingElectricAnalysis = ref(false);
const loadingLast7DayFeeChar = ref(false);
const loadingMiddleInfo = ref(false);
const loadingNewEnergy = ref(false);
const loadingNewEnergySocialBenefits = ref(false);
const loadingOperatingPowerChar = ref(false);
const loadingPowerDemandChar = ref(false);

// 分模块获取数据
const fetchBlockData = async (blockName, loadingRef, dataKey) => {
  loadingRef.value = true;
  return getKanbanDataApiV2({
    moduleId: props.projectModuleId,
    templateId: props.templateId,
    blockName,
  })
    .then((res) => {
      if (res.data.code === 200) {
        pageData.value[dataKey] = res.data.data || {};
        if (blockName == "middleInfo") {
          countStart1.value = pageData.value.middleInfo ? pageData.value.middleInfo.totalSavingAmount : "";
          countStart2.value = pageData.value.middleInfo ? pageData.value.middleInfo.totalSystemRevenue : "";
          countStart3.value = pageData.value.middleInfo ? pageData.value.middleInfo.totalElectric : "";
          countStart4.value = pageData.value.middleInfo ? pageData.value.middleInfo.newEnergyRate : "";
        }
        if (dataKey == "electricAnalysis") {
          for (const key in pageData.value[dataKey]) {
            if (Object.prototype.hasOwnProperty.call(pageData.value[dataKey], key)) {
              let element = pageData.value[dataKey][key];
              pageData.value[dataKey][key] = element * 1;
            }
          }
        }
      } else {
        ElMessage({ type: "error", message: res.data.msg });
      }
    })
    .catch((err) => {
      console.log(err);
    })
    .finally(() => {
      loadingRef.value = false;
    });
};
const getKanbanDataFun = function () {
  console.log("获取大屏数据");
  Promise.all([
    fetchBlockData("baseInfo", loadingBaseInfo, "baseInfo"),
    fetchBlockData("electricAnalysis", loadingElectricAnalysis, "electricAnalysis"),
    fetchBlockData("last7DayFeeChar", loadingLast7DayFeeChar, "last7DayFeeChar"),
    fetchBlockData("middleInfo", loadingMiddleInfo, "middleInfo"),
    fetchBlockData("newEnergy", loadingNewEnergy, "newEnergy"),
    fetchBlockData("newEnergySocialBenefits", loadingNewEnergySocialBenefits, "newEnergySocialBenefits"),
    fetchBlockData("operatingPowerChar", loadingOperatingPowerChar, "operatingPowerChar"),
    fetchBlockData("powerDemandChar", loadingPowerDemandChar, "powerDemandChar"),
  ]).then(() => {
    // 所有数据加载完毕后可做后续处理
    nextTick(() => {
      circleChartLoad1();
      circleChartLoad2();
      lineChartLoad1();
      barChartLoad1();
      lineChartLoad2();
    });
  });

  return;
  getKanbanDataApi({
    moduleId: props.projectModuleId,
    templateId: props.templateId,
  })
    .then((res) => {
      if (res.data.code === 200) {
        if (res.data) {
          countStart1.value = pageData.value.middleInfo ? pageData.value.middleInfo.totalSavingAmount : "";
          countStart2.value = pageData.value.middleInfo ? pageData.value.middleInfo.totalSystemRevenue : "";
          countStart3.value = pageData.value.middleInfo ? pageData.value.middleInfo.totalElectric : "";
          countStart4.value = pageData.value.middleInfo ? pageData.value.middleInfo.newEnergyRate : "";
          pageData.value = res.data.data;
          if (!pageData.value.baseInfo) {
            pageData.value.baseInfo = {};
          }
          if (!pageData.value.electricAnalysis) {
            pageData.value.electricAnalysis = {};
          }
          if (!pageData.value.last7DayFeeChar) {
            pageData.value.last7DayFeeChar = {};
          }
          if (!pageData.value.middleInfo) {
            pageData.value.middleInfo = {};
          }
          if (!pageData.value.newEnergy) {
            pageData.value.newEnergy = {};
          }
          if (!pageData.value.newEnergySocialBenefits) {
            pageData.value.newEnergySocialBenefits = {};
          }
          if (!pageData.value.operatingPowerChar) {
            pageData.value.operatingPowerChar = {};
          }
          if (!pageData.value.powerDemandChar) {
            pageData.value.powerDemandChar = {};
          }
          nextTick(() => {
            circleChartLoad1();
            circleChartLoad2();
            lineChartLoad1();
            barChartLoad1();
            lineChartLoad2();
          });
        }
      } else {
        ElMessage({
          type: "error",
          message: res.data.msg,
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};
let dataTimer = setInterval(() => {
  getKanbanDataFun();
}, 1000 * 60 * 5);
// 获取天气
let currentWeatherObj = ref({});
watch(
  () => pageData.value,
  (newVal, oldValue) => {
    if (
      newVal.baseInfo &&
      newVal.baseInfo.longitude &&
      newVal.baseInfo.latitude &&
      oldValue.baseInfo.longitude !== newVal.baseInfo.longitude &&
      oldValue.baseInfo.latitude !== newVal.baseInfo.latitude
    ) {
      console.log("经纬度：", newVal.baseInfo);
      // 根据坐标获取地址======>用当前位置获取天气
      new BMap.Geocoder().getLocation(new BMap.Point(newVal.baseInfo.longitude, newVal.baseInfo.latitude), (result) => {
        if (result) {
          // console.log("结构化信息：", result.addressComponents, result.addressComponents.province, 'kkk');
          // province.value = result.addressComponents.province
          // city.value = result.addressComponents.city

          // 筛选出城市编码用于获取天气
          let code = cityCode.filter((item) => item.name === result.addressComponents.city)[0].adcode;
          getGeneralWeatherApi(code, "base")
            .then((res) => {
              if (res.data.status === "1") {
                currentWeatherObj.value = res.data.lives[0];
                // console.log(currentWeatherObj.value, '实时')
              } else {
                ElMessage({
                  message: res.data.code,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.error("逆地理编码失败");
        }
      });
    }
  },
  { immediate: true, deep: true }
);

// ws连接*********************************************************
// const wsService = new WebSocketService('ws://192.168.3.11:8088/ws/blockScreen'); // 使用wss或ws协议根据你的服务器配置选择安全或不安全连接方式。
// // 连接WebSocket---------------
const wsService = new WebSocketService(ws + "ws/blockScreen"); // 使用wss或ws协议根据你的服务器配置选择安全或不安全连接方式。
// 连接WebSocket---------------

// 监听接收的数据---------------
// 自定义防抖函数
function debounce(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

// 创建防抖处理函数
const debouncedUpdate = debounce((event) => {
  // console.log(event, '防抖处理后的事件');
  if (event && event !== {}) {
    countStart1.value = pageData.value.middleInfo.totalSavingAmount;
    countStart2.value = pageData.value.middleInfo.totalSystemRevenue;
    countStart3.value = pageData.value.middleInfo.totalElectric;
    countStart4.value = pageData.value.middleInfo.newEnergyRate;
    pageData.value.middleInfo = event;
  }
}, 1000);
wsService.addMessageListener(debouncedUpdate); // 添加监听器以接收消息。

// 发送数据---------------
function sendMessage() {
  wsService.send({
    moduleId: props.projectModuleId,
    blockId: 7,
    templateId: props.templateId,
  }); // 发送消息到服务器。确保服务器可以解析这种格式。
}

// 监听连接状态---------------
let timer2;
wsService.addStatusListener(({ status, data }) => {
  // console.log('WebSocket status changed:', status, data);
  // 连接成功后发送消息
  if (status === "connected") {
    sendMessage();
    timer2 = setInterval(() => {
      wsService.send({ heart: 1 });
    }, 10000);
  }
  if (status === "error") {
    console.error("WebSocket error occurred:", data);
    clearInterval(timer2);
  }
});

watch(
  () => props.projectModuleId,
  (newVal) => {
    getKanbanDataFun();
    getPhotovoltaicRevenueTreeDataFun();
    wsService.connect();
    resizeFun();
    window.onresize = () => {
      nextTick(() => {
        setTimeout(() => {
          resizeFun();
        }, 100);
      });
    };
  }
);

onMounted(() => {
  getKanbanDataFun();
  getPhotovoltaicRevenueTreeDataFun();
  wsService.connect();
  resizeFun();
  window.onresize = () => {
    nextTick(() => {
      setTimeout(() => {
        resizeFun();
      }, 100);
    });
  };
});

onUnmounted(() => {
  clearInterval(timer);
  clearInterval(timer2);
  clearInterval(dataTimer);
  // wsService.disconnect();

  // wsService.removeMessageListener();
  // wsService.removeStatusListener();
  wsService.disconnect();
});
</script>

<style lang="less">
.templateBigScreen1 {
  width: 100%;
  height: 100%;

  .largeScreenContent {
    width: 1920px;
    height: 1080px;
    transform-origin: 0% 0%;
    position: relative;
    background: url("https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen1/background.png") no-repeat 0 0;
    background-size: 100% 100%;

    //标题
    .screenTitle {
      position: absolute;
      top: 8px;
      width: 100%;
      font-family: Title;
      font-size: 37px;
      color: #0c4dcc;
      line-height: 48px;
      text-align: center;
    }

    //时间
    .timeBoxTemplateBigScreen1 {
      position: absolute;
      top: 24px;
      left: 21px;
      font-size: 16px;
      color: #48637e;
    }

    //操作
    .operatorBox {
      position: absolute;
      left: 20px;
      top: 51px;
      height: 28px;
      display: flex;

      img {
        width: 28px;
        height: 28px;
        cursor: pointer;
        margin-right: 10px;
      }
    }

    //天气
    .weatherBoxTemplateBigScreen1 {
      position: absolute;
      top: 32px;
      right: 38px;
      font-size: 16px;
      color: #48637e;
    }

    //左边数据展示
    .leftBoxTemplateBigScreen1 {
      width: 390px;
      height: 967px;
      position: absolute;
      top: 89px;
      left: 20px;

      .leftItem {
        width: 390px;
        height: 309px;
        margin-bottom: 20px;

        .itemTitle {
          width: 388px;
          height: 45px;
          margin-bottom: 10px;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }

          .itemTitleRight {
            position: absolute;
            top: 0;
            right: 20px;
            height: 45px;
            line-height: 45px;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
          }
        }

        .leftItemCont {
          width: 390px;
          height: 254px;
          background: linear-gradient(90deg, #e5f0ff 0%, rgba(255, 255, 255, 0.7) 100%);
          box-shadow: 4px 4px 6px 0px rgba(24, 54, 89, 0.12);
          border-radius: 0px 0px 30px 30px;
          border: 1px solid;
          border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
        }
      }

      .leftItem1 {
        .leftItemCont {
          .leftItemContTop {
            width: calc(100% - 12px);
            height: 164px;
            margin-left: 12px;

            .leftItemContTopItem {
              display: flex;
              align-items: center;
              margin-top: 10px;
              height: 48px;

              img {
                width: 48px;
                height: 48px;
              }

              .name {
                font-weight: 400;
                font-size: 14px;
                color: #455464;

                .remark {
                  font-size: 10px;
                }
              }

              .val {
                font-weight: bold;
                font-size: 34px;
                color: #333333;
                margin: 0 8px;
              }

              .unit {
                font-weight: 500;
                font-size: 14px;
                color: #455464;
              }
            }
          }

          .leftItemContBottom {
            width: calc(100% - 40px);
            height: 37px;
            margin-top: 16px;
            margin-left: 20px;
            display: flex;
            justify-content: space-between;

            .leftItemContBottomItem {
              .val {
                font-weight: 500;
                font-size: 24px;
                color: #333333;

                .unit {
                  font-size: 12px;
                }
              }

              .name {
                font-weight: 400;
                font-size: 12px;
                color: #455464;
                transform: translateY(-8px);
              }
            }
          }
        }
      }

      .leftItem2 {
        .leftItemCont {
          .leftItemContTop {
            width: calc(100% - 32px);
            height: 100px;
            margin-left: 16px;
            display: flex;
            flex-wrap: wrap;

            .leftItemContTopItem {
              margin-top: 10px;
              width: calc(50% - 24px);
              height: 40px;
              background: linear-gradient(90deg, #cce0fc 0%, rgba(255, 255, 255, 0.7) 100%);
              box-shadow: 4px 4px 6px 0px rgba(24, 54, 89, 0.12);
              border-radius: 6px;
              border: 1px solid;
              border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
              position: relative;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 6px;

              .name {
                font-weight: 400;
                font-size: 14px;
                color: #333333;
              }

              .val {
                font-weight: bold;
                font-size: 16px;
                color: #076fff;

                .unit {
                  font-size: 12px;
                }
              }
            }

            .leftItemContTopItem::before {
              content: "";
              display: inline-block;
              width: 2px;
              height: 32px;
              background: #076fff;
              position: absolute;
              top: 4px;
              left: 0;
            }

            .leftItemContTopItem:nth-child(even) {
              margin-left: 18px;
            }
          }

          .echartsBox {
            display: flex;
            justify-content: space-between;

            .labelBox {
              width: 195px;

              p {
                position: relative;
                padding-left: 14px;

                .name {
                  font-weight: 400;
                  font-size: 10px;
                  transform: scale(0.8);
                  color: #455464;
                }

                .val {
                  font-size: 10px;
                  font-weight: 500;
                }
              }

              p:nth-child(1) .val {
                color: #32cba0;
              }

              p:nth-child(2) .val {
                color: #0297f3;
              }

              p::before {
                content: "";
                display: inline-block;
                width: 5px;
                height: 5px;
                background: #11d19f;
                border-radius: 50%;
                position: absolute;
                top: 9px;
                left: 7px;
              }

              p:nth-child(2)::before {
                background: #0297f3;
              }
            }
          }
        }
      }

      .leftItem3 {
        margin-bottom: 0;

        .leftItemCont {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          align-content: space-around;

          .leftItemContItem {
            display: flex;
            //justify-content: center;
            align-items: center;
            width: 50%;

            img {
              width: 40px;
              height: 40px;
              margin-right: 8px;
              margin-left: 10px;
            }

            .leftItemContItemRight {
              .val {
                height: 36px;
                line-height: 36px;
                font-weight: bold;
                font-size: 24px;
                color: #333333;

                .unit {
                  font-size: 12px;
                }
              }

              .name {
                font-weight: 400;
                font-size: 12px;
                color: #728294;
              }
            }
          }
        }
      }
    }

    //中间数据展示
    .centerBoxTemplateBigScreen1 {
      //中上数据
      .centerTopBox {
        width: 1059px;
        height: 96px;
        position: absolute;
        left: 430px;
        top: 89px;
        display: flex;
        justify-content: space-between;

        .centerTopItem {
          padding: 12px;
          width: 313px;
          height: 72px;
          border-radius: 4px;

          .tit {
            display: flex;

            img {
              width: 20px;
              height: 20px;
              margin-right: 8px;
            }

            .name {
              font-weight: bold;
              font-size: 14px;
              color: #ffffff;
            }
          }

          .valBox {
            .val {
              letter-spacing: 2px;
              text-align: center;
              font-size: 30px;
              font-family: OPPOSans B;
              color: #ffffff;
            }
          }
        }

        .centerTopItem:nth-child(1) {
          background: linear-gradient(90deg, #4ecbf3 0%, #1099ed 100%);
          box-shadow: 4px 4px 6px 0px rgba(24, 74, 89, 0.12);
        }

        .centerTopItem:nth-child(2) {
          background: linear-gradient(90deg, #efbc4d 0%, #eb7e50 100%);
          box-shadow: 4px 4px 6px 0px rgba(89, 62, 24, 0.12);
        }

        .centerTopItem:nth-child(3) {
          background: linear-gradient(90deg, #629df4 0%, #5571f5 100%);
          box-shadow: 4px 4px 6px 0px rgba(24, 54, 89, 0.12);
        }
      }

      //中间数据
      .centerBox {
        .centerBigBox {
          width: 172px;
          height: 69px;
          background: rgba(12, 77, 204, 0.7);
          box-shadow: 4px 4px 6px 0px rgba(24, 54, 89, 0.12);
          border-radius: 6px;
          border: 1px solid;
          border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
          position: absolute;
          padding: 10px 14px;

          .tit {
            display: flex;
            align-items: center;

            img {
              width: 16px;
              height: 16px;
              margin-right: 5px;
            }

            .name {
              font-size: 16px;
              color: #ffffff;
              font-weight: bold;
            }
          }

          .centerBigBoxCont {
            p {
              font-weight: 400;
              font-size: 14px;
              color: #ffffff;
            }
          }

          .el-progress,
          .el-progress-circle,
          .el-progress .el-progress-circle svg {
            width: 48px;
            height: 48px;
          }

          .el-progress {
            .el-progress__text span {
              font-weight: bold;
              font-size: 14px;
              color: #20f7c3;
            }

            svg > path:nth-child(1) {
              stroke: rgba(32, 247, 195, 0.2); // #write 此处的id就是定义的svg标签id 做替换即可
            }
          }
        }

        .centerBox1-1 {
          left: 430px;
          top: 232px;
        }

        .centerBox2-1 {
          width: 265px;
          height: 91px;
          left: 436px;
          top: 560px;
        }

        .centerBox3-1 {
          left: 1008px;
          top: 589px;
          height: 47px;
        }

        .centerBox4-1 {
          left: 1290px;
          top: 558px;
        }

        .centerBox5-1 {
          left: 1290px;
          top: 212px;
          height: 47px;
        }

        .centerSmallBox {
          height: 24px;
          padding: 0 6px;
          background: #1455d3;
          border-radius: 3px;
          position: absolute;
          font-size: 14px;
          color: #fff;
          text-align: center;
          line-height: 24px;
        }

        .centerBox1-2 {
          left: 708px;
          top: 360px;
          transform: rotateZ(26deg);
        }

        .centerBox2-2 {
          left: 660px;
          top: 464px;
          transform: rotateZ(-10deg);
        }

        .centerBox2-3 {
          left: 668px;
          top: 504px;
          transform: rotateZ(-10deg);
        }

        .centerBox3-2 {
          left: 852px;
          top: 509px;
          transform: rotateZ(-61deg);
        }

        .centerBox3-3 {
          left: 896px;
          top: 535px;
          transform: rotateZ(-61deg);
        }

        .centerBox4-2 {
          left: 1117px;
          top: 463px;
          transform: rotateZ(9deg);
        }

        .centerBox5-2 {
          left: 1126px;
          top: 366px;
          transform: rotateZ(-26deg);
        }

        .centerProportionBox {
          width: 120px;
          height: 120px;
          text-align: center;
          position: absolute;
          top: 275px;
          left: 899px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .val {
            font-weight: 800;
            font-size: 48px;
            color: #fff400;
            height: 70px;
          }

          .name {
            font-weight: 400;
            font-size: 18px;
            color: #fff;
          }
        }
      }

      //中下数据
      .centerBottomBox {
        .centerBottomBox1 {
          width: 1060px;
          height: 102px;
          position: absolute;
          left: 430px;
          top: 719px;
          display: flex;
          justify-content: space-between;

          .centerBottomBoxItem {
            width: 215px;
            height: 82px;
            background: linear-gradient(90deg, #e5f0ff 0%, rgba(255, 255, 255, 0.7) 100%);
            box-shadow: 4px 4px 6px 0px rgba(24, 54, 89, 0.12);
            border-radius: 6px;
            border: 1px solid;
            border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
            padding: 12px 16px 8px;

            .tit {
              display: flex;
              align-items: center;

              img {
                width: 10px;
                height: 10px;
                margin-right: 8px;
              }

              .name {
                font-weight: bold;
                font-size: 16px;
                color: #333333;
              }
            }

            .centerBottomBoxItemCont {
              p {
                font-weight: 400;
                font-size: 14px;
                color: #333333;
              }
            }
          }

          .centerBottomBoxItem:nth-child(2) .centerBottomBoxItemCont p {
            line-height: 20px;
          }
        }

        .centerBottomBox2 {
          width: 1060px;
          height: 223px;
          position: absolute;
          left: 430px;
          top: 833px;

          .itemTitle {
            width: 100%;
            height: 45px;
            margin-bottom: 10px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .centerBottomBoxCont {
            width: 1060px;
            height: 168px;
            background: linear-gradient(90deg, #e5f0ff 0%, rgba(255, 255, 255, 0.7) 100%);
            box-shadow: 4px 4px 6px 0px rgba(24, 54, 89, 0.12);
            border-radius: 0px 0px 30px 30px;
            border: 1px solid;
            border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;

            .lineChartRef2 {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }

    //右边数据展示
    .rightBoxTemplateBigScreen1 {
      width: 390px;
      height: 967px;
      position: absolute;
      top: 89px;
      right: 20px;

      .rightItem {
        width: 390px;
        height: 309px;
        margin-bottom: 20px;

        .itemTitle {
          width: 388px;
          height: 45px;
          margin-bottom: 10px;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }

          .itemTitleRight {
            position: absolute;
            top: 0;
            right: 20px;
            height: 45px;
            line-height: 45px;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
          }
        }

        .rightItemCont {
          width: 390px;
          height: 254px;
          background: linear-gradient(90deg, #e5f0ff 0%, rgba(255, 255, 255, 0.7) 100%);
          box-shadow: 4px 4px 6px 0px rgba(24, 54, 89, 0.12);
          border-radius: 0px 0px 30px 30px;
          border: 1px solid;
          border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;

          .chartBox {
            width: 100%;
            height: 238px;
            margin-top: 16px;
          }
        }
      }

      .rightItem1 {
      }

      .rightItem2 {
      }

      .rightItem3 {
        margin-bottom: 0;

        .rightItemCont {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          align-content: space-around;

          .rightItemContItem {
            display: flex;
            //justify-content: center;
            align-items: center;
            width: 50%;

            img {
              width: 40px;
              height: 40px;
              margin-right: 8px;
              margin-left: 20px;
            }

            .rightItemContItemRight {
              .val {
                height: 36px;
                line-height: 36px;
                font-weight: bold;
                font-size: 36px;
                color: #333333;

                .unit {
                  font-size: 12px;
                }
              }

              .name {
                font-weight: 400;
                font-size: 12px;
                color: #728294;
              }
            }
          }
        }
      }
    }
  }

  //选择模块弹窗
  .selectSetDialog {
    .listBox {
      display: flex;
      flex-wrap: wrap;
      //justify-content: space-between;

      .listItem {
        width: 30%;
        margin-bottom: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #efefef;
        cursor: pointer;
        margin-right: calc(5% - 3px);

        img {
          width: 100%;
        }
      }

      .listItem:nth-child(3n) {
        margin-right: 0;
      }

      .listItemActive {
        box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.2);
      }
    }
  }

  //配置
  .setDialog1 {
    .el-form {
      display: flex;
      flex-wrap: wrap;

      .el-form-item {
        margin-right: 16px;

        .el-select {
          width: 167px;
        }
      }
    }

    .tit {
      font-size: 16px;
      font-weight: bold;
      margin: 20px 0 0;
    }

    .eleContBox {
      .contentItem {
        width: calc(100% - 60px);
        display: flex;
        flex-wrap: wrap;
        margin-top: 16px;
        background: #f6f8fc;
        border: 1px solid #ebedfd;
        padding: 10px;
        margin-left: 20px;

        .liItemBox {
          width: 160px;
          height: 100px;
          background: #ffffff;
          padding: 16px;
          margin: 10px 36px 10px 26px;

          .bgc {
            min-width: 160px;
            width: 140px;
            height: 100%;
            background: rgba(22, 93, 255, 0.05);
            box-shadow: inset 0px 0px 20px 0px rgba(22, 93, 255, 0.1);
            border-radius: 6px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
              width: 56px;
              height: 56px;
              margin-bottom: 8px;
            }

            > p:first-of-type {
              font-size: 16px;
            }

            > p:nth-of-type(2) {
              font-size: 12px;
              color: #409eff;
              cursor: pointer;
            }
          }
        }

        .el-radio-group {
          display: block;

          .el-radio {
            margin-right: 15px !important;
          }
        }

        > p,
        > div {
          display: flex;
          align-items: center;
          margin-right: 10px;
        }

        .contItemBox {
          align-items: center;
          margin: 10px 10px 10px 0;

          .symbol {
            margin-right: 10px;
            font-size: 20px;
            text-align: center;
            width: 16px;

            p {
              cursor: pointer;
              margin: 0;
            }

            .activeSymbol {
              color: #165dff;
              font-weight: bold;
            }
          }

          .symbol2 {
            margin-top: 50px;
          }
        }

        .addIcon,
        .delIcon {
          font-size: 17px;
          color: #000;
          cursor: pointer;
        }

        .addBox {
          width: 160px;
          height: 160px;
          border: 1px dashed #000;
          margin: 10px 0 0 10px;
          text-align: center;
          line-height: 160px;
          font-size: 40px;
          color: #000;
          cursor: pointer;
        }

        .contItem {
          display: flex;
          flex-direction: column;
          width: 160px;
          height: 100px;
          background: #ffffff;
          padding: 16px;
          position: relative;

          .delIcon {
            position: absolute;
            top: 8px;
            right: 6px;
            color: #5d5d5d;
            font-size: 18px;
            z-index: 1;
          }

          .el-select,
          .el-input {
            width: 160px;
            height: 30px;
            margin-right: 0;
          }

          .contTime .el-input {
            width: 110px;
            height: 30px;
          }

          .el-input__wrapper {
            height: 30px;
          }

          .contBox {
            position: relative;

            .el-select {
              margin-top: 20px;
            }

            .center {
              span {
                color: #666666;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                background: rgba(51, 51, 51, 0.1);
                border-radius: 3px;
                margin-top: 10px;
                display: inline-block;
                padding: 3px 8px;
              }

              //.val .el-input__wrapper {
              //  box-shadow: 0 0 0 0;
              //  background-color: #f6f6f6;
              //}
              .val {
                margin-top: 30px;

                .el-input__wrapper {
                  box-shadow: 0 0 0 0;
                }
              }

              .val .el-input__inner {
                font-size: 28px;
                color: #000;
              }

              .val .el-input__inner::placeholder {
                font-size: 12px;
                vertical-align: middle;
              }
            }

            .unit {
              text-align: right;
              position: absolute;
              top: 25px;
              right: 0;
            }
          }

          .contItem:hover .delIcon {
            display: block;
          }
        }

        .bagClass {
          .el-select__wrapper {
            width: 220px;
          }
        }
      }

      .timeSelect .el-select__wrapper {
        width: 500px;
      }
    }
  }
}
</style>
